{
  "app": {
    "language": "Taal",
    "openMenu": "Menu openen",
    "closeMenu": "Menu sluiten",
    "brandLogoAlt": "BCS HR Software",
    "footerAdmin": "BCS Learning — Admin",
    "footerTenant": "BCS Learning — {tenant}",
    "footerTenantFallback": "BCS Learning",
    "superadmin": {
      "title": "Superadmin"
    },
    "tenant": {
      "title": "Je werkomgeving"
    }
  },
  "nav": {
    "catalog": "Catalogus",
    "myEnrollments": "Mijn inschrijvingen",
    "myQuestionnaires": "Mijn vragenlijsten",
    "myQualifications": "Mijn kwalificaties",
    "dashboard": "Dashboard",
    "tenants": "Tenants",
    "platformAssets": "Mediabibliotheek",
    "platformLocales": "Talen",
    "superadmins": "Superadmins",
    "settings": "Instellingen",
    "users": "Gebruikers",
    "orgUnits": "Organisatie-units",
    "localeOverrides": "Teksten",
    "mailOutbox": "Mail-outbox",
    "sendMessage": "Stuur bericht",
    "mailTemplates": "Mail-teksten",
    "workflows": "Workflows",
    "platformWorkflows": "Platform-workflows",
    "approvals": "Goedkeuringen",
    "approvalsOverview": "Alle goedkeuringen",
    "badgePending": "{count} wachtend",
    "mainNavigation": "Hoofdnavigatie",
    "logout": "Uitloggen",
    "changeLanguage": "Taal wijzigen",
    "themeDark": "Donkere modus",
    "themeLight": "Lichte modus",
    "openAdminConsole": "Beheer openen",
    "openApp": "Naar de app",
    "cancellationReasons": "Annuleer-redenen",
    "questionnaires": "Vragenlijsten",
    "locations": "Trainingslocaties",
    "externalPeople": "Externe personen",
    "externalCompanies": "Externe bedrijven",
    "approvalFlows": "Goedkeuringsflows",
    "roles": "Rollen & rechten",
    "attendance": "Presentie",
    "auditLog": "Logboek",
    "accessGroups": "Toegangsgroepen",
    "ltiProviders": "LTI-koppelingen",
    "groupUsersOrg": "Gebruikers & organisatie",
    "groupCatalogs": "Catalogi",
    "groupLearning": "Leeraanbod",
    "groupMessaging": "E-mail & berichten",
    "tests": "Toetsen",
    "grading": "Nakijken",
    "results": "Resultaten",
    "qualifications": "Kwalificaties",
    "externalRequestTypes": "Externe opleiding (inrichting)",
    "themes": "Categorieën",
    "media": "Mediabibliotheek",
    "groupResources": "Middelen",
    "documentTemplates": "Documentsjablonen"
  },
  "myEnrollments": {
    "title": "Mijn inschrijvingen",
    "description": "Een overzicht van de activiteiten waarvoor je bent ingeschreven en de status ervan.",
    "empty": "Je hebt nog geen inschrijvingen.",
    "emptyCta": "Blader door de catalogus",
    "error": "We konden je inschrijvingen niet laden.",
    "retry": "Opnieuw proberen",
    "untitled": "Naamloze activiteit",
    "controlsLabel": "Sorteren en filteren",
    "sortLabel": "Sorteren",
    "sort": {
      "dateAsc": "Startdatum (oplopend)",
      "dateDesc": "Startdatum (aflopend)"
    },
    "filter": {
      "showHistory": "Toon historie"
    },
    "groupActive": "Actief",
    "groupHistory": "Historie",
    "noActive": "Je hebt geen actieve inschrijvingen.",
    "noHistory": "Je hebt nog geen afgeronde of geannuleerde inschrijvingen.",
    "partOf": "Onderdeel van {title}",
    "certificate": {
      "filename": "certificaat",
      "download": "Certificaat downloaden",
      "inProgress": "Certificaat wordt nog gemaakt",
      "downloadFailed": "Het certificaat kon niet gedownload worden. Probeer het later opnieuw.",
      "revoked": "Ingetrokken"
    }
  },
  "myLearningPath": {
    "notFound": "We konden deze leerlijn niet vinden.",
    "error": "We konden je leerlijn niet laden.",
    "retry": "Opnieuw proberen",
    "progressTitle": "Voortgang",
    "progress": "{done} van {total} verplichte onderdelen afgerond",
    "noRequired": "Deze leerlijn heeft geen verplichte onderdelen.",
    "sequentialHint": "Je doorloopt de onderdelen op volgorde. Een onderdeel gaat open zodra het vorige is afgerond.",
    "partsTitle": "Onderdelen",
    "noParts": "Deze leerlijn heeft nog geen onderdelen.",
    "reference": "Naslag",
    "completedOn": "Afgerond op {date}",
    "state": {
      "to_schedule": "Nog te plannen",
      "locked": "Op slot",
      "not_started": "Niet gestart",
      "in_progress": "Bezig",
      "completed": "Afgerond",
      "previously_completed": "Eerder behaald",
      "exempted": "Vrijgesteld",
      "not_passed": "Niet behaald",
      "expired": "Verlopen",
      "cancelled": "Geannuleerd"
    },
    "detail": {
      "completedOn": "Afgerond op {date}",
      "previouslyCompletedOn": "Afgerond op {date}, eerder behaald",
      "lockedBy": "Gaat open zodra je {title} hebt afgerond.",
      "toSchedule": "Voor dit onderdeel kies je een uitvoering met een datum. Dat kan hier binnenkort.",
      "notPassed": "Je hebt dit onderdeel afgerond, maar niet behaald.",
      "expired": "Je had dit onderdeel behaald, maar het is niet meer geldig."
    }
  },
  "catalog": {
    "structural": {
      "locked": {
        "enrollments": "Kan niet meer: er staan al inschrijvingen op deze training.",
        "attempts": "Kan niet meer: deze e-learning is al gestart.",
        "completions": "Kan niet meer: er staan al afrondingen op deze training."
      },
      "warnTitle": "Deze training is al gepubliceerd",
      "warnBody": "Je wijzigt iets dat bepaalt wat een inschrijving of afronding betekent. Er staan nog geen inschrijvingen op, dus het kan nog. Zodra iemand zich inschrijft, ligt dit vast.",
      "warnConfirm": "Toch opslaan",
      "field": {
        "composition": "De samenstelling",
        "type": "Het type",
        "source_kind": "De bron",
        "source_url": "De link",
        "source_package_id": "Het e-learningpakket",
        "source_lti_provider_id": "De LTI-leverancier",
        "tracking_mode": "Activiteit of naslag",
        "completion_rule": "De afrondingsregel",
        "completion_threshold": "Het percentage van de afrondingsregel",
        "sources": "Het materiaal in een andere taal",
        "items": "De onderdelen of welke verplicht zijn"
      }
    },
    "detail": {
      "back": "Terug naar catalogus",
      "backToMyEnrollments": "Terug naar mijn inschrijvingen",
      "duration": "Duur",
      "durationMinutes": "{count} min",
      "category": "Categorie",
      "contentManagers": "Beheerders",
      "occurrences": "Geplande uitvoeringen",
      "noOccurrences": "Er zijn nog geen geplande uitvoeringen.",
      "items": "Onderdelen",
      "noItems": "Er zijn nog geen onderdelen.",
      "notFound": "Activiteit niet gevonden",
      "ctaSoon": "Binnenkort beschikbaar",
      "studyLoad": "Studielast",
      "description": "Omschrijving",
      "details": "Details",
      "language": "Taal",
      "themes": "Categorieën",
      "tags": "Trefwoorden",
      "tracking": "Bijhouden",
      "trackingYes": "Ja — telt als te doen en gedaan",
      "trackingNo": "Nee — naslag",
      "planned_one": "{count} uitvoering gepland",
      "planned_other": "{count} uitvoeringen gepland",
      "spotsTotal_one": "{count} plek vrij",
      "spotsTotal_other": "{count} plekken vrij",
      "chooseBelow": "kies hieronder een uitvoering om je in te schrijven",
      "approvalHint": "Na inschrijving vraagt het systeem goedkeuring aan je leidinggevende; je ontvangt een bevestiging per mail.",
      "directHint": "Je ontvangt direct een bevestiging per mail.",
      "approval": "Goedkeuring",
      "approvalRequired": "Nodig",
      "approvalNotRequired": "Niet nodig",
      "spotsOf": "{left} van {total} plekken vrij",
      "fullWaitlist": "Vol — wachtlijst",
      "days_one": "{count} dag",
      "days_other": "{count} dagen",
      "dayN": "Dag {n}",
      "enrollUntil": "Inschrijven t/m {date}",
      "itemsOrdered": "Onderdelen (in volgorde)",
      "itemsOrderedHint": "Elk onderdeel gaat open zodra het vorige is afgerond.",
      "itemsFreeHint": "Geen vaste volgorde — doorloop de onderdelen zoals het jou uitkomt.",
      "openInLanguage": "In een andere taal openen",
      "ownLanguage": "Mijn eigen taal"
    },
    "error": {
      "title": "Er ging iets mis",
      "retry": "Opnieuw proberen"
    },
    "launch": {
      "start": "Starten",
      "resume": "Verdergaan",
      "review": "Opnieuw bekijken",
      "open": "Openen",
      "error": "Openen is niet gelukt.",
      "restart": "Start opnieuw",
      "restartTitle": "Opnieuw beginnen?",
      "restartBody": "Je begint deze training opnieuw vanaf het begin. Je voortgang in de training wordt gewist; je resultaat blijft staan."
    },
    "enroll": {
      "action": "Inschrijven",
      "full": "Vol",
      "closed": "Inschrijving gesloten",
      "success": "Je bent ingeschreven.",
      "requested": "Je aanvraag is ingediend. Je hoort het zodra er een besluit is.",
      "waitlisted": "Je staat op de wachtlijst. Je bent nog niet ingeschreven — je hoort het zodra er een plek vrijkomt.",
      "error": "Inschrijven is niet gelukt.",
      "elsewhere": "Je bent al ingeschreven op {date}",
      "waitlistedElsewhere": "Je staat al op de wachtlijst van {date}",
      "spotsLeft": "{count} plekken vrij",
      "awaitingApproval": "Wacht op goedkeuring",
      "joinWaitlist": "Inschrijven op wachtlijst",
      "onWaitlist": "Op wachtlijst",
      "offerPending": "Je hebt een plek — accepteer je aanbod",
      "offerAcceptBy": "Je hebt een plek — accepteer vóór {date}",
      "acceptOffer": "Accepteren",
      "declineOffer": "Afwijzen"
    },
    "cancel": {
      "button": "Annuleren",
      "requestButton": "Annulering aanvragen",
      "pending": "Annulering in behandeling",
      "confirmTitle": "Inschrijving annuleren?",
      "confirmBody": "Weet je zeker dat je je inschrijving wilt annuleren? Dit kan niet ongedaan worden gemaakt.",
      "reasonLabel": "Reden (optioneel)",
      "confirm": "Ja, annuleren",
      "keep": "Behouden",
      "cancelled": "Geannuleerd — reden: {reason}",
      "reasonSelectLabel": "Reden",
      "reasonSelectPlaceholder": "— Kies een reden —",
      "cancelledReason": "Reden: {reason}",
      "cancelledNote": "Geannuleerd — reden:"
    },
    "cancellationMode": {
      "self": "Zelf annuleren",
      "needs_approval": "Met goedkeuring",
      "not_allowed": "Niet toegestaan"
    },
    "waitlistPromotionMode": {
      "auto_enter": "Automatisch doorschuiven",
      "invite": "Plek aanbieden"
    },
    "enrollmentLimit": {
      "one": "1 (standaard)",
      "multiple": "Meerdere"
    },
    "deliveryMode": {
      "klassikaal": "Klassikaal",
      "virtual_classroom": "Virtual classroom",
      "blended": "Blended"
    },
    "enrollmentStatus": {
      "enrolled": "Ingeschreven",
      "pending": "In behandeling",
      "offered": "Plek aangeboden",
      "waitlisted": "Op wachtlijst",
      "rejected": "Afgewezen",
      "cancelled": "Geannuleerd",
      "expired": "Verlopen",
      "finalized": "Verwerkt"
    },
    "heading": "Catalogusbeheer",
    "intro": "Beheer alle leeractiviteiten.",
    "new": "Nieuwe activiteit",
    "settingsLink": "Instellingen",
    "empty": "Nog geen leeractiviteiten — maak er één aan.",
    "backToList": "Terug naar catalogus",
    "filter": {
      "search": "Zoeken op titel of samenvatting…",
      "status": "Status",
      "all": "Alle",
      "searchPlaceholder": "Zoek in de catalogus",
      "themes": "Categorie",
      "type": "Type",
      "composition": "Vorm",
      "tracking": "Soort",
      "category": "Categorie",
      "sort": "Sorteren",
      "reset": "Filters wissen",
      "activeLabel": "Actieve filters",
      "removeFilter": "Filter verwijderen: {filter}",
      "completionRule": "Afrondingsregel",
      "completionRuleMissing": "Regel ontbreekt",
      "heading": "Filters",
      "language": "Taal",
      "clear": "Wissen",
      "onlyWith": "Alleen met {name}"
    },
    "presentation": {
      "activiteit": "Activiteit",
      "naslag": "Naslag"
    },
    "type": {
      "e_learning": "E-learning",
      "assessment": "Toets",
      "meeting": "Bijeenkomst",
      "content": "Content/media",
      "social": "Sociaal",
      "workplace": "Werkplek",
      "external": "Externe opleiding"
    },
    "composition": {
      "single": "Activiteit",
      "learning_path": "Leerlijn",
      "bundle": "Bundel"
    },
    "source": {
      "manual": "Handmatig",
      "file": "Bestand",
      "link": "Link",
      "scorm_xapi": "E-learning-pakket (SCORM)",
      "lti": "LTI",
      "session": "Sessie / aanwezigheid"
    },
    "status": {
      "concept": "Concept",
      "published": "Gepubliceerd",
      "hidden": "Verborgen",
      "archived": "Gearchiveerd"
    },
    "unavailable": {
      "ltiProviderInactive": "Niet in het aanbod: koppeling uit"
    },
    "columns": {
      "title": "Titel",
      "composition": "Samenstelling",
      "type": "Type",
      "soort": "Soort",
      "status": "Status",
      "actions": "Acties",
      "completionRule": "Afronding",
      "themes": "Categorieën"
    },
    "actions": {
      "edit": "Bewerken",
      "changeStatus": "Status wijzigen…",
      "duplicate": "Dupliceren",
      "delete": "Verwijderen",
      "planning": "Planning",
      "export": "Exporteren ({count})"
    },
    "bulk": {
      "label": "Bulk-acties",
      "selected": "{count} geselecteerd",
      "selectAllMatching": "Selecteer alle {count} die aan dit filter voldoen",
      "allMatchingSelected": "Alle {count} die aan dit filter voldoen",
      "limitToSelection": "Beperk tot de aangevinkte rijen"
    },
    "confirm": {
      "archiveTitle": "Activiteit(en) archiveren?",
      "archiveBody": "Dit archiveert {count} activiteit(en); ze verdwijnen uit de catalogus maar blijven in records.",
      "deleteTitle": "Concept verwijderen?",
      "deleteBody": "\"{title}\" wordt definitief verwijderd. Dit kan niet ongedaan worden gemaakt.",
      "bulkTitle": "Status wijzigen?",
      "allMatchingBody": "Dit zet {count} activiteit(en) op \"{status}\" — ook de activiteiten die nu niet op het scherm staan."
    },
    "feedback": {
      "statusChanged": "{count} activiteit(en) → {status}.",
      "duplicated": "\"{title}\" is gedupliceerd als concept.",
      "deleted": "\"{title}\" is verwijderd.",
      "bulkDuplicated": "{count} kopie(ën) aangemaakt.",
      "archivedPartlyHidden": "{count} activiteit(en) verwerkt; {hidden} daarvan staan op Verborgen omdat er nog uitvoeringen liepen."
    },
    "fields": {
      "title": "Titel",
      "summary": "Samenvatting",
      "description": "Omschrijving",
      "category": "Categorie",
      "durationMinutes": "Duur (minuten)",
      "image": "Afbeelding",
      "imagePreviewAlt": "Voorbeeld van de gekozen afbeelding",
      "imageHelp": "Kies een afbeelding uit de mediabibliotheek, haal er een binnen via een adres of Pexels, of upload er een vanaf je computer. Zonder eigen afbeelding toont het item de standaardafbeelding van de omgeving.",
      "removeImage": "Afbeelding verwijderen",
      "sourceUrl": "Webadres",
      "sourceUrlHelp": "Waar de deelnemer terechtkomt.",
      "neededToPublish": "Nodig om te publiceren; een concept mag zonder.",
      "sourceFile": "Het bestand",
      "sourceFileHelp": "Het document dat de deelnemer opent. Alleen wie de training mag zien, kan het downloaden.",
      "sourceFileSaveFirst": "Sla deze training eerst op als concept; daarna kun je het bestand toevoegen. Publiceren gaat pas als er een bestand staat.",
      "ltiProvider": "LTI-leverancier",
      "ltiProviderHelp": "Bij welke leverancier deze training draait.",
      "ltiProviderNew": "Nieuwe leverancier toevoegen",
      "ltiLaunchUrl": "Adres van de cursus",
      "ltiLaunchUrlHelp": "Het adres van déze cursus bij de leverancier. Laat je het leeg, dan gebruiken we het standaard-adres van de leverancier — dat klopt alleen als die leverancier één cursus heeft. Publiceren gaat pas als er een van de twee is.",
      "ltiPickCourse": "Cursus kiezen bij de leverancier",
      "ltiPickCourseSaveFirst": "Je kunt de cursus bij de leverancier kiezen zodra deze training is opgeslagen. Je verlaat dit scherm om te kiezen, dus sla eerst op als concept — anders raak je kwijt wat je nu invult.",
      "ltiPickCourseConfirmTitle": "Er staan al resultaten op deze training",
      "ltiPickCourseConfirmBody_one": "Er is al {count} resultaat vastgelegd voor de cursus die er nu aan hangt. Dat blijft staan: wie de training heeft afgerond, houdt dat. Vanaf nu volgen nieuwe deelnemers de cursus die je zo kiest.",
      "ltiPickCourseConfirmBody_other": "Er zijn al {count} resultaten vastgelegd voor de cursus die er nu aan hangt. Die blijven staan: wie de training heeft afgerond, houdt dat. Vanaf nu volgen nieuwe deelnemers de cursus die je zo kiest.",
      "ltiPickCourseConfirmAction": "Cursus kiezen",
      "sourceFileReplaceConfirmTitle": "Er is al afgerond met het huidige bestand",
      "sourceFileReplaceConfirmBody_one": "{count} persoon heeft deze activiteit al afgerond met het vorige bestand; die afronding blijft staan. Wie de activiteit hierna opent, krijgt het nieuwe bestand.",
      "sourceFileReplaceConfirmBody_other": "{count} mensen hebben deze activiteit al afgerond met het vorige bestand; hun afronding blijft staan. Wie de activiteit hierna opent, krijgt het nieuwe bestand.",
      "sourceFileReplaceConfirmAction": "Bestand vervangen",
      "ltiProviderNoAccess": "Je mag de koppelingen van deze omgeving niet inzien. Vraag een beheerder om de leverancier te kiezen.",
      "ltiProviderInactive": "{name} (staat uit)",
      "package": "Het e-learning-bestand",
      "packageHint": "Eén zip-bestand, zoals je het van de leverancier krijgt. Nodig om te publiceren.",
      "packageHintWithMax": "Eén zip-bestand, zoals je het van de leverancier krijgt, tot {max} MB. Nodig om te publiceren.",
      "packageChoose": "Bestand kiezen",
      "packageReplace": "Ander bestand uploaden",
      "packageTry": "Uitproberen",
      "packageTryHint": "Opent de cursus in een nieuw tabblad, precies zoals een deelnemer hem ziet. Er wordt niets vastgelegd: geen voortgang, geen resultaat, geen afronding.",
      "packageTryBlocked": "Je browser hield het nieuwe tabblad tegen. Sta pop-ups voor deze pagina toe en probeer het opnieuw.",
      "packageTryFailed": "De cursus kon niet geopend worden. Probeer het opnieuw.",
      "packagePresent": "Er staat een bestand",
      "packageUploading": "Uploaden",
      "packageProgress": "Uploaden — {percent}%",
      "packageInspecting": "Het bestand wordt nagekeken…",
      "packageAccepted": "Eén training gevonden: {title}",
      "packageAcceptedUntitled": "Eén training gevonden. Het bestand noemt zelf geen titel.",
      "packageNotes": "Wat er aan dit bestand is aangepast of weggelaten:",
      "packageRejected": "Dit bestand kan zo niet gebruikt worden:",
      "packageNeedsChoice": "Er zit meer dan één e-learning in dit bestand:",
      "completionRule": "Wanneer is dit afgerond?",
      "completionRuleHint": "Er is met opzet geen standaard: vul zelf in wanneer deze training af is. Zolang er niets staat, rondt niemand hem af.",
      "completionRuleProgressUnavailable": "Afronden op het percentage dat iemand doorlopen heeft kan hier niet: dit bestand houdt niet bij hoever iemand is.",
      "completionRuleNone": "Nog niet gekozen",
      "completionRuleFixed": "Bij deze bron valt er niets te kiezen: afgerond betekent hier {rule}.",
      "completionThreshold": "Percentage",
      "completionThresholdHint": "Een getal tussen 1 en 100.",
      "progressResetDays": "Geldigheid van de afronding",
      "progressResetDaysHint": "Leeg = gaat eeuwig mee.",
      "progressResetDaysHelp": "Na hoeveel dagen een afronding vervalt en de deelnemer de training opnieuw moet doen. De teller start bij het afronden.",
      "choose": "Kies…",
      "summaryHint": "Hooguit drie regels, maximaal 200 tekens.",
      "summaryHelp": "Een korte tekst voor op de kaart en bovenaan het artikel.",
      "contentManagers": "Content-beheerders",
      "contentManagersPlaceholder": "Zoek een persoon",
      "contentManagersHint": "Mogen deze activiteit onderhouden: de basisgegevens en het bron/materiaal. De rol Content-beheerder verleent de rechten.",
      "contentManagerNoRole": "{name} heeft de rol Content-beheerder niet en kan deze activiteit dus niet bewerken.",
      "educators": "Opleider(s)",
      "educatorsPlaceholder": "Kies een opleider",
      "educatorsHint": "Bepaalt welke docenten je bij het plannen kunt kiezen. Leeg betekent geen beperking.",
      "educatorInternal": "Intern",
      "translationHint": "Laat je een tekst in deze taal leeg, dan ziet de lezer die in de taal van de omgeving.",
      "languageInUse_one": "{language} wordt nog gebruikt door 1 uitvoering ({dates}). Zonder titel valt deze taal weg, en dat kan pas als je daar eerst een andere taal kiest.",
      "languageInUse_other": "{language} wordt nog gebruikt door {count} uitvoeringen ({dates}). Zonder titel valt deze taal weg, en dat kan pas als je daar eerst een andere taal kiest."
    },
    "version": {
      "breaking": "De cursus is ingrijpend gewijzigd",
      "breakingHint": "Lopende deelnames worden afgesloten en beginnen opnieuw. Nodig wanneer onderdelen zijn verwijderd of herschikt — anders komt iemand terug op een plek die niet meer bestaat.",
      "closedAttempts": "Versie gewisseld. {count} lopende deelname(s) afgesloten; die personen beginnen opnieuw.",
      "compatibilityLegend": "Wat betekent deze versie voor lopende deelnames?",
      "compatible": "De cursus is grotendeels hetzelfde",
      "compatibleHint": "Wie halverwege is, gaat verder waar hij was. Kies dit alleen als de opbouw van de cursus niet is veranderd.",
      "heading": "Nieuwe versie",
      "intro": "Deze e-learning is al gepubliceerd met een pakket. Een nieuw bestand vervangt de versie voor iedereen, dus je geeft eerst aan wat de wijziging betekent voor wie nu bezig is.",
      "noAttemptsClosed": "Versie gewisseld. Er waren geen lopende deelnames.",
      "restartConfirm": "Opnieuw laten beginnen",
      "restartOpen": "Deelnames opnieuw laten beginnen",
      "restartReason": "Reden",
      "restartWarning": "Hiermee sluit je alle lopende deelnames op de huidige versie. Voortgang en bladwijzers gaan verloren; de afgeronde resultaten blijven staan.",
      "switch": "Versie wisselen",
      "viewResults": "Resultaten bekijken"
    },
    "elearningResults": {
      "actions": "Acties",
      "back": "Terug naar de activiteit",
      "correctError": "De correctie kon niet worden opgeslagen.",
      "correctFor": "Resultaat van {name} corrigeren",
      "correctedNote": "Gecorrigeerd op {date}",
      "effective": "Geldt nu",
      "empty": "Niemand is aan deze e-learning begonnen.",
      "failed": "Niet geslaagd",
      "heading": "Resultaten",
      "intro": "Wie is aan deze e-learning begonnen, hoe ver is iemand, en wat staat er als resultaat. Een handmatige correctie staat naast wat de cursus rapporteerde — beide blijven zichtbaar.",
      "lastActivity": "Laatst actief",
      "loadError": "De resultaten konden niet worden opgehaald.",
      "next": "Volgende",
      "pageOf": "Pagina {page} van {total}",
      "pagination": "Paginering",
      "passed": "Geslaagd",
      "person": "Persoon",
      "prev": "Vorige",
      "reason": "Reden",
      "reasonHint": "Komt in het logboek en is het antwoord op “waarom staat hier dit cijfer?”.",
      "reported": "Gerapporteerd",
      "resetConfirm": "Voortgang terugzetten",
      "resetError": "De voortgang kon niet worden teruggezet.",
      "resetFor": "Voortgang van {name} terugzetten",
      "resetKeepsCompletion": "De afronding van {name} blijft staan: die is in een andere taal behaald.",
      "resetLanguage": "Taal",
      "resetLanguageHint": "Alleen de voortgang in deze taal wordt teruggezet. Vooraf gekozen: de taal waarin {name} het laatst werkte.",
      "resetPreviewError": "Er kon niet worden opgehaald wat het terugzetten doet. Probeer het opnieuw.",
      "resetReason": "Reden",
      "resetReasonHint": "Komt in het logboek van {name} en is het antwoord dat hij of zij later kan krijgen.",
      "resetWarn": "De voortgang van {name} in deze e-learning wordt gesloten. De toegang blijft; {name} kan daarna opnieuw beginnen.",
      "resetWarnLanguage": "De voortgang van {name} in het {language} wordt gesloten; andere talen blijven staan. De toegang blijft; {name} kan daarna opnieuw beginnen.",
      "resetWarnLanguageWithCompletion": "{name} heeft deze e-learning in het {language} afgerond. Die afronding wordt ingetrokken — ze blijft terug te vinden als ingetrokken, maar telt vanaf nu niet meer mee. Andere talen blijven staan; de toegang blijft.",
      "resetWarnWithCompletion": "{name} heeft deze e-learning afgerond. Die afronding wordt ingetrokken — ze blijft terug te vinden als ingetrokken, maar telt vanaf nu niet meer mee. De toegang blijft; {name} kan daarna opnieuw beginnen.",
      "save": "Correctie opslaan",
      "scoreHint": "Leeg laten als je alleen de uitspraak wijzigt.",
      "scorePercent": "Score (%)",
      "scoreRange": "Vul een getal van 0 tot 100 in.",
      "status": "Status",
      "statuses": {
        "closed": "Afgesloten",
        "completed": "Afgerond",
        "in_progress": "Bezig"
      },
      "superseded": {
        "admin_reset": "Teruggezet door een beheerder",
        "breaking_version": "Afgesloten door een nieuwe, ingrijpend gewijzigde versie",
        "forced_restart": "Afgesloten door een gedwongen herstart",
        "learner_restart": "Opnieuw begonnen door de deelnemer zelf",
        "progress_reset": "Vervallen — de afronding was verlopen"
      },
      "unknownUser": "Onbekende gebruiker",
      "verdict": "Uitspraak",
      "verdictNone": "Geen uitspraak"
    },
    "wizard": {
      "newTitle": "Nieuwe leeractiviteit",
      "editTitle": "Leeractiviteit bewerken",
      "needType": "Kies een type.",
      "needTitle": "Titel is verplicht.",
      "needSummary": "Vul een samenvatting in.",
      "needDescription": "Vul een beschrijving in.",
      "occurrencesFollowTitle": "Ook de uitvoeringen met de oude titel hernoemen ({n})",
      "occurrencesFollowTitleHelp": "Uitvoeringen die nu \"{title}\" heten krijgen de nieuwe titel. Uitvoeringen met een eigen onderwerp blijven ongewijzigd.",
      "source": "Bron / materiaal",
      "sourceNone": "— geen —",
      "tracking": "Bijhouden",
      "ready": "Klaar om te publiceren.",
      "publish": "Publiceren",
      "saveConcept": "Opslaan als concept",
      "save": "Opslaan",
      "next": "Volgende",
      "published": "\"{title}\" is gepubliceerd.",
      "savedConcept": "\"{title}\" is opgeslagen als concept.",
      "publishAt": "Publiceren op (optioneel)",
      "publishAtHint": "Leeg: je publiceert zelf.",
      "publishAtHelp": "Met een moment blijft de activiteit een concept en wordt hij op dat moment vanzelf gepubliceerd, met dezelfde controles als nu publiceren.",
      "publishAtPast": "Kies een moment in de toekomst.",
      "schedule": "Inplannen",
      "scheduled": "“{title}” is ingepland: publicatie op {date}.",
      "grantsFailed": "“{title}” is aangemaakt, maar een of meer kwalificaties konden niet worden gekoppeld. Koppel ze hieronder opnieuw.",
      "saved": "\"{title}\" is opgeslagen.",
      "saveInvalid": "Opslaan lukte niet: een of meer velden kloppen niet. De stappen met een uitroepteken zeggen wat er mis is.",
      "statusInListHint": "Publiceren, verbergen en archiveren doe je in de lijst via \"Status wijzigen\".",
      "step": {
        "type": "Type",
        "bron": "Bron / materiaal",
        "resultaten": "Resultaten",
        "basis": "Basisgegevens",
        "details": "Details",
        "controle": "Controleren & publiceren",
        "compositie": "Samenstelling",
        "zichtbaarheid": "Zichtbaarheid",
        "inschrijven": "Inschrijven",
        "onderdelen": "Onderdelen"
      },
      "section": {
        "classificatie": "Indeling",
        "people": "Betrokkenen",
        "fields": "Kenmerken",
        "what": "Wat het is",
        "texts": "Teksten",
        "time": "Tijd",
        "material": "Materiaal",
        "completion": "Afronding",
        "anonymous": "Zonder inloggen",
        "enrolling": "Inschrijven",
        "waitlist": "Wachtlijst",
        "deadlines": "Deadlines en annuleren",
        "certificate": "Certificaat"
      },
      "finished": {
        "question": "Wil je nu inplannen, of terug naar de lijst?",
        "planNow": "Verder met plannen",
        "backToList": "Terug naar de lijst"
      },
      "sourceHint": "De bron bepaalt wat je kunt bijhouden; alleen bronnen die bij het type passen zijn kiesbaar.",
      "trackingHint": "Activiteit = te doen/gedaan (kan meetellen voor PE); Naslag = alleen bekijken.",
      "compositionHint": "Activiteit = losse leeractiviteit · Leerlijn = geordend (kan een certificaat ontgrendelen) · Bundel = ongeordende groep.",
      "needOnderdeel": "Een leerlijn/bundel heeft minimaal één onderdeel nodig.",
      "basicsOnlyNotice": "Je bent content-beheerder van deze activiteit: je wijzigt de basisgegevens en het bron/materiaal. Zichtbaarheid, inschrijven, resultaten en planning beheert iemand met beheerrechten voor de hele omgeving.",
      "required": {
        "heading": "Minimaal nodig om te publiceren",
        "legend": "Velden met * zijn verplicht.",
        "done": "(ingevuld)",
        "missing": "(ontbreekt nog)",
        "onePart": "Minstens één onderdeel"
      },
      "fieldShowToLearner": "Toon {name} aan de deelnemer"
    },
    "plannen": {
      "problem": {
        "needsDay": "Er is nog geen dag. Voeg minstens één dag toe.",
        "needsDate_one": "Dag {days} heeft nog geen datum. Vul bij elke dag een datum in.",
        "needsDate_other": "Dag {days} hebben nog geen datum. Vul bij elke dag een datum in.",
        "needsStartTime": "Dag 1 heeft nog geen begintijd. Vul bij de eerste dag een begintijd in."
      },
      "problemFor": "Uitvoering {n}: {problem}",
      "uitvoering": "Uitvoering {n}",
      "removeUitvoering": "Uitvoering verwijderen",
      "minParticipants": "Min. deelnemers",
      "maxParticipants": "Max. deelnemers",
      "minParticipantsHelp": "Onder dit aantal gaat de uitvoering in principe niet door. De planning waarschuwt als het minimum niet gehaald wordt; bevestigen of annuleren doe je zelf.",
      "maxParticipantsHelp": "Zoveel plekken zijn er. Is de uitvoering vol, dan komen nieuwe aanmeldingen op de wachtlijst, als die aan staat. Leeg = geen maximum.",
      "deadline": "Inschrijfdeadline",
      "deadlineHelp": "Tot en met deze dag kunnen deelnemers zich inschrijven. Hij wordt berekend uit de eerste dag; tik je zelf een datum in, dan blijft die staan.",
      "description": "Aanvullende omschrijving",
      "descriptionHint": "Hooguit 5000 tekens.",
      "descriptionHelp": "Extra informatie over deze uitvoering voor de deelnemer, zoals wat hij meeneemt of hoe hij de zaal vindt. Ze staat bij deze uitvoering in de catalogus; in een agenda-uitnodiging staat ze zonder opmaak.",
      "occurrenceTitle": "Titel van de uitvoering",
      "occurrenceTitleHint": "Laat leeg of gelijk aan de activiteit als er geen eigen onderwerp is.",
      "occurrenceTitleHelp": "Het onderwerp van deze sessie, als de activiteit een verzamelnaam is. De deelnemer ziet het onder de titel van de activiteit.",
      "day": "Dag {n}",
      "removeDay": "Dag verwijderen",
      "date": "Datum",
      "dateMissing": "Vul een datum in.",
      "startTimeMissing": "Vul een begintijd in.",
      "from": "Van",
      "to": "Tot",
      "location": "Trainingslocatie",
      "locationPlaceholder": "Kies of typ…",
      "locationEntity": "Trainingslocatie (uit lijst)",
      "locationNone": "Geen trainingslocatie",
      "locationCapacityWarning": "Max. deelnemers ({max}) is hoger dan de capaciteit van deze locatie ({capacity}). Kies een grotere locatie of verlaag het maximum.",
      "deliveryMode": "Leveringsvorm",
      "deliveryModeNone": "Geen keuze",
      "trainer": "Trainer",
      "trainerNone": "Geen trainer",
      "trainerExternalGroup": "Externe personen",
      "trainerInternalGroup": "Interne medewerkers",
      "lunch": "Lunch",
      "diner": "Diner",
      "overnight": "Overnachting",
      "addDay": "+ Dag toevoegen",
      "maxEnrollments": "Aantal inschrijvingen",
      "maxEnrollmentsHint": "Hoeveel keer iemand tegelijk actief ingeschreven mag staan voor deze activiteit (over alle uitvoeringen heen).",
      "maxWaitlistRegistrations": "Aantal wachtlijst-registraties",
      "maxWaitlistRegistrationsHint": "Hoeveel wachtlijst-plekken iemand tegelijk mag bezetten voor deze activiteit. Bij een plek van de wachtlijst afgehandeld, komt de wachtlijst-plek weer vrij.",
      "waitlistEnabled": "Wachtlijst",
      "waitlistEnabledHint": "Als een uitvoering vol is, kunnen lerenden zich op de wachtlijst zetten. Komt er een plek vrij, dan wordt die volgens de gekozen methode toegewezen. Volg de omgeving: de standaard uit de catalogus-instellingen geldt, ook als die later verandert.",
      "waitlistFollowDefaultOn": "Volg de omgeving (nu aan)",
      "waitlistFollowDefaultOff": "Volg de omgeving (nu uit)",
      "promotionMode": "Toewijzing bij vrije plek",
      "offerWindowHours": "Acceptatie-venster (uren)",
      "offerWindowHoursHint": "Hoeveel uur een aangeboden plek gereserveerd blijft voordat het aanbod vervalt. Leeg laten = systeemstandaard (48 uur).",
      "offerWindowHoursPlaceholder": "48",
      "waitlistCap": "Wachtlijst-plafond",
      "waitlistCapHint": "Maximaal aantal wachtenden per uitvoering. Leeg laten = ongelimiteerd.",
      "waitlistCapPlaceholder": "Ongelimiteerd",
      "waitlistCapUnlimited": "Ongelimiteerd",
      "occurrenceWaitlist": "Wachtlijst (deze uitvoering)",
      "occurrenceWaitlistHelp": "Volg activiteit: de wachtlijst-instelling van de activiteit geldt. Aan of Uit wijkt alleen voor deze uitvoering af.",
      "occurrenceWaitlistInherit": "Volg activiteit",
      "occurrenceWaitlistOn": "Aan",
      "occurrenceWaitlistOff": "Uit",
      "manageWaitlist": "Wachtlijst beheren",
      "cancellationDeadline": "Annuleringsdeadline",
      "cancellationDeadlineHelp": "Tot en met deze dag kunnen deelnemers zelf annuleren. Hij wordt berekend uit de eerste dag; tik je zelf een datum in, dan blijft die staan.",
      "enrollmentDeadlineDays": "Inschrijven kan tot (dagen vóór de eerste dag)",
      "deadlineDaysHint": "Leeg = de standaard van de omgeving. 0 = tot de eerste dag zelf.",
      "deadlineDaysHelp": "Het aantal kalenderdagen vóór de eerste dag. De datum per uitvoering rekent de server hiervan uit; per uitvoering kun je hem overschrijven.",
      "deadlineCalculated": "Berekend uit de eerste dag",
      "deadlineOverridden": "Zelf ingesteld",
      "deadlineNone": "Geen deadline",
      "deadlineBackToCalculated": "Terug naar berekend",
      "noDate": "Geen datum",
      "expandDay": "Bewerken",
      "collapseDay": "Inklappen",
      "deadlineDaysBefore_one": "{count} dag vóór de eerste dag",
      "deadlineDaysBefore_other": "{count} dagen vóór de eerste dag",
      "deadlineSameDay": "Tot de eerste dag zelf",
      "deadlineInherited": "{days} (standaard van de omgeving)",
      "cancellationApprovalFlow": "Goedkeuringsflow voor annuleren",
      "cancellationApprovalFlowHelp": "Wie een annuleringsverzoek beslist, als de annuleringsvoorwaarden goedkeuring vragen. Goedgekeurd is geannuleerd; afgewezen blijft de deelnemer ingeschreven.",
      "opleider": "Opleider",
      "opleiderHelp": "Een opleider beperkt de lijst met docenten tot de docenten van dat bedrijf. Het is alleen een filter; het wordt niet opgeslagen.",
      "opleiderNone": "— Geen / eigen docent —",
      "capacity": "Capaciteit",
      "enrolledBadge": "Heeft inschrijvingen",
      "enrolledReadOnly": "Deze uitvoering heeft inschrijvingen en is hier alleen-lezen. Wijzig datum, trainer, trainingslocatie of deelnemers op de planning-pagina.",
      "managePlanningLink": "Beheer op de planning-pagina",
      "approvalFlow": "Goedkeuring",
      "approvalFlowNone": "Geen goedkeuring — direct inschrijven",
      "approvalFlowHint": "Kies een goedkeuringsflow, of laat het op geen goedkeuring staan. Wachtlijst, capaciteit en inschrijfvenster blijven onverkort gelden.",
      "cancellationPolicy": "Annuleringsvoorwaarden",
      "cancellationPolicyHelp": "Tot wanneer en onder welke voorwaarden een deelnemer annuleert. Je kiest een set uit de instellingen; een uitvoering kan een andere kiezen.",
      "cancellationPolicyDefault": "{name} (standaard)",
      "cancellationApprovalFlowNone": "Geen flow",
      "occurrenceCancellationPolicy": "Annuleringsvoorwaarden",
      "occurrenceCancellationPolicyHelp": "Een andere set dan die van de activiteit, voor alleen deze uitvoering. De annuleerdeadline volgt dan de termijn van die set.",
      "occurrenceCancellationPolicyInherit": "Zoals de activiteit ({name})",
      "occurrenceCancellationPolicyInheritPlain": "Zoals de activiteit"
    },
    "inschrijven": {
      "intro": "Dit zijn de standaardinstellingen voor het inschrijven op deze activiteit. De uitvoeringen zelf plan je daarna op de planningspagina, en elke uitvoering kan hiervan afwijken."
    },
    "waitlist": {
      "heading": "Wachtlijst",
      "intro": "De volgorde bepaalt wie als eerste een vrijgekomen plek krijgt. Gebruik de knoppen om wachtenden te herordenen.",
      "back": "Terug naar de uitvoeringen",
      "empty": "Er staat niemand op de wachtlijst voor deze uitvoering.",
      "loadError": "De wachtlijst kon niet worden geladen. Probeer het opnieuw.",
      "moveError": "De volgorde kon niet worden aangepast. Probeer het opnieuw.",
      "unknownUser": "Onbekende gebruiker",
      "joinedAt": "Aangemeld op {date}",
      "toTop": "Naar boven",
      "moveUp": "{name} één plek omhoog",
      "moveDown": "{name} één plek omlaag",
      "moveTop": "{name} naar boven"
    },
    "panel": {
      "title": "Wat je bouwt"
    },
    "classificatie": {
      "themes": "Categorieën",
      "noThemes": "Nog geen categorieën beheerd — voeg ze later toe in het categoriebeheer.",
      "themesPlaceholder": "Zoek en kies categorieën",
      "tags": "Trefwoorden",
      "tagPlaceholder": "Typ een trefwoord…",
      "addTag": "Nieuw trefwoord: “{tag}”",
      "duration": "Duur",
      "language": "Taal",
      "choose": "— kies —",
      "formCategory": "Leervorm",
      "formCategoryHelp": "Een label voor de lerende, gekozen uit de lijst van deze omgeving. Voorgevuld op basis van het type.",
      "formCategoryOption": {
        "formal_digital": "Formeel – digitaal",
        "formal_classroom": "Formeel – klassikaal",
        "formal_supporting": "Formeel – ondersteunend",
        "social_learning": "Sociaal leren",
        "workplace_experience": "Werkplek & ervaring",
        "self_directed": "Zelfgestuurd leren"
      },
      "languagePerOccurrence": "De taal kies je per uitvoering, op de planning. De activiteit is er dan in de talen van haar uitvoeringen."
    },
    "duration": {
      "kort": "Kort (< 30 min)",
      "uur": "Ongeveer een uur",
      "dagdeel": "Dagdeel",
      "meerdaags": "Meerdaags"
    },
    "language": {
      "nl": "Nederlands",
      "en": "Engels",
      "de": "Duits",
      "fr": "Frans"
    },
    "visibility": {
      "everyone": "Iedereen",
      "lead": "Wie mag deze leeractiviteit zien?",
      "ruleset": "Een opgeslagen toegangsgroep",
      "closedUntilGroup": "Let op: zolang hier geen toegangsgroep aan hangt, ziet niemand deze leeractiviteit — behalve wie hem mag bewerken. Kies \"Iedereen\" als je hem juist open wilt zetten.",
      "chooseGroup": "Toegangsgroep",
      "noGroupChosen": "Nog geen groep gekozen",
      "groupOption": "{name} ({count} personen)",
      "noGroupsYet": "Er zijn nog geen toegangsgroepen. Maak er een aan bij Toegangsgroepen — daar stel je in wie erbij hoort, en die groep kun je hier en op andere plekken kiezen."
    },
    "onderdelen": {
      "pathLead": "Stel de geordende onderdelen samen (volgorde bepaalt ontgrendeling).",
      "bundleLead": "Groepeer de onderdelen (ongeordend).",
      "sequentieel": "Verplichte volgorde (strikt sequentieel)",
      "required": "Verplicht (telt voor ontgrendeling)",
      "remove": "verwijderen",
      "empty": "Nog geen onderdelen.",
      "addExisting": "+ Bestaande activiteit toevoegen…",
      "searchLabel": "Zoek een activiteit om als onderdeel toe te voegen",
      "moveUp": "Omhoog",
      "moveDown": "Omlaag"
    },
    "title": "Catalogus",
    "description": "Doorzoek en filter alle leeractiviteiten en open er één om je in te schrijven.",
    "results_one": "{count} activiteit",
    "results_other": "{count} activiteiten",
    "loadMore": "Meer laden",
    "sort": {
      "newest": "Nieuwste eerst",
      "title_asc": "Titel A–Z",
      "title_desc": "Titel Z–A"
    },
    "emptyState": {
      "title": "Niets gevonden",
      "body": "Pas je filters of zoekopdracht aan.",
      "reset": "Filters wissen"
    },
    "occurrenceStatus": {
      "concept": "Concept",
      "planned": "Gepland",
      "confirmed": "Bevestigd",
      "completed": "Afgelopen",
      "cancelled": "Geannuleerd"
    },
    "planning": {
      "heading": "Planning",
      "intro": "Beheer de uitvoeringen van deze leeractiviteit.",
      "backToWizard": "Terug naar de activiteit",
      "openLink": "Planning openen",
      "loadError": "De planning kon niet worden geladen. Probeer het opnieuw.",
      "drift": {
        "title": "Deadlines wijken af van het aantal dagen",
        "body": "Bij {n} uitvoering(en) klopt de berekende deadline niet meer met het aantal dagen van de activiteit of de omgeving.",
        "withEnrolments": "Bij {n} daarvan staan al mensen ingeschreven; die blijven staan tenzij je ze uitdrukkelijk meeneemt.",
        "recalculate": "Herbereken (zonder inschrijvingen)",
        "recalculateAll": "Herbereken ook met inschrijvingen"
      },
      "statusError": "De status kon niet worden gewijzigd. Probeer het opnieuw.",
      "empty": "Deze activiteit heeft nog geen uitvoeringen.",
      "filterStatus": "Status",
      "statsLabel": "Statistieken",
      "stats": {
        "completed": "Keer gedraaid",
        "totalEnrolled": "Ingeschreven totaal",
        "concept": "Concept",
        "planned": "Gepland",
        "confirmed": "Bevestigd",
        "cancelled": "Geannuleerd"
      },
      "columns": {
        "title": "Onderwerp",
        "datetime": "Datum & tijd",
        "trainer": "Trainer",
        "location": "Trainingslocatie",
        "bezetting": "Bezetting",
        "status": "Status",
        "deadline": "Inschrijfdeadline",
        "actions": "Acties"
      },
      "transition": {
        "planned": "Openzetten",
        "confirmed": "Bevestigen",
        "completed": "Afronden",
        "cancelled": "Annuleren"
      },
      "detailLink": "Deelnemers",
      "confirmCancelTitle": "Uitvoering annuleren",
      "confirmCancelBody": "Weet je zeker dat je deze uitvoering wilt annuleren? Alle deelnemers én iedereen op de wachtlijst worden geannuleerd en krijgen hiervan automatisch bericht. Dit kan niet ongedaan worden gemaakt.",
      "confirmCancelConfirm": "Uitvoering annuleren",
      "confirmCancelKeep": "Niet annuleren",
      "cancelReasonLabel": "Reden (optioneel)",
      "addOccurrence": "Uitvoering bijplannen",
      "editRow": "Bewerken",
      "belowMinimum": "Minimum niet gehaald",
      "belowMinimumHint": "Er zijn minder inschrijvingen dan het minimum van {min}. Je kunt de uitvoering bevestigen (toch doorgaan), annuleren, of de datum verplaatsen.",
      "editor": {
        "addTitle": "Uitvoering bijplannen",
        "editTitle": "Uitvoering herplannen",
        "intro": "Vul de gegevens van de uitvoering in. Bestaande inschrijvingen blijven behouden.",
        "loadError": "De uitvoeringen konden niet worden geladen. Probeer het opnieuw.",
        "saveError": "De uitvoering kon niet worden opgeslagen. Probeer het opnieuw.",
        "backToPlanning": "← Terug naar planning",
        "sectionBasis": "Basis",
        "sectionCapacity": "Capaciteit en inschrijven",
        "sectionDays": "Dagen",
        "summary": "Samenvatting",
        "summaryFirstDay": "Eerste dag",
        "summaryDays": "Aantal dagen",
        "summaryCapacity": "Deelnemers",
        "notFound": "Deze uitvoering bestaat niet meer.",
        "conceptNotice": "Deze uitvoering is nog een concept: deelnemers zien haar niet en kunnen zich niet inschrijven. Loop de dagen na en zet haar daarna open.",
        "saveAndOpen": "Opslaan en openzetten",
        "openError": "De uitvoering is opgeslagen, maar kon niet worden opengezet. Zet haar open in de planning.",
        "sectionLanguage": "Taal",
        "language": "Taal van deze uitvoering",
        "languageHint": "Kies uit de talen waarin de activiteit haar teksten heeft.",
        "languageHelp": "De activiteit staat in de catalogus in de talen van haar uitvoeringen.",
        "sectionFields": "Kenmerken",
        "fieldsHint": "Vul alleen in wat bij deze uitvoering anders is. Leeg betekent: zoals bij de activiteit.",
        "fieldFromActivity": "Bij de activiteit: {value}",
        "fieldInherit": "Zoals de activiteit",
        "sectionCertificate": "Certificaat"
      },
      "duplicateRow": "Dupliceren",
      "bulkEdit": "Alles bewerken",
      "duplicate": {
        "title": "Uitvoering dupliceren",
        "intro": "De kopie neemt de dagen, tijden, locaties, docenten en instellingen over en schuift mee met de nieuwe startdatum. Deelnemers gaan nooit mee.",
        "opensNow": "De kopie staat meteen open voor inschrijving.",
        "startsAsConcept": "Het origineel heeft {days} dagen. De kopie begint daarom als concept: deelnemers zien haar nog niet. Loop de andere dagen na en zet haar daarna open in de planning.",
        "currentStart": "Eerste dag van het origineel: {date}",
        "startDate": "Nieuwe startdatum",
        "startDateHelp": "Alle dagen behouden dezelfde onderlinge afstand.",
        "confirm": "Dupliceren",
        "error": "De uitvoering kon niet worden gedupliceerd. Probeer het opnieuw."
      },
      "bulk": {
        "title": "Uitvoeringen in bulk bewerken",
        "intro": "Alle uitvoeringen van deze activiteit in één tabel. Wijzig wat nodig is en sla alles in één keer op.",
        "backToPlanning": "← Terug naar planning",
        "loadError": "De uitvoeringen konden niet worden geladen. Probeer het opnieuw.",
        "empty": "Deze activiteit heeft nog geen uitvoeringen om te bewerken.",
        "saveError": "De wijzigingen konden niet worden opgeslagen. Er is niets aangepast.",
        "saved": "De wijzigingen zijn opgeslagen.",
        "dirty": "Er zijn wijzigingen die nog niet zijn opgeslagen.",
        "tableLabel": "Uitvoeringen en hun dagen",
        "col": {
          "select": "Selecteren",
          "day": "Dag"
        },
        "field": "{field} ({row})",
        "rowLabel": "{occurrence}, dag {day}",
        "selectRow": "Selecteer {row}",
        "selectOccurrence": "Selecteer {occurrence} met al haar dagen",
        "collapse": "Klap {occurrence} in",
        "expand": "Klap {occurrence} uit",
        "lockedEnrollments": "Heeft inschrijvingen: dagen, tijden en locaties staan vast. Herplannen kan op de pagina van de uitvoering.",
        "lockedFinished": "Afgesloten of geannuleerd: niet meer te bewerken.",
        "trainers": "Docent(en): {names}",
        "collision": "Zelfde datum en begintijd als een andere uitvoering van deze activiteit.",
        "collisionSummary": "Voor {count} dagen geldt: dezelfde datum en begintijd als een andere uitvoering van deze activiteit. Dat mag, maar controleer of het de bedoeling is.",
        "saveCollisionTitle": "Dezelfde datum en begintijd",
        "saveCollisionBody": "Er zijn dagen ({count}) met dezelfde datum en begintijd als een andere uitvoering van deze activiteit. Wil je toch opslaan?",
        "saveCollisionConfirm": "Toch opslaan",
        "saveCollisionBack": "Terug naar de tabel",
        "apply": {
          "title": "Toepassen op geselecteerde rijen",
          "selected": "Geselecteerd: {days} dagen, {occurrences} uitvoeringen",
          "location": "Trainingslocatie voor de geselecteerde dagen",
          "locationPlaceholder": "Kies een locatie",
          "locationButton": "Locatie toepassen",
          "trainers": "Docent(en) voor de geselecteerde uitvoeringen",
          "trainersHelp": "Vervangt de docenten van de geselecteerde uitvoeringen.",
          "trainersButton": "Docent(en) toepassen",
          "nothingSelected": "Selecteer eerst rijen in de tabel.",
          "done": "Toegepast op {count} rijen. Nog niet opgeslagen."
        }
      },
      "cancelReasonHint": "De deelnemers lezen deze reden bij hun inschrijving en in de annuleringsmail. Vet, cursief, lijsten en links kunnen; hooguit 1000 tekens.",
      "cancelledOn": "Geannuleerd op {date}",
      "conceptHint": "Niet zichtbaar voor deelnemers"
    },
    "occurrenceDetail": {
      "heading": "Uitvoering-detail",
      "intro": "Beheer de deelnemers en de wachtlijst van deze uitvoering.",
      "backToPlanning": "← Terug naar planning",
      "metaLabel": "Uitvoering-gegevens",
      "meta": {
        "title": "Onderwerp",
        "datetime": "Datum & tijd",
        "trainer": "Trainer",
        "location": "Trainingslocatie",
        "capacity": "Capaciteit (min–max)",
        "deadline": "Inschrijfdeadline",
        "status": "Status",
        "bezetting": "Bezetting"
      },
      "participantsHeading": "Deelnemers",
      "participantsEmpty": "Er zijn nog geen deelnemers ingeschreven voor deze uitvoering.",
      "columns": {
        "name": "Naam",
        "department": "Afdeling",
        "status": "Status",
        "actions": "Acties",
        "enrolledBy": "Ingeschreven door"
      },
      "unknownUser": "Onbekende gebruiker",
      "cancelAction": "Annuleren",
      "transfer": {
        "action": "Verplaatsen",
        "title": "Deelnemer verplaatsen",
        "body": "{name} verplaatsen naar een andere uitvoering van deze leeractiviteit.",
        "targetLabel": "Nieuwe uitvoering",
        "targetPlaceholder": "Kies een uitvoering",
        "hint": "De plek op de huidige uitvoering komt vrij en gaat naar de eerste wachtende. Zit de nieuwe uitvoering vol, dan komt de deelnemer daar op de wachtlijst.",
        "willWaitlist": "vol, wordt wachtlijst",
        "noDate": "zonder datum",
        "noTargets": "Deze leeractiviteit heeft geen andere geplande of bevestigde uitvoering om naartoe te verplaatsen.",
        "confirm": "Verplaatsen",
        "error": "De deelnemer kon niet worden verplaatst. Probeer het opnieuw."
      },
      "cancelError": "De inschrijving kon niet worden geannuleerd. Probeer het opnieuw.",
      "confirmCancelTitle": "Inschrijving annuleren",
      "confirmCancelBody": "Weet je zeker dat je de inschrijving van {name} wilt annuleren? De plek komt vrij en de wachtlijst schuift automatisch door.",
      "confirmCancelConfirm": "Inschrijving annuleren",
      "completion": {
        "heading": "Certificaat & evaluatie",
        "soon": "Een certificaat uitgeven en de uitvoering laten evalueren komt binnenkort beschikbaar."
      },
      "loadError": "De uitvoering kon niet worden geladen. Probeer het opnieuw.",
      "onBehalf": {
        "action": "Deelnemers inschrijven",
        "title": "Deelnemers inschrijven",
        "body": "Kies wie je wilt inschrijven. Je ziet eerst per persoon wat er gebeurt; pas daarna schrijf je in.",
        "peopleLabel": "Personen",
        "peoplePlaceholder": "Zoek op naam of e-mail",
        "check": "Controleren",
        "back": "Terug",
        "confirm": "Inschrijven",
        "close": "Sluiten",
        "previewHeading": "Wat er gaat gebeuren",
        "doneHeading": "Wat er gebeurd is",
        "nothingToDo": "Niemand van deze personen kan nu worden ingeschreven.",
        "error": "Het inschrijven is niet gelukt. Probeer het opnieuw.",
        "overridesHeading": "Toch doorgaan?",
        "overridesIntro": "Voor een of meer personen staat een regel in de weg. Je kunt die opzij zetten; dat wordt bij de inschrijving vastgelegd, met jouw naam.",
        "adminOnly": "Alleen een beheerder kan deze regel opzij zetten.",
        "applied": "Opzij gezet: {gates}",
        "unknownPerson": "Onbekende persoon",
        "override": {
          "capacity": "Inschrijven boven het maximum aantal deelnemers",
          "deadline": "Inschrijven na de inschrijfdeadline",
          "approval": "Inschrijven zonder goedkeuring"
        },
        "gate": {
          "capacity": "maximum",
          "deadline": "inschrijfdeadline",
          "approval": "goedkeuring"
        },
        "preview": {
          "enrolled": "Wordt ingeschreven",
          "pending": "Wacht daarna op goedkeuring",
          "waitlisted": "Komt op de wachtlijst",
          "blocked": "Kan niet worden ingeschreven",
          "not_found": "Niet gevonden of buiten je bereik"
        },
        "done": {
          "enrolled": "Ingeschreven",
          "pending": "Wacht op goedkeuring",
          "waitlisted": "Op de wachtlijst",
          "blocked": "Niet ingeschreven",
          "not_found": "Niet gevonden of buiten je bereik"
        },
        "reason": {
          "deadline_passed": "De inschrijfdeadline is verstreken.",
          "full": "De uitvoering is vol en heeft geen wachtlijst.",
          "waitlist_full": "De uitvoering en de wachtlijst zijn vol.",
          "already_enrolled_here": "Staat al op deze uitvoering.",
          "already_enrolled_elsewhere": "Staat al ingeschreven voor een andere uitvoering van deze leeractiviteit.",
          "not_visible": "Deze leeractiviteit is niet voor deze persoon bedoeld.",
          "suspended": "Het account van deze persoon is geblokkeerd."
        }
      },
      "cancelCosts": {
        "before": "Vóór de annuleerdeadline kost annuleren {amount}.",
        "after": "Na de annuleerdeadline kost annuleren {amount}.",
        "charge": "Kosten in rekening brengen",
        "waiverReason": "Reden van kwijtschelden",
        "waiverReasonRequired": "Geef een reden op waarom de kosten worden kwijtgescholden.",
        "managerHint": "Alleen een beheerder met rechten op de hele omgeving kan de kosten kwijtschelden."
      }
    },
    "archiveLive": {
      "title": "Archiveren: er staan nog uitvoeringen gepland",
      "body": "{activities} activiteit(en) uit deze selectie hebben {occurrences} uitvoering(en) die nog moeten plaatsvinden, met {enrollments} actieve inschrijving(en). De eerste is op {date}. Kies wat daarmee moet gebeuren.",
      "choose": "Wat gebeurt er met de lopende uitvoeringen?",
      "keep_running": "Niet meer aanbieden, wel afmaken",
      "keep_runningHint": "Deze activiteiten worden Verborgen in plaats van Gearchiveerd: ze verdwijnen uit de catalogus, maar wie is ingeschreven maakt de uitvoering af. Er verandert niets aan de inschrijvingen.",
      "cancel_enrollments": "Iedereen uitschrijven en archiveren",
      "cancel_enrollmentsHint": "De uitvoeringen worden geannuleerd en alle deelnemers en wachtlijst-registraties worden ingetrokken. Iedereen krijgt hierover bericht. Dit kan niet ongedaan worden gemaakt.",
      "confirmKeep": "Verbergen",
      "confirmCancel": "Uitschrijven en archiveren"
    },
    "anonymous": {
      "label": "Zonder inloggen te openen",
      "help": "Iedereen met de link kan de cursus doen, ook zonder account. Bedoeld om te laten zien wat een cursus is — niet om iemand af te laten ronden.",
      "warning": "Let op: van een cursus die zonder inloggen wordt gestart, bewaren we geen voortgang en geen resultaat — er is geen deelnemer om het aan te hangen. En de doelgroep hierboven geldt niet voor deze link: wie hem heeft, komt binnen.",
      "linkLabel": "Link om te delen"
    },
    "completionRule": {
      "completed": "De cursus meldt zelf dat hij voltooid is",
      "progress_percentage": "Een deel van de inhoud doorlopen",
      "minimum_score": "Een minimale score halen",
      "opened": "Geopend is afgerond",
      "attendance": "Aanwezig volgens de presentielijst",
      "declaration": "Iemand verklaart dat het gedaan is"
    },
    "completionRuleBulk": {
      "action": "Afrondingsregel zetten",
      "title": "Afrondingsregel zetten",
      "scopeSelection": "Voor de {count} geselecteerde trainingen.",
      "scopeAll": "Voor alle {count} trainingen die aan het filter voldoen.",
      "choose": "Wat wil je zetten?",
      "determined": "Vul in wat vaststaat",
      "determinedHint": "Bij een bijeenkomst, een link, een bestand of een handmatige registratie is er maar één regel mogelijk. Die vult het systeem in. Trainingen waar wél iets te kiezen valt blijven ongemoeid.",
      "explicit": "Zet deze regel",
      "explicitHint": "Voor e-learning en LTI, waar drie regels mogelijk zijn. Trainingen met een andere bron vallen af.",
      "preview": "Wat gaat dit doen?",
      "previewResult": "{count} trainingen krijgen een afrondingsregel",
      "skipLine": "{count} × {reason}",
      "confirm": "Zetten",
      "done": "{updated} bijgewerkt, {skipped} overgeslagen.",
      "skip": {
        "already_set": "had er al een",
        "needs_choice": "hier moet je zelf kiezen",
        "source_forbids": "past niet bij de bron",
        "package_cannot_measure": "het bestand meet dit niet"
      }
    },
    "rules": {
      "evaluationsTitle": "Evaluaties",
      "testsTitle": "Toetsen",
      "evaluationsIntro": "Vragenlijsten die deelnemers invullen over deze activiteit. Een regel geldt voor alle uitvoeringen.",
      "testsIntro": "Toetsen die een docent nakijkt. Een regel geldt voor alle uitvoeringen. Telt een toets mee voor het behalen, dan volgt de afronding — en dus de kwalificatie — pas als de toets is nagekeken en geslaagd.",
      "add": "Regel toevoegen",
      "empty": "Nog geen regels.",
      "emptyNew": "Nog geen regels. Wat je hier toevoegt, wordt vastgelegd zodra je de activiteit aanmaakt.",
      "draftBadge": "Concept",
      "external": "Extern",
      "pendingNote": "Wordt vastgelegd zodra je de activiteit aanmaakt.",
      "needsSource": "Kies eerst een type, dan kun je hier regels toevoegen.",
      "failedAfterCreate": "“{title}” is aangemaakt, maar een of meer regels konden niet worden vastgelegd. Voeg ze hieronder opnieuw toe.",
      "mandatory": "Telt mee voor het behalen",
      "removed": "De regel is verwijderd.",
      "archivedInstead": "De regel is stopgezet: er was al iets verstuurd, dus verwijderen kan niet.",
      "removeTitle": "Regel verwijderen?",
      "removeBody": "De regel en wat er nog voor deelnemers klaarlag verdwijnen. Is er al iets verstuurd, dan wordt de regel stopgezet.",
      "saveFirstNeeds": "Om een regel toe te voegen wordt de activiteit eerst als concept opgeslagen. Vul eerst nog in:",
      "referenceNote": "Naslag wordt nooit afgerond. Daar kan geen kwalificatie of toets aan hangen; een evaluatie wel. Hangen er al kwalificaties of toetsen aan, dan worden die bij het opslaan weggehaald.",
      "testsNeedSessions": "Een toets kan alleen bij een klassikale activiteit, met bijeenkomsten.",
      "createTest": "Nieuwe toets maken",
      "createEvaluation": "Nieuwe evaluatie maken"
    },
    "links": {
      "qualifications": "Kwalificaties",
      "evaluations": "Evaluaties",
      "tests": "Toetsen"
    },
    "list": {
      "publishPlanned": "Gepland: {date}",
      "publishFailed": "Publicatie niet gelukt"
    },
    "earlyClose": {
      "title": "Deze uitvoering is nog niet afgelopen",
      "notStarted": "Deze uitvoering begint op {date}. Er heeft nog geen dag plaatsgevonden.",
      "partial": "Er komen nog dagen: {remaining} van de {total} dagen zijn nog niet voorbij. Wie niet alle dagen aanwezig was, blijft zonder uitkomst.",
      "confirm": "Toch afsluiten",
      "keep": "Niet afsluiten"
    },
    "view": {
      "label": "Weergave",
      "cards": "Kaarten",
      "list": "Lijst"
    },
    "card": {
      "parts_one": "{count} onderdeel",
      "parts_other": "{count} onderdelen"
    },
    "sources": {
      "heading": "Materiaal per taal",
      "help": "Voor een andere taal kun je een eigen pakket, link of cursus-adres toevoegen. De lerende krijgt standaard zijn eigen taal en kan een andere kiezen.",
      "primaryLanguages": "Talen van dit materiaal",
      "languages": "Talen",
      "other": "Materiaal voor een andere taal ({n})",
      "add": "Materiaal voor een andere taal toevoegen",
      "notForThisKind": "Een bestand per taal kan nog niet; kies hierboven de talen die dit bestand dekt."
    },
    "help": {
      "completionRule": "Wanneer een deelnemer deze training af heeft: als de inhoud zegt dat hij voltooid is, bij een minimale score, bij een percentage doorlopen, of als hij het geopend heeft. Welke regels er zijn, hangt af van de bron.",
      "accessGroup": "Een toegangsgroep beschrijft één keer wie iets mag zien, en is op meer plekken te gebruiken. Je bouwt hem onder Toegang › Toegangsgroepen; hier kies je er een.",
      "promotionMode": "Wat er gebeurt als er een plek vrijkomt: de eerste op de wachtlijst wordt meteen ingeschreven, of krijgt de plek aangeboden en beslist zelf binnen de bedenktijd.",
      "studyLoad": "De duur is hoe lang de training zelf duurt. De studielast is de totale tijd die een deelnemer eraan kwijt is, met voorbereiding, huiswerk en toetsen erbij."
    },
    "occurrences": {
      "results_one": "{count} uitvoering",
      "results_other": "{count} uitvoeringen",
      "notPlanned": "Nog geen datum",
      "moreDays_one": "+ {count} dag",
      "moreDays_other": "+ {count} dagen"
    },
    "notFound": {
      "title": "Deze catalogus bestaat niet",
      "body": "De link klopt niet meer, of deze catalogus is niet voor jou bedoeld. Vraag het na bij je beheerder als je hem wel zou moeten zien.",
      "back": "Naar de catalogus"
    },
    "certificate": {
      "label": "Certificaat",
      "loading": "Certificaatsjablonen laden…",
      "loadError": "De certificaatsjablonen konden niet geladen worden.",
      "asActivity": "Zoals de activiteit",
      "unavailableTemplate": "Niet meer te kiezen sjabloon",
      "none": "Geen certificaat",
      "help": {
        "activity": "Kies het sjabloon voor het certificaat. Het certificaat ontstaat vanzelf als iemand deze activiteit afrondt. Standaard volgt de activiteit de keuze van de omgeving (Instellingen → Certificaten).",
        "occurrence": "Standaard krijgt een deelnemer het certificaat dat de activiteit kiest. Kies hier alleen iets anders als deze uitvoering moet afwijken."
      },
      "archivedWarning": "Dit sjabloon is gearchiveerd of niet meer te kiezen. Er worden nog certificaten mee gemaakt; kies een ander sjabloon als dat niet de bedoeling is."
    }
  },
  "catalogSettings": {
    "heading": "Catalogus-instellingen",
    "intro": "Stel hier de standaardwaarden voor de catalogus en inschrijvingen in. Nieuwe activiteiten en uitvoeringen vallen op deze waarden terug.",
    "saved": "Instellingen opgeslagen.",
    "waitlist": {
      "legend": "Wachtlijst",
      "enabledByDefault": "Wachtlijst standaard aan",
      "enabledByDefaultHint": "Nieuwe uitvoeringen zetten de wachtlijst standaard aan wanneer een uitvoering vol is.",
      "promotionMode": "Promotie-modus",
      "offerWindowHours": "Aanbod-venster (uren)",
      "offerWindowHoursHint": "Hoeveel uur een doorgeschoven wachtende krijgt om een aangeboden plek te accepteren.",
      "cap": "Plafond wachtlijst",
      "capHint": "Laat leeg voor een ongelimiteerde wachtlijst.",
      "capPlaceholder": "Ongelimiteerd"
    },
    "deadlines": {
      "legend": "Deadlines",
      "hint": "Het standaard aantal kalenderdagen vóór de eerste dag van een uitvoering. Een activiteit kan een eigen aantal kiezen; leeg betekent geen standaard.",
      "enrollmentDays": "Inschrijven kan tot (dagen vóór de eerste dag)"
    },
    "enrollment": {
      "legend": "Inschrijving",
      "hint": "Hoeveel keer iemand tegelijk mag deelnemen of op de wachtlijst mag staan voor een activiteit. Nieuwe activiteiten starten met deze waarden.",
      "maxEnrollments": "Aantal inschrijvingen",
      "maxWaitlistRegistrations": "Aantal wachtlijst-registraties",
      "cancellationFlow": "Goedkeuringsflow voor annuleren",
      "cancellationFlowHint": "Wie bij een nieuwe activiteit een annuleringsverzoek beslist, als de annuleringsvoorwaarden goedkeuring vragen. Los van de flow bij inschrijven: die mag dezelfde zijn, maar is het niet vanzelf.",
      "cancellationFlowNone": "Geen"
    },
    "visibility": {
      "legend": "Zichtbaarheid",
      "mode": "Zichtbaarheidsmodus"
    },
    "durationPresets": {
      "legend": "Voorkeursduren",
      "hint": "De keuzelijst voor de duur van een training. Elke keuze staat voor een aantal minuten (een halve dag is 240). Een training kan er altijd van afwijken.",
      "empty": "Zonder eigen keuzes geldt de standaardlijst.",
      "add": "Voorkeursduur toevoegen",
      "restore": "Standaardlijst terugzetten",
      "rowTitle": "Voorkeursduur {n}",
      "minutes": "Minuten"
    },
    "learningForms": {
      "legend": "Leervormen",
      "hint": "Een label voor de lerende bij elke training, met een kleur. Bij een training kies je uit deze lijst.",
      "add": "Leervorm toevoegen",
      "rowTitle": "Leervorm {n}",
      "color": "Kleur",
      "preview": "Zo ziet de lerende het",
      "inUse": "In gebruik bij een activiteit: kan niet worden verwijderd.",
      "colorOption": {
        "primary": "Primair",
        "accent": "Accent",
        "success": "Groen",
        "warning": "Oranje",
        "error": "Rood",
        "info": "Blauw",
        "neutral": "Grijs"
      }
    },
    "lists": {
      "nameIn": "Naam in {language}",
      "up": "Omhoog",
      "down": "Omlaag",
      "remove": "Verwijderen",
      "upFor": "Omhoog: {name}",
      "downFor": "Omlaag: {name}",
      "removeFor": "Verwijderen: {name}"
    },
    "activityFields": {
      "legend": "Kenmerken",
      "hint": "Eigen velden op elke activiteit: vrije tekst, een keuzelijst of ja/nee. Een keuzelijst of ja/nee kan een filter in de catalogus zijn; dat staat standaard uit.",
      "rowTitle": "Kenmerk {n}",
      "kindLabel": "Soort",
      "kind": {
        "text": "Vrije tekst",
        "choice": "Keuzelijst",
        "boolean": "Ja/nee"
      },
      "active": "Actief",
      "filterable": "Toon als filter in de catalogus",
      "options": "Opties",
      "optionTitle": "Optie {n}",
      "addOption": "Optie toevoegen",
      "add": "Kenmerk toevoegen",
      "inUse_one": "Staat op {count} activiteit.",
      "inUse_other": "Staat op {count} activiteiten.",
      "kindLocked": "De soort ligt vast zodra er waarden op staan.",
      "removeTitle": "Kenmerk verwijderen?",
      "removeBody_one": "\"{name}\" staat op {count} activiteit. Verwijderen haalt die waarde weg zodra je opslaat. Wil je het alleen verbergen, zet het dan uit.",
      "removeBody_other": "\"{name}\" staat op {count} activiteiten. Verwijderen haalt die waarden weg zodra je opslaat. Wil je het alleen verbergen, zet het dan uit.",
      "saved": "De kenmerken zijn opgeslagen.",
      "empty": "Nog geen kenmerken."
    },
    "summary": {
      "waitlistOff": "uit",
      "waitlistOnOffer": "aan, aanbod {hours} u",
      "waitlistOnAuto": "aan, schuift automatisch door",
      "waitlistCap": "max. {cap}",
      "daysBefore_one": "{count} dag vooraf",
      "daysBefore_other": "{count} dagen vooraf",
      "noDeadline": "geen standaard",
      "enrollment": "inschrijvingen: {enrollments}, wachtlijst: {waitlist}",
      "durationPresets_one": "{count} duur",
      "durationPresets_other": "{count} duren",
      "learningForms_one": "{count} leervorm",
      "learningForms_other": "{count} leervormen",
      "activityFields_one": "{count} actief kenmerk",
      "activityFields_other": "{count} actieve kenmerken",
      "activityFieldsNone": "nog geen",
      "deadlinesEnrollment": "inschrijven: {enrollment}"
    },
    "unsaved": {
      "title": "Wijzigingen opslaan?",
      "body": "Je hebt bij {section} iets gewijzigd dat nog niet is opgeslagen.",
      "discard": "Niet opslaan"
    }
  },
  "settingsHub": {
    "heading": "Instellingen",
    "intro": "Richt hier je omgeving in. Kies een onderdeel.",
    "readOnly": "Je kunt deze instellingen bekijken maar niet wijzigen.",
    "tabs": {
      "catalog": "Catalogus",
      "approvals": "Goedkeuringen",
      "messages": "Berichten",
      "questionnaires": "Vragenlijsten",
      "retention": "Bewaartermijnen",
      "catalogs": "Catalogi",
      "cancellation": "Annuleringsvoorwaarden",
      "languages": "Contenttalen",
      "documents": "Certificaten"
    },
    "empty": "Er is hier niets dat je mag inrichten.",
    "breadcrumb": "Kruimelpad",
    "pages": {
      "catalog": "Catalogusinstellingen"
    },
    "themes": {
      "catalog": "Catalogus",
      "processes": "Processen",
      "textsMessages": "Teksten en berichten",
      "evaluationData": "Evaluatie en gegevens",
      "integrations": "Koppelingen"
    },
    "descriptions": {
      "catalog": "Standaarden voor een nieuwe training: wachtlijst, inschrijven, deadlines, leervormen en kenmerken.",
      "catalogs": "De catalogi, wat erin staat en wie ze mag openen.",
      "themes": "De categorieën waarin je trainingen indeelt.",
      "cancellationReasons": "De redenen waaruit je kiest bij het annuleren.",
      "approvals": "Welke goedkeuringsflow standaard geldt.",
      "approvalFlows": "Wie wat goedkeurt, en in welke volgorde.",
      "workflows": "Wat er automatisch gebeurt na een gebeurtenis.",
      "texts": "Eigen woorden voor de teksten in het platform.",
      "messages": "Hoe vaak de verzamelmail gaat.",
      "questionnaires": "Antwoordtermijn, herinneringen en schaal.",
      "retention": "Hoe lang leergeschiedenis en andere gegevens bewaard blijven.",
      "lti": "Externe leeromgevingen via LTI.",
      "cancellation": "Tot wanneer annuleren kan, wie het beslist en wat het kost.",
      "languages": "In welke talen je trainingen en hun materiaal er zijn.",
      "documentTemplates": "De sjablonen voor certificaten, met hun versies.",
      "documents": "Hoe het certificaatnummer begint, en of de BCS-sjablonen te kiezen zijn."
    }
  },
  "questionBank": {
    "heading": "Vragenlijsten",
    "heading_test": "Toetsen",
    "intro": "Vragen, categorieën en formulieren zijn de bouwstenen van een vragenlijst. Een vraag kan in meerdere categorieën staan, een categorie in meerdere formulieren, en een formulier in meerdere regels.",
    "intro_test": "Vragen, categorieën en toetsen horen bij elkaar. Een vraag kan in meerdere categorieën staan, een categorie in meerdere toetsen, en een toets in meerdere regels bij een training.",
    "tabs": {
      "questions": "Vragen",
      "categories": "Categorieën",
      "forms": "Formulieren",
      "forms_test": "Toetsen",
      "surveys": "Losse vragenlijsten",
      "assignments": "Evaluatieregels",
      "assignments_test": "Toetsregels"
    },
    "status": {
      "filter": "Toon",
      "active": "Actief",
      "archived": "Gearchiveerd",
      "all": "Alles"
    },
    "type": {
      "open": "Open vraag",
      "scale": "Schaal",
      "multiple_choice": "Meerkeuze",
      "yes_no": "Ja/nee"
    },
    "typeHint": {
      "scale": "Schaal {min}–{max}",
      "multiple_choice_one": "Meerkeuze, {count} optie",
      "multiple_choice_other": "Meerkeuze, {count} opties"
    },
    "archivedBadge": "Gearchiveerd",
    "changeHint": "Een wijziging geldt voor uitnodigingen die vanaf nu ontstaan. Wat al verstuurd is, blijft zoals het was.",
    "fixErrors": "Opslaan is niet gelukt. Controleer de gemarkeerde velden.",
    "saveFailed": "Opslaan is niet gelukt. Probeer het opnieuw.",
    "actionFailed": "Dat is niet gelukt. Probeer het opnieuw.",
    "actions": {
      "edit": "Bewerken",
      "view": "Bekijken",
      "copy": "Kopiëren",
      "archive": "Archiveren",
      "restore": "Terugzetten",
      "delete": "Verwijderen",
      "editNamed": "{name} bewerken",
      "viewNamed": "{name} bekijken",
      "copyNamed": "{name} kopiëren"
    },
    "text": {
      "tabsLabel": "Taal van de teksten",
      "tabsHint": "Schrijf de teksten per taal. {language} is de standaardtaal en verplicht; een taal zonder tekst valt terug op de standaardtaal.",
      "tabIncomplete": "{language} (onvolledig)",
      "tabError": "{language} (fout)",
      "hiddenLocale": "{language} (staat uit):",
      "hiddenNotice": "Er staan teksten in een taal die uit staat voor deze omgeving: {languages}. Ze blijven bewaard maar worden niet getoond, en zijn terug zodra de taal weer aan gaat. Je kunt ze per veld verwijderen.",
      "removeHidden": "Tekst in het {language} verwijderen uit {field}"
    },
    "questions": {
      "count_one": "{count} vraag",
      "count_other": "{count} vragen",
      "new": "Nieuwe vraag",
      "empty": "Er staan nog geen vragen in de bank.",
      "emptyFiltered": "Geen vragen met deze status.",
      "loadError": "De vragen konden niet geladen worden.",
      "column": {
        "prompt": "Vraag",
        "type": "Type",
        "categories": "In categorieën",
        "forms": "In formulieren",
        "forms_test": "In toetsen",
        "actions": "Acties"
      }
    },
    "question": {
      "newTitle": "Nieuwe vraag",
      "texts": "Teksten",
      "editTitle": "Vraag bewerken",
      "viewTitle": "Vraag bekijken",
      "backToList": "Terug naar de vragen",
      "loadError": "Deze vraag kon niet geladen worden.",
      "saved": "De vraag is opgeslagen.",
      "copied": "Dit is de kopie. Pas hem aan zoals je wilt: de vorm ligt bij een kopie weer open.",
      "readOnly": "Je kunt deze vraag bekijken, maar niet wijzigen.",
      "archivedNotice": "Deze vraag is gearchiveerd. Hij komt bij geen nieuwe categorie meer; waar hij al staat, blijft hij staan.",
      "locked": {
        "title": "De vorm van deze vraag ligt vast",
        "body": "Er zijn al antwoorden op gegeven, of hij staat in een uitnodiging die nog ingevuld kan worden. Het type, het bereik, één of meer antwoorden en de bestaande opties blijven daarom zoals ze zijn. De tekst, de hulptekst, verplicht en een nieuwe optie kun je wel wijzigen. Heb je een andere vorm nodig, kopieer de vraag dan."
      },
      "fields": {
        "type": "Soort vraag",
        "prompt": "Vraag",
        "helpText": "Hulptekst",
        "helpTextHint": "Staat onder de vraag.",
        "required": "Verplicht om te beantwoorden",
        "placeholder": "Voorbeeldtekst in het veld",
        "minChars": "Minimaal aantal tekens",
        "maxChars": "Maximaal aantal tekens",
        "testimonial": "Antwoorden mogen als citaat gebruikt worden",
        "testimonialHint": "Later te tonen op de pagina van de training.",
        "requiredQuoteReason": "Een vraag waarvan de antwoorden als citaat gebruikt mogen worden, kan niet verplicht zijn.",
        "minValue": "Laagste waarde",
        "maxValue": "Hoogste waarde",
        "scaleDisplay": "Weergave",
        "scaleLabels": "Tekst per punt",
        "scaleLabelsHint": "Optioneel. Zonder tekst ziet de deelnemer bijvoorbeeld “3 van 5”.",
        "scaleLabelsTooMany": "Een tekst per punt kun je geven bij een schaal van hoogstens {max} punten.",
        "scalePoint": "Punt {point}",
        "options": "Antwoordopties",
        "noOptions": "Er zijn nog geen opties.",
        "option": "Optie {n}",
        "addOption": "Optie toevoegen",
        "moveOptionUp": "Optie {n} omhoog",
        "moveOptionDown": "Optie {n} omlaag",
        "removeOption": "Optie {n} verwijderen",
        "allowsMultiple": "Meer dan één antwoord mogelijk",
        "allowsOther": "“Anders, namelijk” aanbieden",
        "allowsOtherHint": "Naast de andere keuzes, niet in plaats daarvan."
      },
      "choiceLimits": {
        "hint": "Laat een grens leeg als die er niet is. Het minimum ligt minstens één onder het aantal opties ({count}, “anders, namelijk” meegeteld), het maximum past erin. Een verplichte vraag vraagt altijd minstens één antwoord.",
        "min": "Minimum aantal te kiezen",
        "max": "Maximum aantal te kiezen",
        "minTooHigh": "Het minimum moet minstens één lager zijn dan het aantal opties ({count}).",
        "maxTooHigh": "Het maximum kan niet hoger zijn dan het aantal opties ({count}).",
        "backwards": "Het maximum is lager dan het minimum.",
        "notAWholeNumber": "Vul een geheel getal van 1 of hoger in."
      },
      "scaleDisplay": {
        "numbers": "Cijfers",
        "stars": "Sterren"
      },
      "usage": {
        "title": "Waar deze vraag staat",
        "categories": "Categorieën",
        "forms": "Formulieren",
        "forms_test": "Toetsen",
        "assignments": "Lopende toewijzingen",
        "unused": "Deze vraag staat nog nergens in."
      },
      "delete": {
        "title": "Vraag verwijderen",
        "body": "De vraag verdwijnt uit de bank. Dat kan niet ongedaan gemaakt worden.",
        "confirm": "Verwijderen"
      }
    },
    "categories": {
      "count_one": "{count} categorie",
      "count_other": "{count} categorieën",
      "new": "Nieuwe categorie",
      "empty": "Er zijn nog geen categorieën.",
      "emptyFiltered": "Geen categorieën met deze status.",
      "loadError": "De categorieën konden niet geladen worden.",
      "column": {
        "title": "Titel",
        "questions": "Vragen",
        "forms": "In formulieren",
        "forms_test": "In toetsen",
        "actions": "Acties"
      }
    },
    "category": {
      "newTitle": "Nieuwe categorie",
      "editTitle": "Categorie bewerken",
      "viewTitle": "Categorie bekijken",
      "backToList": "Terug naar de categorieën",
      "loadError": "Deze categorie kon niet geladen worden.",
      "saved": "De categorie is opgeslagen.",
      "copied": "Dit is de kopie, met dezelfde vragen. Een vraag die ook moet afwijken, kopieer je apart.",
      "readOnly": "Je kunt deze categorie bekijken, maar niet wijzigen.",
      "archivedNotice": "Deze categorie is gearchiveerd. Hij komt in geen nieuw formulier meer; waar hij al staat, blijft hij staan.",
      "archivedNotice_test": "Deze categorie is gearchiveerd. Hij komt in geen nieuwe toets meer; waar hij al staat, blijft hij staan.",
      "fields": {
        "title": "Titel",
        "description": "Omschrijving"
      },
      "questions": {
        "title": "Vragen in deze categorie",
        "hint": "In deze volgorde staan ze in het formulier.",
        "hint_test": "In deze volgorde staan ze in de toets.",
        "empty": "Er staan nog geen vragen in deze categorie.",
        "add": "Vraag toevoegen",
        "search": "Zoek een vraag in de bank",
        "noResults": "Geen vragen gevonden.",
        "moveUp": "“{question}” omhoog",
        "moveDown": "“{question}” omlaag",
        "remove": "“{question}” uit de categorie halen"
      },
      "usage": {
        "title": "Waar deze categorie staat",
        "forms": "Formulieren",
        "forms_test": "Toetsen",
        "assignments": "Lopende toewijzingen",
        "unused": "Deze categorie staat nog in geen enkel formulier.",
        "unused_test": "Deze categorie staat nog in geen enkele toets."
      },
      "delete": {
        "title": "Categorie verwijderen",
        "body": "De categorie verdwijnt. De vragen erin blijven in de bank. Dat kan niet ongedaan gemaakt worden.",
        "confirm": "Verwijderen"
      },
      "actions": {
        "saveAndNewQuestion": "Opslaan en nieuwe vraag maken"
      }
    },
    "forms": {
      "count_one": "{count} formulier",
      "count_test_one": "{count} toets",
      "count_other": "{count} formulieren",
      "count_test_other": "{count} toetsen",
      "new": "Nieuw formulier",
      "new_test": "Nieuwe toets",
      "empty": "Er zijn nog geen formulieren.",
      "empty_test": "Er zijn nog geen toetsen.",
      "emptyFiltered": "Geen formulieren met deze status.",
      "emptyFiltered_test": "Geen toetsen met deze status.",
      "loadError": "De formulieren konden niet geladen worden.",
      "loadError_test": "De toetsen konden niet geladen worden.",
      "filter": {
        "current": "Concept en gepubliceerd",
        "draft": "Concept",
        "published": "Gepubliceerd",
        "archived": "Gearchiveerd",
        "all": "Alles"
      },
      "column": {
        "title": "Titel",
        "status": "Status",
        "assignments": "Toewijzingen",
        "actions": "Acties"
      }
    },
    "form": {
      "newTitle": "Nieuw formulier",
      "newTitle_test": "Nieuwe toets",
      "editTitle": "Formulier bewerken",
      "editTitle_test": "Toets bewerken",
      "viewTitle": "Formulier bekijken",
      "viewTitle_test": "Toets bekijken",
      "backToList": "Terug naar de formulieren",
      "backToList_test": "Terug naar de toetsen",
      "loadError": "Dit formulier kon niet geladen worden.",
      "loadError_test": "Deze toets kon niet geladen worden.",
      "saved": "Het formulier is opgeslagen.",
      "saved_test": "De toets is opgeslagen.",
      "copied": "Dit is de kopie: een nieuw concept met dezelfde categorieën. Een categorie die moet afwijken, kopieer je apart.",
      "published": "Het formulier is gepubliceerd en kan nu aan een training gekoppeld worden.",
      "published_test": "De toets is gepubliceerd en kan nu aan een training gekoppeld worden.",
      "publishFailed": "Publiceren is niet gelukt. Controleer de gemarkeerde velden.",
      "readOnly": "Je kunt dit formulier bekijken, maar niet wijzigen.",
      "readOnly_test": "Je kunt deze toets bekijken, maar niet wijzigen.",
      "archivedNotice": "Dit formulier is gearchiveerd en kan aan geen training meer gekoppeld worden. Zet het terug om er weer een concept van te maken.",
      "archivedNotice_test": "Deze toets is gearchiveerd en kan aan geen training meer gekoppeld worden. Zet hem terug om er weer een concept van te maken.",
      "status": {
        "draft": "Concept",
        "published": "Gepubliceerd",
        "archived": "Gearchiveerd"
      },
      "statusPanel": {
        "title": "Status",
        "new": "Een nieuw formulier wordt als concept opgeslagen.",
        "new_test": "Een nieuwe toets wordt als concept opgeslagen.",
        "draft": "Een concept kan nog niet aan een training gekoppeld worden. Publiceer het als het af is; dan wordt gecontroleerd of alles klopt.",
        "published": "Het formulier kan aan trainingen gekoppeld worden. Het blijft te bewerken, zolang het publiceerbaar blijft.",
        "published_test": "De toets kan aan trainingen gekoppeld worden. Hij blijft te bewerken, zolang hij publiceerbaar blijft.",
        "archived": "Het formulier staat in het archief. Terugzetten maakt er weer een concept van.",
        "archived_test": "De toets staat in het archief. Terugzetten maakt er weer een concept van."
      },
      "fields": {
        "title": "Titel",
        "description": "Omschrijving",
        "descriptionHint": "Staat onder de titel.",
        "headerText": "Koptekst",
        "headerTextHint": "Staat boven de vragen, bijvoorbeeld een welkom.",
        "footerText": "Voettekst",
        "footerTextHint": "Staat onder de vragen, bijvoorbeeld een bedankje.",
        "allowRemarks": "Ruimte voor een opmerking aan het eind",
        "allowRemarksHint": "De deelnemer kan een vrije opmerking achterlaten, los van de vragen."
      },
      "categories": {
        "title": "Categorieën in dit formulier",
        "title_test": "Categorieën in deze toets",
        "hint": "In deze volgorde staan ze in de vragenlijst. Een vraag staat maar één keer in een formulier.",
        "hint_test": "In deze volgorde staan ze in de toets. Een vraag staat maar één keer in een toets.",
        "empty": "Er staan nog geen categorieën in dit formulier.",
        "empty_test": "Er staan nog geen categorieën in deze toets.",
        "add": "Categorie toevoegen",
        "search": "Zoek een categorie",
        "noResults": "Geen categorieën gevonden.",
        "questionCount_one": "{count} vraag",
        "questionCount_other": "{count} vragen",
        "moveUp": "“{category}” omhoog",
        "moveDown": "“{category}” omlaag",
        "remove": "“{category}” uit het formulier halen",
        "remove_test": "“{category}” uit de toets halen"
      },
      "actions": {
        "publish": "Publiceren",
        "saveAndNewCategory": "Opslaan en nieuwe categorie maken"
      },
      "delete": {
        "title": "Formulier verwijderen",
        "title_test": "Toets verwijderen",
        "body": "Het formulier verdwijnt. De categorieën en vragen erin blijven in de bank. Dat kan niet ongedaan gemaakt worden.",
        "body_test": "De toets verdwijnt. De categorieën en vragen erin blijven in de bank. Dat kan niet ongedaan gemaakt worden.",
        "confirm": "Verwijderen"
      },
      "assignments": {
        "title": "Toewijzingen",
        "unused": "Dit formulier is nog aan geen training gekoppeld.",
        "unused_test": "Deze toets is nog aan geen training gekoppeld.",
        "total": "In gebruik",
        "pausable": "Te pauzeren",
        "pausedViaForm": "Gepauzeerd via dit formulier",
        "pausedSeparately": "Los gepauzeerd, blijft staan bij hervatten",
        "held_one": "{count} toewijzing staat via dit formulier op pauze. Er gaat niets uit tot je hervat.",
        "held_other": "{count} toewijzingen staan via dit formulier op pauze. Er gaat niets uit tot je hervat.",
        "hint": "Wil je het formulier verbeteren terwijl het in gebruik is? Pauzeer eerst alle toewijzingen, pas het aan en hervat ze. Links die al verstuurd zijn, blijven werken.",
        "listTitle": "Per toewijzing",
        "unknownTraining": "Training zonder naam",
        "openNamed": "Uitnodigingen bij {training}",
        "invitations_one": "{count} uitnodiging",
        "invitations_other": "{count} uitnodigingen"
      },
      "pause": {
        "open": "Alle toewijzingen pauzeren",
        "title": "Alle toewijzingen pauzeren",
        "body_one": "De lopende toewijzing van dit formulier gaat op pauze. Tot je hervat, gaat er niets uit: wie in die tijd afrondt, krijgt de uitnodiging pas bij het hervatten, als je dan kiest om op te pakken. Links die al verstuurd zijn, blijven werken.",
        "body_other": "De {count} lopende toewijzingen van dit formulier gaan op pauze. Tot je hervat, gaat er niets uit: wie in die tijd afrondt, krijgt de uitnodiging pas bij het hervatten, als je dan kiest om op te pakken. Links die al verstuurd zijn, blijven werken.",
        "confirm": "Pauzeren",
        "done_one": "{count} toewijzing staat nu op pauze.",
        "done_other": "{count} toewijzingen staan nu op pauze."
      },
      "resume": {
        "open": "Hervatten…",
        "title": "Toewijzingen hervatten",
        "loadError": "Wat er klaarligt, kon niet geladen worden.",
        "intro": "Tijdens de pauze is niets verstuurd. Dit ligt er per training klaar: uitnodigingen van vóór de pauze, en van wie tijdens de pauze afrondde.",
        "nothingHeld": "Er ligt niets klaar. Hervatten zet de toewijzingen weer aan; wie daarna afrondt, krijgt het formulier zoals het dan is.",
        "table": {
          "caption": "Klaarliggende uitnodigingen per training",
          "training": "Training",
          "before": "Van vóór de pauze",
          "during": "Tijdens de pauze",
          "oldest": "Oudste",
          "beyond": "Vervalt door de grens",
          "total": "Totaal",
          "days_one": "{count} dag",
          "days_other": "{count} dagen",
          "none": "geen",
          "unknownTraining": "Training zonder naam"
        },
        "choice": {
          "legend": "Wat gebeurt er met de klaarliggende uitnodigingen?",
          "pickUp": "Oppakken",
          "pickUpHint": "Ze gaan alsnog uit, allemaal met het formulier zoals het nu is. Is hun moment al voorbij, dan gaan ze nu; het invulvenster begint bij het versturen.",
          "decline": "Niet oppakken",
          "declineHint": "Ze vervallen, en wie tijdens de pauze afrondde, krijgt er geen.",
          "required": "Kies of je de klaarliggende uitnodigingen oppakt."
        },
        "limit": {
          "label": "Leeftijdsgrens in dagen",
          "hint": "Optioneel: alleen uitnodigingen die jonger zijn dan dit aantal dagen worden opgepakt, oudere vervallen. Leeg laten: alles wordt opgepakt.",
          "beyond_one": "Met deze grens vervalt {count} van de {total} klaarliggende uitnodigingen; de rest wordt opgepakt.",
          "beyond_other": "Met deze grens vervallen {count} van de {total} klaarliggende uitnodigingen; de rest wordt opgepakt.",
          "checkFailed": "De grens kon niet gecontroleerd worden."
        },
        "confirm": "Hervatten",
        "done_one": "{count} toewijzing loopt weer. Opgepakt: {refrozen}, vervallen: {withdrawn}.",
        "done_other": "{count} toewijzingen lopen weer. Opgepakt: {refrozen}, vervallen: {withdrawn}."
      },
      "backToWizard": "Terug naar de training",
      "fromWizardHint": "Je komt uit de training die je aan het maken bent. Publiceer dit formulier om het daar te kiezen; je gaat dan vanzelf terug. Je invoer in de training is bewaard."
    },
    "gradingLink": "Naar nakijken"
  },
  "questionnaireSettings": {
    "intro": "De standaarden waarmee nieuwe uitnodigingen en schaalvragen beginnen. Laat je een veld leeg, dan geldt de standaard van het platform.",
    "followsPlatform": "Je hebt hier nog niets eigens ingesteld: overal geldt de standaard van het platform.",
    "window": {
      "legend": "Antwoordtermijn",
      "hint": "Hoe lang een uitnodiging na het versturen invulbaar blijft, als de toewijzing zelf niets anders zegt. Een wijziging geldt voor uitnodigingen die vanaf nu verstuurd worden.",
      "label": "Aantal dagen",
      "platform_one": "Leeg: {count} dag, de standaard van het platform.",
      "platform_other": "Leeg: {count} dagen, de standaard van het platform."
    },
    "reminder": {
      "legend": "Herinneringen",
      "hint": "Hoeveel dagen een uitnodiging openstaat voordat iedereen herinneren en de automatische herinnering hem meenemen. Zo krijgt niemand een herinnering vlak na de uitnodiging. Een herinnering aan één persoon met de hand houdt zich hier niet aan.",
      "zero": "0: geen minimum.",
      "label": "Minimaal aantal dagen na het versturen",
      "platform_one": "Leeg: {count} dag, de standaard van het platform.",
      "platform_other": "Leeg: {count} dagen, de standaard van het platform."
    },
    "scale": {
      "legend": "Schaalbereik",
      "hint": "Het bereik waarmee een nieuwe schaalvraag begint. Per vraag pas je het aan; bestaande vragen houden hun eigen bereik.",
      "pairRule": "Vul beide waarden in, of laat ze allebei leeg.",
      "min": "Laagste waarde",
      "max": "Hoogste waarde",
      "platform": "Leeg: {value}, de standaard van het platform."
    },
    "saved": "De instellingen zijn opgeslagen.",
    "saveFailed": "Opslaan is niet gelukt."
  },
  "retentionSettings": {
    "intro": "Hoe lang de leergeschiedenis van je omgeving bewaard blijft, per soort record en geteld vanaf de datum van het record. Is de termijn voorbij, dan verwijdert de nachtelijke bewaartermijn-run het record — het record, niet de persoon. Laat je een veld leeg, dan blijft het record bewaard.",
    "keepHint": "Leeg: bewaren. Dat is de standaard.",
    "defaultHint_one": "Standaard: {count} maand. Leeg: bewaren.",
    "defaultHint_other": "Standaard: {count} maanden. Leeg: bewaren.",
    "keepPlaceholder": "Bewaren",
    "types": {
      "enrollment": "Inschrijvingen (maanden)",
      "attendance": "Aanwezigheid (maanden)",
      "attempt": "Pogingen bij e-learning (maanden)",
      "completion": "Afrondingen (maanden)",
      "qualification": "Kwalificaties (maanden na einde of verloop)",
      "certificate": "Certificaten (maanden)",
      "evaluation_response": "Evaluaties (maanden na het insturen)",
      "import_raw_data": "Ruwe importgegevens (maanden)"
    },
    "history": {
      "legend": "Leergeschiedenis",
      "hint": "Afrondingen, kwalificaties en certificaten blijven standaard bewaard: ze zijn het bewijs van wat iemand behaald heeft. Een inschrijving of afronding waar nog iets aan hangt dat bewaard blijft, wordt overgeslagen tot ook dat verlopen is. Een kwalificatie die nog geldig is, wordt nooit verwijderd."
    },
    "evaluation": {
      "legend": "Evaluaties",
      "hint": "Ingevulde evaluaties en andere meningen. Een kennistoets heeft geen eigen termijn: die gaat mee met de afronding waar hij bij hoort.",
      "action": "Na de termijn",
      "actions": {
        "anonymise": "Anonimiseren: de antwoorden blijven voor de rapportage, zonder naam",
        "delete": "Verwijderen: de invulling en haar antwoorden gaan weg"
      }
    },
    "imports": {
      "legend": "Ruwe importgegevens",
      "hint": "De ingelezen regels uit een HR-bestand, met bijvoorbeeld namen en geboortedata. Na de termijn worden ze leeggemaakt; het overzicht van de import blijft."
    },
    "fixed": {
      "legend": "Vaste termijnen",
      "personalData_one": "De persoonsgegevens van een verwijderde gebruiker worden {count} dag na het verwijderen onherkenbaar gemaakt. Deze termijn stelt BCS voor je omgeving in.",
      "personalData_other": "De persoonsgegevens van een verwijderde gebruiker worden {count} dagen na het verwijderen onherkenbaar gemaakt. Deze termijn stelt BCS voor je omgeving in.",
      "mailOutbox_one": "Verzonden e-mails worden na {count} dag verwijderd (een termijn van het platform).",
      "mailOutbox_other": "Verzonden e-mails worden na {count} dagen verwijderd (een termijn van het platform)."
    },
    "lastRun": {
      "legend": "Laatst toegepast",
      "none": "De bewaartermijnen zijn nog niet toegepast. Dat gebeurt elke nacht.",
      "summary": "Op {date}: {erased} gebruikers onherkenbaar gemaakt, {records} records verwerkt en {shells} lege accounts opgeruimd."
    },
    "saved": "De bewaartermijnen zijn opgeslagen.",
    "saveFailed": "Opslaan is niet gelukt."
  },
  "questionnaireStatus": {
    "heading": "Stand van de regel",
    "heading_test": "Stand van de toetsregel",
    "backToForm": "Naar het formulier",
    "backToForm_test": "Naar de toets",
    "backToSurveys": "Naar de losse vragenlijsten",
    "backToTraining": "Naar de training",
    "subject": "{form} bij {training}",
    "subjectWithoutTraining": "Vragenlijst {form}",
    "subjectWithoutTraining_test": "Toets {form}",
    "anonymous": "Anoniem",
    "anonymousNote": "Deze regel is anoniem: je ziet hoeveel uitnodigingen er in elke stand staan, maar niet van wie. Per persoon herinneren of opnieuw sturen kan daarom niet; iedereen die nog open staat herinneren wel.",
    "anonymousBelowFloor": "De uitslag blijft verborgen tot er {floor} antwoorden zijn, over alle uitvoeringen samen. Tot nu toe: {counted} van {floor}.",
    "loadError": "Deze regel kon niet geladen worden.",
    "loadError_test": "Deze toetsregel kon niet geladen worden.",
    "notFound": "Deze regel bestaat niet (meer).",
    "notFound_test": "Deze toetsregel bestaat niet (meer).",
    "actionFailed": "Dat lukte niet. Probeer het opnieuw.",
    "backToRule": "Naar de regel",
    "backToRule_test": "Naar de toetsregel",
    "occurrence": {
      "heading": "Toewijzing: {date}, {location}",
      "headingNoLocation": "Toewijzing: {date}",
      "headingLoading": "Toewijzing",
      "notFound": "Deze toewijzing bestaat niet (meer).",
      "loadError": "Deze toewijzing kon niet geladen worden."
    },
    "occurrences": {
      "title": "Toewijzingen",
      "hint": "Per uitvoering van de training: wie is uitgenodigd en hoe ver ze zijn. Open een toewijzing om de mensen te zien.",
      "empty": "Er is voor deze regel nog niets uitgenodigd.",
      "empty_test": "Er is voor deze toetsregel nog niets uitgenodigd.",
      "loadError": "De toewijzingen konden niet geladen worden.",
      "future_one": "{count} toekomstige uitvoering, nog niets verstuurd.",
      "future_other": "{count} toekomstige uitvoeringen, nog niets verstuurd.",
      "column": {
        "date": "Uitvoering",
        "location": "Locatie",
        "trainers": "Trainers",
        "sent": "Verstuurd",
        "submitted": "Ingevuld",
        "open": "Open",
        "expired": "Verlopen",
        "actions": "Acties"
      },
      "sentOf": "{sent} van {invited}",
      "submittedOf": "{count} ({percent}%)",
      "view": "Bekijken",
      "viewNamed": "Toewijzing van {name} bekijken",
      "noDate": "Geen datum",
      "none": "–"
    },
    "assignment": {
      "active": "Loopt",
      "paused": "Gepauzeerd",
      "archived": "Gearchiveerd"
    },
    "notRunning": {
      "paused": "Deze regel is gepauzeerd. Herinneren en opnieuw sturen kan weer zodra ze hervat is; links die al verstuurd zijn, blijven werken.",
      "paused_test": "Deze toetsregel is gepauzeerd. Er gaat niets uit tot hij hervat is.",
      "archived": "Deze regel is gearchiveerd. Herinneren en opnieuw sturen kan niet meer; links die al verstuurd zijn, blijven werken tot ze verlopen.",
      "archived_test": "Deze toetsregel is gearchiveerd en verstuurt niets meer."
    },
    "counts": {
      "title": "Tellingen",
      "loadError": "De tellingen konden niet geladen worden.",
      "empty": "Uit deze regel zijn nog geen uitnodigingen ontstaan.",
      "mailFailed": "Mail mislukt",
      "mailFailedHint": "Bij een mislukte mail staat de uitnodiging op verstuurd, maar is de mail niet aangekomen. Opnieuw sturen stuurt hem nog eens: met een nieuwe link, of met het adres in Mijn vragenlijsten als de vragenlijst alleen in de app opengaat.",
      "submittedOf": "van {total} ({percent}%)",
      "submittedHint": "Uitnodigingen waarop de vragenlijst is ingevuld.",
      "submittedHint_test": "Uitnodigingen waarop de toets is ingevuld.",
      "open": "Open",
      "openHint": "Verstuurd en nog in te vullen.",
      "expiredHint": "De invultermijn is verstreken zonder invulling. Opnieuw sturen heropent de uitnodiging.",
      "moreDetail": "Meer: wat nog moet uitgaan en wat niet doorgaat",
      "lessDetail": "Minder tonen",
      "toSend": "Moet nog uit",
      "toSendHint": "Nog niet verstuurd: gepland, in afwachting van presentie, in afwachting van een definitieve afronding, of vastgehouden tijdens een pauze.",
      "notGoingAhead": "Gaat niet door",
      "notGoingAheadHint": "Ingetrokken of niet meer te versturen, met de reden erbij."
    },
    "state": {
      "waiting": "Wacht op verzending",
      "held": "Ligt klaar",
      "waiting_for_attendance": "Wacht op presentie",
      "waiting_for_completion": "Wacht tot de afronding definitief is",
      "sent": "Verstuurd",
      "submitted": "Ingevuld",
      "expired": "Verlopen",
      "cancelled": "Ingetrokken",
      "recipient_inactive": "Ontvanger niet actief",
      "waitingReady": "Staat klaar om te versturen"
    },
    "reason": {
      "completion_withdrawn": "Afronding ingetrokken",
      "condition_not_met": "Voorwaarde niet gehaald",
      "pause_declined": "Niet opgepakt na de pauze",
      "archived": "Toewijzing gearchiveerd",
      "recipient_inactive": "Ontvanger niet actief",
      "session_removed": "Bijeenkomst verwijderd",
      "occurrence_cancelled": "Uitvoering geannuleerd",
      "enrollment_cancelled": "Inschrijving geannuleerd",
      "unknown": "Onbekende reden"
    },
    "list": {
      "title": "Uitnodigingen",
      "loadError": "De uitnodigingen konden niet geladen worden.",
      "empty": "Er zijn nog geen uitnodigingen.",
      "column": {
        "respondent": "Ontvanger",
        "state": "Stand",
        "sent": "Verstuurd",
        "expires": "Verloopt",
        "reminded": "Laatste herinnering",
        "actions": "Acties"
      },
      "erased": "Verwijderde gebruiker",
      "anonymousRespondent": "Anoniem",
      "scheduled": "Gepland op {date}",
      "submittedOn": "Ingevuld op {date}",
      "withdrawnOn": "{reason}, op {date}",
      "cycle": "Ronde {cycle}",
      "notYet": "Nog niet",
      "waitingUntil": "Gaat uit op {date}",
      "waitingNextRound": "Gaat uit bij de volgende verzendronde",
      "sendingOff": "Verzenden staat uit voor deze omgeving; hij gaat uit zodra het weer aan staat",
      "emptyFiltered": "Geen uitnodigingen in de groep ‘{name}’."
    },
    "actions": {
      "remind": "Nu herinneren",
      "remindNamed": "{name} nu herinneren",
      "resend": "Opnieuw sturen",
      "resendNamed": "Opnieuw sturen naar {name}",
      "reminded": "Er staat een herinnering klaar voor {name}.",
      "resent": "Er staat een nieuwe link klaar voor {name}.",
      "reopened": "Er staat een nieuwe link klaar voor {name}. De uitnodiging was verlopen en is heropend tot {date}; eerdere links blijven dicht.",
      "resentInApp": "Er staat een mail naar Mijn vragenlijsten klaar voor {name}.",
      "reopenedInApp": "Er staat een mail naar Mijn vragenlijsten klaar voor {name}. De uitnodiging was verlopen en is heropend tot {date}."
    },
    "filter": {
      "active": "Filter: {name}",
      "clear": "Filter wissen: {name}"
    },
    "remindOpen": {
      "open": "Iedereen die nog open staat herinneren",
      "title": "Iedereen herinneren die nog open staat",
      "body_one": "Er staat {count} uitnodiging open. Wie nog niet heeft ingevuld, krijgt een herinnering: met een nieuwe link, of met het adres in Mijn vragenlijsten als de vragenlijst alleen in de app opengaat. Een eerder verstuurde link blijft werken. Wie kort geleden al een herinnering kreeg, wordt overgeslagen.",
      "body_other": "Er staan {count} uitnodigingen open. Wie nog niet heeft ingevuld, krijgt een herinnering: met een nieuwe link, of met het adres in Mijn vragenlijsten als de vragenlijst alleen in de app opengaat. Een eerder verstuurde link blijft werken. Wie kort geleden al een herinnering kreeg, wordt overgeslagen.",
      "confirm": "Herinneringen versturen",
      "nothingOpen": "Er staat nu geen uitnodiging open om aan te herinneren.",
      "done_one": "{count} herinnering klaargezet.",
      "done_other": "{count} herinneringen klaargezet.",
      "previewWill_one": "{count} herinnering gaat uit.",
      "previewWill_other": "{count} herinneringen gaan uit.",
      "previewSkipped_one": "{count} overgeslagen ({reason}).",
      "previewSkipped_other": "{count} overgeslagen ({reason}).",
      "daysAgo_one": "minder dan {count} dag geleden uitgenodigd",
      "daysAgo_other": "minder dan {count} dagen geleden uitgenodigd",
      "skip": {
        "reminded_recently": "Kort geleden al herinnerd: {count}",
        "too_soon_after_send": "Nog te kort geleden uitgenodigd: {count}",
        "mail_on_its_way": "Er was al een mail onderweg: {count}",
        "recipient_inactive": "Ontvanger niet actief: {count}",
        "no_address": "Geen e-mailadres: {count}",
        "not_queued": "Mail kon niet klaargezet worden: {count}",
        "closed": "Intussen ingevuld, ingetrokken of verlopen: {count}"
      }
    },
    "openResults": "Resultaten bekijken"
  },
  "auditLog": {
    "heading": "Logboek",
    "intro": "Wie heeft wat wanneer gewijzigd. Filter per kolom; er staat geen filter aan, dus je ziet standaard alles, nieuwste eerst.",
    "export": "Exporteren (CSV)",
    "empty": "Er staat nog niets in het logboek.",
    "emptyFiltered": "Geen regels die voldoen aan deze filters.",
    "filterError": "Dit filter kan niet worden toegepast. Pas het aan en probeer het opnieuw.",
    "pagination": "Paginering logboek",
    "prev": "Vorige",
    "next": "Volgende",
    "pageOf": "Pagina {page} van {pages}",
    "diffShow": "Details",
    "diffHide": "Verbergen",
    "diffBefore": "Oude waarde",
    "diffAfter": "Nieuwe waarde",
    "diffContext": "Gegevens",
    "badge": {
      "bcs": "namens BCS Learning"
    },
    "cols": {
      "when": "Wanneer",
      "category": "Categorie",
      "action": "Handeling",
      "actor": "Wie",
      "target": "Waarop",
      "detail": "Detail"
    },
    "filters": {
      "from": "Vanaf datum",
      "to": "Tot en met datum",
      "category": "Categorie",
      "categoryAll": "Alle categorieën",
      "action": "Handeling",
      "actionPlaceholder": "Zoek op handeling",
      "actor": "Persoon",
      "actorAll": "Alle personen",
      "bcsOnly": "Alleen handelingen namens BCS Learning",
      "clearAll": "Alle filters wissen",
      "none": "Deze kolom heeft geen filter",
      "targetActive": "Je ziet de geschiedenis van één onderdeel. Wis de filters om het hele logboek te zien."
    },
    "categories": {
      "inschrijvingen": "Inschrijvingen",
      "catalogus": "Catalogus",
      "rechten": "Rechten",
      "berichten": "Berichten",
      "inloggen": "Inloggen",
      "instellingen": "Instellingen",
      "organisatie": "Organisatie",
      "beveiliging": "Beveiliging",
      "overig": "Overig"
    },
    "diffField": "Veld",
    "redacted": "verborgen",
    "reference": {
      "erasedUser": "Verwijderde gebruiker",
      "erasedExternalPerson": "Verwijderde externe persoon",
      "removed": "verwijderd"
    },
    "actorSystem": "Systeem",
    "actorSystemNamed": "Systeem ({name})",
    "history": {
      "heading": "Geschiedenis",
      "openFullLog": "Bekijk in het logboek",
      "empty": "Hier is nog niets over vastgelegd.",
      "notFound": "Dit onderdeel bestaat hier niet (meer), dus er is geen geschiedenis te tonen.",
      "pagination": "Paginering geschiedenis",
      "show": "Geschiedenis",
      "enrollmentTitle": "Geschiedenis van de inschrijving van {name}"
    },
    "archive": {
      "periodArchived": "Deze periode is gearchiveerd.",
      "periodArchivedHint": "Deze regels staan niet meer in het logboek zelf maar in het archief. Exporteer de maand, of haal hem tijdelijk terug om hem hier te doorzoeken.",
      "olderArchived": "Het logboek tot en met {month} is gearchiveerd. Kies een periode in de kolom Wanneer om die te bekijken of terug te halen.",
      "monthLabel": "{month} ({rows} regels)",
      "export": "Exporteren",
      "restore": "Haal deze periode terug",
      "restoring": "{month} wordt teruggehaald…",
      "restored": "{month} is teruggehaald tot {date}.",
      "failed": "Terughalen van {month} is mislukt: het archiefbestand klopte niet of was niet te lezen.",
      "restoreError": "Terughalen kon niet worden gestart. Probeer het opnieuw.",
      "noRight": "Terughalen of exporteren kan alleen iemand met het recht om het logboek te exporteren.",
      "historyArchived": "Oudere geschiedenis is gearchiveerd.",
      "historyRestored": "Oudere geschiedenis is teruggehaald tot {date}."
    },
    "fields": {
      "title": "Titel",
      "summary": "Samenvatting",
      "description": "Omschrijving",
      "status": "Status",
      "type": "Soort",
      "name": "Naam",
      "category": "Categorie",
      "first_name": "Voornaam",
      "last_name": "Achternaam",
      "email": "E-mailadres",
      "phone": "Telefoonnummer",
      "locale": "Taal",
      "external_id": "Externe sleutel",
      "attributes": "Aanvullende gegevens",
      "manager_user_id": "Leidinggevende",
      "hire_date": "Datum in dienst",
      "end_date": "Datum uit dienst",
      "account_valid_from": "Account geldig vanaf",
      "account_valid_until": "Account geldig tot",
      "last_login_at": "Laatst ingelogd",
      "profile_picture_url": "Profielfoto",
      "password": "Wachtwoord",
      "user_id": "Deelnemer",
      "learning_activity_id": "Leeractiviteit",
      "occurrence_id": "Uitvoering",
      "waitlist_position": "Plek op de wachtlijst",
      "cancelled_at": "Geannuleerd op",
      "cancel_reason": "Toelichting bij de annulering",
      "cancel_reason_id": "Reden van annulering",
      "cancel_requested_at": "Annulering aangevraagd op",
      "transferred_from_enrollment_id": "Verplaatst vanaf inschrijving",
      "offer_expires_at": "Aanbod verloopt op",
      "composition": "Samenstelling",
      "tracking_mode": "Voortgang bijhouden",
      "source_kind": "Bron",
      "source_file": "Bronbestand",
      "completion_rule": "Afrondingsregel",
      "completion_threshold": "Afrondingspercentage",
      "duration": "Duur",
      "duration_minutes": "Duur (minuten)",
      "language": "Taal",
      "labels": "Trefwoorden",
      "tags": "Trefwoorden",
      "visibility_mode": "Zichtbaarheid",
      "access_group_id": "Toegangsgroep",
      "allow_anonymous": "Anoniem toegankelijk",
      "max_enrollments": "Aantal inschrijvingen",
      "max_waitlist_registrations": "Aantal wachtlijst-registraties",
      "approval_flow_id": "Goedkeuringsketen",
      "waitlist_enabled": "Wachtlijst",
      "waitlist_promotion_mode": "Toewijzing bij vrije plek",
      "offer_window_hours": "Aanbod-venster (uren)",
      "waitlist_cap": "Plafond wachtlijst",
      "cancellation_deadline": "Annuleringsdeadline",
      "cancel_before": "Annuleren vóór de deadline",
      "cancel_after": "Annuleren na de deadline",
      "min_participants": "Min. deelnemers",
      "max_participants": "Max. deelnemers",
      "enrollment_deadline": "Inschrijfdeadline",
      "delivery_mode": "Leveringsvorm",
      "timezone": "Tijdzone",
      "waitlist_enabled_by_default": "Wachtlijst standaard aan",
      "waitlist_offer_window_hours": "Aanbod-venster (uren)",
      "cancel_before_default": "Standaard: annuleren vóór de deadline",
      "cancel_after_default": "Standaard: annuleren na de deadline",
      "visibility_mode_default": "Standaard zichtbaarheid",
      "approval_flow_id_default": "Standaard goedkeuringsketen",
      "max_enrollments_default": "Standaard aantal inschrijvingen",
      "max_waitlist_registrations_default": "Standaard aantal wachtlijst-registraties",
      "enabled": "Aan",
      "frequency": "Frequentie",
      "send_time": "Verzendtijd",
      "send_weekday": "Verzenddag",
      "response_window_days": "Antwoordtermijn (dagen)",
      "scale_min": "Laagste schaalwaarde",
      "scale_max": "Hoogste schaalwaarde",
      "anonymity_floor": "Anonimiteitsdrempel",
      "reminder_min_days_after_send": "Herinnering na (dagen)",
      "enrollment_months": "Bewaartermijn inschrijvingen (maanden)",
      "attendance_months": "Bewaartermijn presentie (maanden)",
      "attempt_months": "Bewaartermijn pogingen (maanden)",
      "completion_months": "Bewaartermijn afrondingen (maanden)",
      "qualification_months": "Bewaartermijn kwalificaties (maanden)",
      "certificate_months": "Bewaartermijn certificaten (maanden)",
      "evaluation_response_months": "Bewaartermijn evaluatie-antwoorden (maanden)",
      "evaluation_response_action": "Na de termijn met evaluatie-antwoorden",
      "import_raw_data_months": "Bewaartermijn importgegevens (maanden)"
    }
  },
  "approvalsOverview": {
    "heading": "Alle goedkeuringen",
    "intro": "Elke goedkeuring die nog openstaat in deze omgeving, met de behandelaar erbij en hoe lang hij al wacht. Blijft er iets liggen, dan kun je het overdragen of zelf afhandelen.",
    "empty": "Er staat op dit moment niets open.",
    "cols": {
      "applicant": "Aanvrager",
      "course": "Activiteit",
      "assignee": "Behandelaar",
      "waiting": "Wacht al"
    },
    "kind": {
      "enrollment": "Inschrijving",
      "cancellation": "Annulering",
      "external_request": "Externe opleiding",
      "other": "Overig"
    },
    "unknownApplicant": "Onbekend",
    "noAssignee": "Bij niemand",
    "waitingDays_one": "{count} dag",
    "waitingDays_other": "{count} dagen",
    "remind": "Herinneren",
    "reminded": "Herinnerd",
    "remindFailed": "De herinnering is niet verstuurd. Mogelijk is de aanvraag intussen afgehandeld of ingetrokken.",
    "move": "Overdragen",
    "approve": "Goedkeuren",
    "reject": "Afwijzen",
    "moveTitle": "Goedkeuring overdragen",
    "moveBody": "De aanvraag van {applicant} ligt nu bij {assignee}. Kies wie hem overneemt.",
    "moveConfirm": "Overdragen",
    "movePickerLabel": "Nieuwe behandelaar",
    "movePickerPlaceholder": "Zoek op naam of e-mailadres",
    "moveFailed": "Overdragen is niet gelukt.",
    "rejectTitle": "Aanvraag afwijzen",
    "rejectComment": "Toelichting voor de aanvrager",
    "decideFailed": "De beslissing is niet doorgekomen. Mogelijk is de aanvraag intussen al afgehandeld of ingetrokken."
  },
  "approvalFlows": {
    "heading": "Goedkeuringsflows",
    "intro": "Een goedkeuringsflow is een keten van goedkeurders. Je kiest per leeractiviteit welke flow geldt.",
    "new": "Nieuwe flow",
    "empty": "Er zijn nog geen goedkeuringsflows.",
    "noSteps": "geen stappen",
    "stepCount": "{n} stap(pen)",
    "platformBadge": "Standaard",
    "ownBadge": "Eigen",
    "platformReadOnly": "Dit is een standaardflow van het platform. Je kunt hem kiezen en bekijken, maar niet wijzigen.",
    "filterOwner": "Eigenaar",
    "stepsHeading": "Stappen (in volgorde)",
    "stepN": "Stap {n}",
    "addStep": "Stap toevoegen",
    "choose": "Kies...",
    "singlePerson": "Deze route levert altijd één persoon op.",
    "deadlineEscalates": "Verloopt de termijn, dan komt er een extra stap voor HR bij.",
    "dependsOnApplicant": "Wie dit is, hangt af van de aanvrager.",
    "nobodyFallsBackToHr": "Niemand gevonden — valt terug op HR.",
    "deleteTitle": "Flow verwijderen",
    "deleteBody": "Weet je zeker dat je {name} wilt verwijderen?",
    "deleteFailed": "Verwijderen is niet gelukt. Wordt deze flow nog gebruikt?",
    "saveFailed": "Opslaan is niet gelukt. Controleer de stappen.",
    "cols": {
      "name": "Naam",
      "chain": "Keten"
    },
    "owner": {
      "all": "Alles",
      "platform": "Standaard (platform)",
      "own": "Eigen flows"
    },
    "mode": {
      "any": "Één akkoord is genoeg",
      "all": "Allen moeten akkoord"
    },
    "fields": {
      "name": "Naam",
      "description": "Omschrijving",
      "expiresAfterDays": "Beslistermijn (dagen)",
      "expiresAfterDaysHint": "Laat leeg om een aanvraag nooit te laten vervallen. Met een termijn vervalt een aanvraag die niemand behandelt, en komt de plek vrij voor iemand anders.",
      "warnDaysBefore": "Waarschuwen (dagen vooraf)",
      "warnDaysBeforeHint": "Zoveel dagen vóór het vervallen krijgt de aanvrager bericht, zodat hij zijn goedkeurder nog kan aanstoten.",
      "route": "Wie beslist",
      "role": "Rol",
      "orgLevel": "Niveau",
      "orgField": "Rolveld",
      "decisionMode": "Bij meerdere personen",
      "deadline": "Beslistermijn",
      "deadlineHours": "Uren",
      "person": "Persoon"
    },
    "route": {
      "own_manager": "Eigen manager",
      "org_role": "Rol op een org-eenheid",
      "tenant_role": "Rol in de omgeving",
      "fixed_person": "Vaste persoon"
    },
    "settingsHeading": "Goedkeuringen",
    "settingsIntro": "Kies welke goedkeuringsflow standaard wordt voorgevuld bij een nieuwe leeractiviteit.",
    "settingsNone": "Geen goedkeuring — direct inschrijven",
    "defaultLabel": "Standaard voor nieuwe activiteiten",
    "defaultHint": "Alleen een voorvulling: bestaande activiteiten veranderen niet mee, en een activiteit waar bewust geen goedkeuring staat wordt nooit overruled.",
    "manageLink": "Goedkeuringsflows beheren",
    "editor": {
      "inspector": "Inspecteur",
      "selectHint": "Selecteer een stap in de keten om hem te bewerken, of voeg een stap toe.",
      "removeStep": "Verwijder stap",
      "moveUp": "Stap eerder in de keten",
      "moveDown": "Stap later in de keten"
    },
    "node": {
      "request": "Aanvraag",
      "requestTitle": "Iemand vraagt goedkeuring",
      "outcome": "Uitkomst",
      "outcomeTitle": "Goedgekeurd",
      "allOf": "allen akkoord",
      "deadline": "{n} uur"
    }
  },
  "workflows": {
    "heading": "Workflows",
    "intro": "Automatiseer acties op gebeurtenissen: trigger → conditie → stappen.",
    "new": "Nieuwe workflow",
    "empty": "Nog geen workflows.",
    "on": "Aan",
    "off": "Uit",
    "system": "Standaard",
    "custom": "Eigen",
    "locked": "Vergrendeld",
    "lockedHint": "Door het platform vergrendeld — je kunt 'm alleen inzien, niet uitschakelen, bewerken of verwijderen.",
    "unavailable": "Overgeslagen",
    "unavailableHint": "Deze workflow gebruikt iets dat in deze omgeving niet beschikbaar is en wordt daarom overgeslagen. Hij blijft bewaard.",
    "unavailableNotice": "Een of meer workflows worden overgeslagen: ze gebruiken iets dat in deze omgeving niet beschikbaar is. Ze blijven bewaard.",
    "systemHint": "Door het platform geleverde standaard-workflow. Uitschakelen kan; verwijderen niet (bewerken maakt er een eigen kopie van).",
    "confirmDelete": "Workflow verwijderen?",
    "confirmDeleteBody": "Dit verwijdert \"{name}\" definitief.",
    "cols": {
      "name": "Naam",
      "trigger": "Trigger",
      "enabled": "Actief",
      "origin": "Type"
    },
    "fields": {
      "name": "Naam",
      "key": "Sleutel",
      "keyHint": "Stabiele, unieke sleutel binnen je tenant (kleine letters, streepjes).",
      "trigger": "Trigger",
      "description": "Omschrijving",
      "enabled": "Direct inschakelen"
    },
    "schedule": {
      "heading": "Trigger-timing",
      "offsetDays": "Dagen-offset",
      "offsetHint": "Negatief = vóór de datum (bijv. -7 voor pre-boarding), 0 = op de dag, positief = erna.",
      "offsetHintAfter": "Aantal dagen na de inschrijving. 0 = dezelfde dag, 7 = een week later.",
      "time": "Tijdstip (tenant-tijdzone)"
    },
    "editor": {
      "inspector": "Inspecteur",
      "selectHint": "Selecteer een blok om het te bewerken, of voeg een stap toe.",
      "actionTitle": "Actie",
      "actionKind": "Soort actie",
      "actionNoSettings": "Deze actie heeft geen instellingen.",
      "approvalTitle": "Goedkeuring",
      "addAction": "Actie",
      "addApproval": "Goedkeuring",
      "removeStep": "Verwijder blok",
      "addMail": "+ Mail",
      "subject": "Onderwerp",
      "body": "Inhoud",
      "dueHours": "Verloopt na (uren)",
      "saved": "Opgeslagen.",
      "lockedNotice": "Deze workflow is door het platform vergrendeld. Je kunt 'm inzien, maar niet wijzigen.",
      "systemNotice": "Dit is een standaard-workflow. Zodra je de definitie wijzigt en opslaat, wordt het een eigen kopie (los van de globale set).",
      "recipient": {
        "label": "Ontvanger",
        "subjectUser": "De betrokken gebruiker",
        "fixed": "Vast adres",
        "orgUnitRole": "Org-unit-rol",
        "address": "E-mailadres",
        "orgUnitManager": "Manager van de org-unit",
        "contentOwner": "Beheerder van de training",
        "occurrenceTrainers": "Trainer(s) van de uitvoering"
      },
      "unit": {
        "label": "Org-unit",
        "subjectUnit": "Unit van de gebruiker",
        "orgRoot": "Organisatie (root)",
        "fieldKey": "Veld-sleutel (bv. ceo, teamlead)"
      },
      "branch": {
        "on_approve": "Bij goedkeuren",
        "on_reject": "Bij afwijzen",
        "on_timeout": "Bij uitblijven (timeout)"
      },
      "node": {
        "trigger": "Trigger",
        "action": "Actie",
        "approval": "Goedkeuring",
        "email": "E-mail",
        "digestLine": "Regel op de verzamelmail",
        "confirmEnrollment": "Inschrijving bevestigen",
        "rejectEnrollment": "Inschrijving afwijzen",
        "confirmCancellation": "Annulering bevestigen",
        "rejectCancellation": "Annulering afwijzen",
        "materializeExternalRequest": "Externe opleiding vastleggen",
        "rejectExternalRequest": "Aanvraag externe opleiding afwijzen",
        "approvalTitle": "Beoordeling"
      }
    },
    "help": {
      "link": "Uitleg",
      "backToList": "Terug naar workflows",
      "inEditor": "Zo ziet het eruit in de editor",
      "title": "Hoe werken workflows?",
      "intro": "Met workflows automatiseer je acties op gebeurtenissen in het platform. Elke workflow volgt hetzelfde patroon: een trigger start 'm, optionele condities filteren wanneer hij echt loopt, en stappen voeren acties uit — bijvoorbeeld een mail sturen of een goedkeuring vragen.",
      "conceptsHeading": "De bouwstenen",
      "concepts": {
        "trigger": {
          "title": "Trigger",
          "body": "De gebeurtenis die de workflow start, bijvoorbeeld 'Gebruiker aangemaakt' of 'Inschrijving aangevraagd'. Elke workflow heeft precies één trigger."
        },
        "scheduling": {
          "title": "Timing bij datum-triggers",
          "body": "Datum-triggers (in dienst, uit dienst, account-geldigheid) vuren op een dag die je zelf bepaalt: kies hoeveel dagen vóór of ná de datum (bijv. 7 dagen vóór indienst voor pre-boarding, of 0 op de dag zelf) en op welk tijdstip (per 15 minuten, in de tijdzone van de tenant). Zo kun je 's ochtends een welkomstmail sturen en 's middags een reminder. Een nieuwe workflow werkt nooit met terugwerkende kracht: hij vuurt alleen voor datums die op of ná het aanmaken vallen, dus wie al in dienst is krijgt 'm niet alsnog."
        },
        "condition": {
          "title": "Conditie (optioneel)",
          "body": "Een filter dat bepaalt of de workflow echt loopt, bijvoorbeeld alleen als een inschrijving zelf-service is. Geen conditie betekent: altijd uitvoeren."
        },
        "steps": {
          "title": "Stappen",
          "body": "Wat er gebeurt, in volgorde. Een stap is een actie (iets doen) of een goedkeuring (wachten op een beslissing van iemand)."
        },
        "actionEmail": {
          "title": "Actie: e-mail",
          "body": "Stuurt automatisch een mail. Je kiest de ontvanger, het onderwerp en de inhoud. In de tekst kun je variabelen gebruiken zoals {tpl}, die per ontvanger worden ingevuld."
        },
        "approval": {
          "title": "Goedkeuring",
          "body": "Pauzeert de workflow tot iemand goedkeurt of afwijst. Je stelt in wie beslist, binnen hoeveel uur, en wat er gebeurt bij goedkeuren, afwijzen of uitblijven (timeout)."
        },
        "recipient": {
          "title": "Ontvanger via org-rol",
          "body": "'Naar wie' een mail of goedkeuring gaat is geen vaste persoon, maar een verwijzing naar een rol-veld op een org-unit (bv. teamlead of ceo), relatief tot de betrokken gebruiker. Voorwaarde: dat veld is ingevuld op het juiste niveau in de organisatiestructuur."
        },
        "enabling": {
          "title": "In- en uitschakelen",
          "body": "Een workflow draait pas als hij aanstaat. Standaard-workflows die het platform levert kun je aan- of uitzetten; zodra je de stappen wijzigt en opslaat, wordt het een eigen kopie los van de globale set."
        },
        "locked": {
          "title": "Vergrendelde workflows",
          "body": "Sommige workflows zijn door het platform vergrendeld (slot-icoon): die kun je als beheerder wél inzien, maar niet uitschakelen, bewerken of verwijderen. Superadmins beheren deze centraal en zetten wijzigingen met 'Sync naar tenants' door."
        }
      },
      "examplesHeading": "Voorbeelden",
      "resultLabel": "Resultaat",
      "examples": {
        "welcome": {
          "title": "Welkomstmail bij een nieuwe gebruiker",
          "scenario": "Trigger 'Gebruiker aangemaakt' → actie e-mail naar de betrokken gebruiker, met onderwerp 'Welkom, {tpl}'. Wil je in plaats daarvan HR informeren? Kies dan als ontvanger een vast adres, bijvoorbeeld hr@bedrijf.nl.",
          "result": "Elke nieuwe gebruiker krijgt automatisch een welkomstmail, zonder dat een beheerder iets hoeft te doen.",
          "flow": {
            "trigger": "Gebruiker aangemaakt",
            "action": "E-mail versturen",
            "actionSub": "naar de gebruiker"
          }
        },
        "approval": {
          "title": "Manager-goedkeuring bij zelf-inschrijving",
          "scenario": "Trigger 'Inschrijving aangevraagd' → conditie 'zelf-service' → goedkeuring door de teamlead van de eigen unit (verloopt na 72 uur). Bij goedkeuren: bevestigingsmail naar de gebruiker. Bij afwijzen: afwijzingsmail. Bij uitblijven: een herinnering.",
          "result": "Zelf-inschrijvingen lopen eerst langs de teamlead voordat ze definitief worden, met automatische opvolging.",
          "flow": {
            "trigger": "Inschrijving aangevraagd",
            "condition": "Alleen bij zelf-inschrijving",
            "approval": "Goedkeuring teamlead",
            "approvalSub": "verloopt na 72 uur",
            "onApprove": "Bevestigingsmail",
            "onReject": "Afwijzingsmail",
            "onTimeout": "Herinnering"
          }
        }
      }
    }
  },
  "platformWorkflows": {
    "heading": "Platform-workflows",
    "intro": "Globale workflows die naar alle tenants gekloond worden. Vergrendelde workflows kunnen tenant-beheerders niet wijzigen.",
    "new": "Nieuwe platform-workflow",
    "empty": "Nog geen platform-workflows.",
    "sync": "Sync naar tenants",
    "syncStarted": "Sync gestart — wijzigingen worden op de achtergrond naar alle tenants doorgevoerd.",
    "keyHint": "Stabiele, unieke sleutel binnen het platform (kleine letters, streepjes).",
    "lockedField": "Vergrendelen (beheerders kunnen 'm niet wijzigen)",
    "lockedHint": "Een vergrendelde workflow is bij tenants read-only; ook de aan/uit-stand bepaalt het platform.",
    "lockedYes": "Vergrendeld",
    "lockedNo": "Open",
    "cols": {
      "locked": "Toegang"
    },
    "confirmDelete": "Platform-workflow verwijderen?",
    "confirmDeleteBody": "Dit verwijdert \"{name}\" uit de platform-set. Al gekloonde tenant-kopieën blijven bestaan.",
    "editorNotice": "Wijzigingen hier bereiken bestaande tenants pas na een sync; nieuwe tenants krijgen de huidige stand bij aanmaken.",
    "sync_status": {
      "col": "Uitrol",
      "none": "Geen tenants",
      "notRolledOut": "Niet uitgerold",
      "coverage": "{synced}/{total} tenants",
      "inSync": "Actueel",
      "outdated": "{count} verouderd",
      "outdatedHint": "Deze tenants draaien nog een oudere versie — sync om ze bij te werken.",
      "overridden": "{count} aangepast",
      "overriddenHint": "Deze tenants hebben de workflow zelf aangepast; een sync laat die ongemoeid.",
      "syncOne": "Sync",
      "syncOneHint": "Sync alleen deze workflow naar alle tenants"
    }
  },
  "approvals": {
    "heading": "Goedkeuringen",
    "intro": "Openstaande goedkeuringen die op jouw beslissing wachten.",
    "empty": "Geen openstaande goedkeuringen.",
    "due": "Verloopt",
    "approve": "Goedkeuren",
    "reject": "Afwijzen",
    "unknownWorkflow": "Workflow",
    "rejectTitle": "Afwijzen?",
    "rejectBody": "Je wijst \"{name}\" af.",
    "reason": "Reden (optioneel)",
    "count": "{count} te doen",
    "nothingToDo": "Niets te doen.",
    "applicant": "Aanvrager",
    "noIndependentTitle": "Geen onafhankelijke beoordelaar: {name} vroeg dit zelf aan",
    "noIndependentBody": "Voeg een beoordelaar toe aan de keten, of laat een beheerder met het recht om aanvragen te beheren hem afhandelen.",
    "cannotDecideOwn": "Over je eigen aanvraag beslis je niet.",
    "course": "Cursus",
    "bulk": {
      "selectAll": "Alles selecteren",
      "selectRow": "Selecteer \"{name}\"",
      "selectedCount": "{count} geselecteerd",
      "approveSelected": "Selectie goedkeuren",
      "rejectSelected": "Selectie afwijzen",
      "confirmApproveTitle": "Selectie goedkeuren?",
      "confirmApproveBody": "Je keurt {count} aanvragen in één keer goed. De aanvragers krijgen hier bericht van.",
      "confirmRejectTitle": "Selectie afwijzen?",
      "confirmRejectBody": "Je wijst {count} aanvragen in één keer af. De reden die je invult geldt voor alle afgewezen aanvragen.",
      "resultSummary": "{decided} van {requested} afgehandeld.",
      "outcome": {
        "already_handled": "{count} waren al afgehandeld.",
        "forbidden": "{count} stonden niet op jouw naam.",
        "not_found": "{count} bestonden niet meer."
      }
    },
    "kind": {
      "enrollment": "Inschrijvingen",
      "cancellation": "Annuleringen",
      "external_request": "Externe opleiding",
      "other": "Overig"
    }
  },
  "mailOutbox": {
    "title": "Mail-outbox",
    "empty": "Nog geen mail verzonden.",
    "forwardTo": "Doorsturen naar gebruikers",
    "forwardPlaceholder": "Kies één of meer gebruikers…",
    "filterStatus": "Filter op status",
    "filterAll": "Alle statussen",
    "retentionNotice": "Je ziet hier de e-mails van de afgelopen {days} dagen.",
    "recipients_one": "{count} ontvanger",
    "recipients_other": "{count} ontvangers",
    "openedOf": "{opened} / {total}",
    "expand": "Ontvangers tonen",
    "collapse": "Ontvangers verbergen",
    "batchMore": "Eerste {shown} van {total} ontvangers — verfijn met zoeken of het statusfilter.",
    "cols": {
      "status": "Status",
      "to": "Ontvanger",
      "subject": "Onderwerp",
      "scheduled": "Gepland / verzonden",
      "opens": "Geopend"
    },
    "status": {
      "scheduled": "Gepland",
      "sending": "Wordt verzonden",
      "sent": "Verzonden",
      "failed": "Mislukt",
      "cancelled": "Ingetrokken",
      "suppressed": "Niet verzonden"
    },
    "actions": {
      "view": "Bekijken",
      "cancel": "Intrekken",
      "resend": "Opnieuw",
      "forward": "Doorsturen"
    },
    "detail": {
      "title": "Mail bekijken",
      "recipient": "Ontvanger",
      "body": "Inhoud",
      "attachments": "Bijlagen",
      "noBody": "Voor deze mail is geen inhoud bewaard.",
      "error": "Foutmelding:",
      "attachmentNotAllowed": "Je kunt deze bijlage niet openen. Alleen wie het bericht verstuurde of ontving mag dat."
    }
  },
  "mailTemplates": {
    "title": "Mail-teksten",
    "intro": "Pas de teksten van systeem-mails aan voor jouw organisatie. De standaardteksten zijn platform-beheerd; jij legt per taal alleen je afwijkingen vast.",
    "searchPlaceholder": "Zoek op naam of context…",
    "empty": "Geen mail-templates gevonden.",
    "edit": "Bewerken",
    "notTranslated": "Deze taal is nog niet vertaald. Ontvangers krijgen de tekst in de terugvaltaal — hieronder zie je die tekst.",
    "badge": {
      "locked": "Vergrendeld",
      "customized": "Aangepast",
      "global": "Standaard"
    },
    "preview": {
      "title": "Voorbeeld",
      "subject": "Onderwerp",
      "error": "Voorbeeld kon niet worden opgebouwd."
    },
    "tags": {
      "intro": "Klik een tag om 'm op de cursor in te voegen.",
      "scope": {
        "context": "Context",
        "global": "Algemeen",
        "link": "Links"
      }
    },
    "editor": {
      "back": "Terug naar overzicht",
      "lockedNote": "Dit template is vergrendeld door het platform en kan niet worden aangepast.",
      "footerHint": "Deze tekst verschijnt als footer onderaan elke e-mail. Laat leeg om geen footer te tonen.",
      "lockedBody": "De inhoud is te zien in het voorbeeld hiernaast.",
      "subject": "Onderwerp",
      "preheader": "Preheader",
      "preheaderHint": "Korte samenvatting die sommige mailclients naast het onderwerp tonen.",
      "body": "Inhoud",
      "save": "Opslaan",
      "saved": "Opgeslagen.",
      "saveErrorTitle": "De tekst bevat fouten",
      "reset": "Terugzetten naar standaard",
      "resetLoaded": "Standaardtekst geladen — klik Opslaan om te bevestigen.",
      "customized": "Aangepast voor jouw organisatie.",
      "testTitle": "Test-mail versturen",
      "testTo": "Naar e-mailadres",
      "testSend": "Verstuur test",
      "testOk": "Test-mail verstuurd."
    }
  },
  "centralMailTemplates": {
    "title": "Globale mail-teksten",
    "intro": "Beheer de standaard-teksten van systeem-mails per taal. Dit zijn de teksten die elke tenant erft; vergrendel een template om per-tenant aanpassing te blokkeren.",
    "searchPlaceholder": "Zoek op naam of context…",
    "empty": "Geen mail-templates gevonden.",
    "badge": {
      "locked": "Vergrendeld",
      "missing": "Onvolledig",
      "customized": "{count} aangepast"
    },
    "customizedTooltip": "Tenants met een eigen tekst:",
    "notTranslated": "Deze taal is nog niet vertaald. Ontvangers krijgen de tekst in de terugvaltaal — klik op Bewerken om de vertaling toe te voegen.",
    "edit": "Bewerken",
    "editor": {
      "back": "Terug naar overzicht"
    },
    "locked": "Vergrendeld voor tenants",
    "footerHint": "Deze tekst verschijnt als footer onderaan elke e-mail. Laat leeg om geen footer te tonen.",
    "subject": "Onderwerp",
    "preheader": "Preheader",
    "body": "Inhoud",
    "save": "Opslaan",
    "saved": "Opgeslagen.",
    "reset": "Terugzetten naar standaardtekst",
    "resetLoaded": "Standaardtekst geladen — klik Opslaan om te bevestigen.",
    "saveErrorTitle": "De tekst bevat fouten"
  },
  "centralMailOutbox": {
    "title": "Mail-outbox (alle tenants)",
    "intro": "Read-only overzicht van verzonden mail over alle tenants. Inhoud en acties beheer je per tenant.",
    "empty": "Geen mail gevonden.",
    "filterStatus": "Status",
    "allStatuses": "Alle statussen",
    "filterTenant": "Tenant",
    "allTenants": "Alle tenants",
    "cols": {
      "tenant": "Tenant"
    }
  },
  "elearning": {
    "backToCatalog": "Terug naar de catalogus",
    "completion": {
      "completed": "afgerond",
      "incomplete": "nog niet afgerond",
      "unknown": "nog niets doorgegeven"
    },
    "contentHostMissing": "Deze cursus kan nog niet worden geopend: de omgeving mist de host waarvan cursusinhoud wordt uitgeleverd. Meld dit bij de beheerder.",
    "loadError": "We konden deze cursus niet laden.",
    "outdatedVersion": "Deze cursus is bijgewerkt nadat jij begon. Je gaat verder in de versie waarin je bezig was, zodat je niets kwijtraakt. Wil je liever schoon beginnen in de nieuwste versie?",
    "registered": "Geregistreerd: {status}",
    "saveProgress": "Voortgang nu bewaren",
    "score": "score {score}%",
    "start": "Cursus starten",
    "startHint": "De cursus opent hieronder. Je voortgang wordt tussentijds bewaard, dus je kunt later verdergaan waar je was.",
    "startNewestVersion": "Opnieuw beginnen in de nieuwste versie",
    "starting": "De cursus wordt geopend…",
    "anonymous": {
      "fallbackTitle": "E-learning",
      "startHint": "Deze cursus is vrij toegankelijk: je hoeft niet in te loggen om hem te doen.",
      "notRecorded": "Je voortgang en resultaat worden niet bewaard. Wil je dat je afronding meetelt, log dan in en start de cursus vanuit de catalogus.",
      "unavailable": "Deze cursus is niet (meer) vrij toegankelijk. Vraag de beheerder om een nieuwe link, of log in."
    },
    "restartHint": "Je begint deze training opnieuw vanaf het begin.",
    "backToLearningPath": "Terug naar je leerlijn",
    "superseded": {
      "title": "Je begint opnieuw"
    }
  },
  "myQuestionnaires": {
    "title": "Mijn vragenlijsten",
    "description": "Vragenlijsten die voor je openstaan. Je kunt ze hier invullen of via de link in je mail: het is dezelfde vragenlijst.",
    "loading": "Vragenlijsten laden…",
    "loadError": "Je vragenlijsten konden niet worden geladen.",
    "retry": "Opnieuw proberen",
    "emptyTitle": "Er staat niets voor je open",
    "emptyBody": "Staat er een vragenlijst voor je klaar, dan zie je hem hier.",
    "untitled": "Vragenlijst zonder titel",
    "openUntil": "Open tot {date}",
    "back": "Terug naar mijn vragenlijsten",
    "closedTitle": "Deze vragenlijst staat niet meer open",
    "closedBody": "Heb je hem al ingevuld, bijvoorbeeld via de link in je mail, dan is je antwoord bewaard.",
    "submittedBody": "Je antwoorden zijn verstuurd.",
    "testBadge": "Toets",
    "state": {
      "awaiting_grading": "Wacht op nakijken",
      "graded": "Nagekeken"
    },
    "submittedOn": "Ingestuurd op {date}",
    "viewResult": "Bekijk je uitslag",
    "viewResultNamed": "Bekijk je uitslag van {title}",
    "resultHidden": "De uitslag van deze toets wordt niet getoond."
  },
  "myQualifications": {
    "title": "Mijn kwalificaties",
    "description": "Welke kwalificaties je hebt, tot wanneer ze gelden en waarop ze gebaseerd zijn. Wat verlopen is of niet meer geldt, staat in de geschiedenis.",
    "loading": "Kwalificaties laden…",
    "loadError": "Je kwalificaties konden niet worden geladen.",
    "retry": "Opnieuw proberen",
    "emptyTitle": "Je hebt nog geen kwalificaties",
    "emptyBody": "Rond je een training af die een kwalificatie oplevert, dan zie je die hier.",
    "holds": "Geldig",
    "notHolding": "Geldt nu niet",
    "notHoldingBody": "Op dit moment geldt geen enkele registratie van deze kwalificatie.",
    "validUntil": "Geldig tot {date}",
    "openEnded": "Geldig, zonder einddatum",
    "expiresIn_one": "Verloopt over {count} dag",
    "expiresIn_other": "Verloopt over {count} dagen",
    "expiresToday": "Verloopt vandaag",
    "renewalStopped": "Wordt niet verlengd",
    "groundsLabel": "Waarom dit geldt",
    "groundWindowUntil": "tot {date}",
    "groundWindowOpen": "zonder einddatum",
    "originCompletionNamed": "Afronding van {title}",
    "origin": {
      "completion": "Afronding van een training",
      "external_training": "Externe training",
      "self_declared": "Eigen verklaring",
      "administrative": "Administratief vastgelegd"
    },
    "evidence": {
      "trusted": "Automatisch vastgelegd",
      "verifiable": "Voorlopig toegekend, kan achteraf worden gecorrigeerd",
      "declaration": "Op eigen verklaring"
    },
    "history_one": "Geschiedenis ({count} eerdere registratie)",
    "history_other": "Geschiedenis ({count} eerdere registraties)",
    "historyWindow": "{from} tot en met {until}",
    "historyWindowOpen": "Vanaf {from}, zonder einddatum",
    "endedOn": "Beëindigd op {date}",
    "status": {
      "valid": "Geldig",
      "not_yet_valid": "Nog niet ingegaan",
      "expired": "Verlopen",
      "ended_by_choice": "Beëindigd",
      "superseded": "Vervangen",
      "corrected": "Gecorrigeerd",
      "withdrawn": "Ingetrokken",
      "never_valid": "Nooit geldig geweest"
    },
    "reason": {
      "superseded": "Vervangen door een nieuwere registratie",
      "corrected": "Gecorrigeerd: de geldigheid was verkeerd vastgelegd",
      "withdrawn_from_now": "Ingetrokken: vanaf dat moment geldt hij niet meer",
      "never_valid": "Ingetrokken: je hebt hem nooit gehouden"
    }
  },
  "myExternalRequests": {
    "title": "Mijn aanvragen",
    "description": "Je aanvragen voor een opleiding die niet in de catalogus staat, en hoe ver ze zijn.",
    "new": "Nieuwe aanvraag",
    "newTitle": "Nieuwe aanvraag externe opleiding",
    "back": "Terug naar Mijn aanvragen",
    "loading": "Aanvragen laden…",
    "loadError": "Je aanvragen konden niet geladen worden.",
    "retry": "Opnieuw proberen",
    "emptyTitle": "Nog geen aanvragen",
    "emptyBody": "Wil je een opleiding volgen die niet in de catalogus staat? Vraag hem hier aan.",
    "emptyBodyNoTypes": "Er is op dit moment niets om aan te vragen.",
    "noTypesTitle": "Niets om aan te vragen",
    "notFoundTitle": "Aanvraag niet gevonden",
    "notFoundBody": "Deze aanvraag bestaat niet, of hij is niet van jou.",
    "untitled": "Aanvraag zonder titel",
    "continue": "Verder invullen",
    "open": "Bekijken",
    "submittedOn": "ingediend op {date}",
    "withdrawnOn": "ingetrokken op {date}",
    "rejectedTitle": "Je aanvraag is afgewezen",
    "rejectedNoComment": "Er is geen toelichting gegeven.",
    "runningNotice": "Je aanvraag is goedgekeurd. De opleiding staat op je naam.",
    "awaitingManagement": "In behandeling — wacht op een besluit van beheer",
    "withdraw": "Aanvraag intrekken",
    "withdrawTitle": "Aanvraag intrekken?",
    "withdrawBody": "Er is nog niet beslist over je aanvraag. Trek je hem in, dan wordt hij niet beoordeeld. Dit kun je niet ongedaan maken.",
    "discardTitle": "Concept weggooien?",
    "discardBody": "Het concept en alles wat je hebt ingevuld verdwijnen. Dit kun je niet ongedaan maken.",
    "cancel": "Annuleren",
    "status": {
      "concept": "Concept",
      "submitted": "Ingediend",
      "in_approval": "In behandeling",
      "rejected": "Afgewezen",
      "withdrawn": "Ingetrokken",
      "running": "Loopt"
    },
    "reason": {
      "form_updated": "Het formulier is bijgewerkt sinds je begon. Je ingevulde waarden staan er nog bij de velden die bleven; kijk het na en dien opnieuw in.",
      "request_not_concept": "Deze aanvraag is al ingediend en kan niet meer gewijzigd worden.",
      "request_not_withdrawable": "Deze aanvraag kan niet meer ingetrokken worden.",
      "type_not_live": "Deze soort aanvraag staat niet meer open.",
      "unknown": "Dit kan niet meer met deze aanvraag.",
      "attachments_full": "Deze aanvraag heeft al het hoogste aantal bijlagen."
    },
    "form": {
      "type": "Soort aanvraag",
      "typePlaceholder": "Kies een soort",
      "submit": "Indienen",
      "save": "Opslaan als concept",
      "discard": "Concept weggooien",
      "submitHint": "Na het indienen kun je de aanvraag niet meer wijzigen, wel intrekken zolang er nog niet beslist is.",
      "otherProvider": "Een andere opleider",
      "providerChoice": "Opleider",
      "providerPlaceholder": "Kies een opleider",
      "providerName": "Naam van de opleider",
      "didYouMean": "Bedoel je een van deze?",
      "teacherName": "Naam van de docent of coach",
      "teacherNameHint": "Niet verplicht.",
      "firstDay": "Eerste dag",
      "lastDay": "Laatste dag",
      "day": "Dag {number}",
      "removeDay": "Dag verwijderen",
      "addDay": "Dag toevoegen",
      "price": "{name}: prijs",
      "quantity": "{name}: aantal",
      "costHint": "Het totaal wordt bij het indienen uitgerekend.",
      "saved": "Je concept is opgeslagen.",
      "submitted": "Je aanvraag is ingediend. Je krijgt een bevestiging per e-mail.",
      "checkFields": "Niet alles is goed ingevuld. Kijk de gemarkeerde velden na.",
      "failed": "Dat lukte niet. Probeer het opnieuw."
    },
    "detail": {
      "heading": "Wat je hebt aangevraagd",
      "provider": "Opleider",
      "period": "Periode",
      "costs": "Kosten",
      "costLine": "Kostenpost",
      "excl": "Excl. btw",
      "incl": "Incl. btw",
      "total": "Totaal",
      "vatUnknown": "onbekend",
      "empty": "–",
      "yes": "Ja",
      "no": "Nee"
    },
    "tiles": {
      "heading": "Staat het er niet tussen?",
      "body": "Vraag een opleiding aan die niet in de catalogus staat."
    },
    "attachments": {
      "heading": "Bijlagen",
      "none": "Geen bijlagen.",
      "hint": "Bijvoorbeeld een offerte of programma. PDF, JPG of PNG, hoogstens {max} bestanden.",
      "full": "Deze aanvraag heeft het hoogste aantal bijlagen ({max}). Haal er een weg om een ander toe te voegen.",
      "remove": "Verwijderen",
      "removeNamed": "Bijlage {name} verwijderen",
      "failed": "De bijlage kon niet worden verwerkt. Probeer het opnieuw.",
      "unnamed": "Bijlage",
      "saveFirst": "Bijlagen voeg je toe nadat je de aanvraag als concept hebt bewaard."
    }
  },
  "questionnaireInvite": {
    "loading": "De vragenlijst wordt geopend…",
    "loadError": "De vragenlijst kon niet worden geopend. Controleer je verbinding en probeer het opnieuw.",
    "retry": "Opnieuw proberen",
    "closedTitle": "Deze link werkt niet meer",
    "closedBody": "Heb je de vragenlijst al ingevuld, dan is je antwoord bewaard.",
    "empty": "Deze vragenlijst bevat geen vragen, dus er is niets in te vullen.",
    "language": "Taal",
    "subject": "Deze vragenlijst gaat over {title}.",
    "subjectWithDates": "Deze vragenlijst gaat over {title} ({dates}).",
    "anonymous": "Je naam wordt niet bij je antwoorden getoond.",
    "requiredNote": "Vragen met een * zijn verplicht.",
    "yes": "Ja",
    "no": "Nee",
    "other": "Anders, namelijk",
    "charsBetween": "Gebruik minstens {min} en hoogstens {max} tekens.",
    "charsMin": "Gebruik minstens {min} tekens.",
    "charsMax": "Gebruik hoogstens {max} tekens.",
    "choicesBetween": "Kies er minstens {min} en hoogstens {max}.",
    "choicesMin": "Kies er minstens {min}.",
    "choicesMax": "Kies er hoogstens {max}.",
    "star": "{value} van {max} sterren",
    "starLabelled": "{value} van {max} sterren: {label}",
    "remarks": "Opmerkingen",
    "remarksHint": "Wil je nog iets kwijt dat niet in de vragen past? Dat kan hier.",
    "submit": "Versturen",
    "submitFailed": "Versturen is niet gelukt. Je antwoorden staan er nog; probeer het opnieuw.",
    "fixErrors": "Nog niet alles is goed ingevuld. Kijk bij de gemarkeerde vragen.",
    "submittedTitle": "Bedankt voor het invullen",
    "submittedBody": "Je antwoorden zijn verstuurd. Je kunt dit venster nu sluiten."
  },
  "questionnaireAssignments": {
    "open": "Vragenlijsten",
    "openFor": "Vragenlijsten bij {training}",
    "heading": "Regels voor vragenlijsten bij {training}",
    "heading_test": "Regels voor toetsen bij {training}",
    "headingGeneric": "Regels voor vragenlijsten bij deze training",
    "headingGeneric_test": "Regels voor toetsen bij deze training",
    "add": "Regel toevoegen",
    "add_test": "Toets toevoegen",
    "intro": "Een regel ligt vast: deze vragenlijst gaat op dit moment naar wie aan de voorwaarden voldoet. Een training kan meer regels hebben, ook met dezelfde vragenlijst — bijvoorbeeld halverwege en aan het eind.",
    "intro_test": "Een regel ligt vast: deze toets gaat op dit moment naar wie aan de voorwaarden voldoet. Een training kan meer regels hebben, ook met dezelfde toets — bijvoorbeeld halverwege en aan het eind.",
    "notFound": "Deze training bestaat niet (meer).",
    "loadError": "De regels bij deze training konden niet geladen worden.",
    "loadError_test": "De toetsregels bij deze training konden niet geladen worden.",
    "empty": "Er is nog geen regel voor een vragenlijst bij deze training.",
    "empty_test": "Er is nog geen toets bij deze training.",
    "showArchived_one": "Gearchiveerde regel tonen ({count})",
    "showArchived_test_one": "Gearchiveerde toetsregel tonen ({count})",
    "showArchived_other": "Gearchiveerde regels tonen ({count})",
    "showArchived_test_other": "Gearchiveerde toetsregels tonen ({count})",
    "onlyArchived": "Alle regels van deze training zijn gearchiveerd.",
    "onlyArchived_test": "Alle toetsregels van deze training zijn gearchiveerd.",
    "unknownForm": "Vragenlijst zonder naam",
    "unknownForm_test": "Toets zonder naam",
    "panel": {
      "title": "Regels voor vragenlijsten",
      "title_test": "Toetsen",
      "empty": "Er zijn nog geen regels voor vragenlijsten bij deze training.",
      "add": "Regel toevoegen",
      "mandatory": "Verplicht: {answer}"
    },
    "name": "{form} — {moment}; {conditions}",
    "anonymous": "Anoniem",
    "actionFailed": "Dat lukte niet. Probeer het opnieuw.",
    "table": {
      "caption": "Regels van deze training",
      "caption_test": "Toetsregels van deze training",
      "form": "Vragenlijst",
      "form_test": "Toets",
      "moment": "Moment",
      "conditions": "Voorwaarden",
      "status": "Stand",
      "invitations": "Uitnodigingen",
      "actions": "Acties",
      "invitationCount_one": "{count} uitnodiging",
      "invitationCount_other": "{count} uitnodigingen",
      "invitationsNamed_one": "{count} uitnodiging bij {name}: bekijk de stand",
      "invitationsNamed_other": "{count} uitnodigingen bij {name}: bekijk de stand"
    },
    "status": {
      "active": "Loopt",
      "paused": "Gepauzeerd",
      "archived": "Gearchiveerd"
    },
    "actions": {
      "edit": "Wijzigen",
      "editNamed": "{name} wijzigen",
      "pause": "Pauzeren",
      "pauseNamed": "{name} pauzeren",
      "resume": "Hervatten…",
      "resumeNamed": "{name} hervatten",
      "archive": "Archiveren",
      "archiveNamed": "{name} archiveren",
      "delete": "Verwijderen",
      "deleteNamed": "{name} verwijderen"
    },
    "pause": {
      "title": "Regel pauzeren",
      "title_test": "Toetsregel pauzeren",
      "body": "Een gepauzeerde regel verstuurt niets. Uitnodigingen ontstaan wel en liggen klaar; bij het hervatten kies je of ze alsnog uitgaan. Links die al verstuurd zijn, blijven werken.",
      "body_test": "Een gepauzeerde regel verstuurt niets. Uitnodigingen ontstaan wel en liggen klaar; bij het hervatten kies je of ze alsnog uitgaan.",
      "confirm": "Pauzeren",
      "done": "De regel is gepauzeerd.",
      "done_test": "De toetsregel is gepauzeerd."
    },
    "archive": {
      "title": "Regel archiveren",
      "title_test": "Toetsregel archiveren",
      "body": "Archiveren stopt deze regel voorgoed. Uitnodigingen die nog niet verstuurd zijn, vervallen. Links die al verstuurd zijn, blijven werken tot ze verlopen.",
      "body_test": "Archiveren stopt deze regel voorgoed. Uitnodigingen die nog niet verstuurd zijn, vervallen.",
      "confirm": "Archiveren",
      "done": "De regel is gearchiveerd.",
      "done_test": "De toetsregel is gearchiveerd."
    },
    "delete": {
      "title": "Regel verwijderen",
      "title_test": "Toetsregel verwijderen",
      "body": "Uit deze regel is nog niets verstuurd, dus hij kan weg.",
      "bodyWithInvitations_one": "Uit deze regel is nog niets verstuurd, dus hij kan weg. De {count} uitnodiging die klaarligt, gaat mee; niemand heeft hem gezien.",
      "bodyWithInvitations_other": "Uit deze regel is nog niets verstuurd, dus hij kan weg. De {count} uitnodigingen die klaarliggen, gaan mee; niemand heeft ze gezien.",
      "confirm": "Verwijderen",
      "done": "De regel is verwijderd.",
      "done_test": "De toetsregel is verwijderd."
    },
    "resume": {
      "title": "Regel hervatten",
      "title_test": "Toetsregel hervatten",
      "confirm": "Hervatten",
      "loadError": "Wat er klaarligt, kon niet geladen worden.",
      "nothingHeld": "Er ligt niets klaar. Hervatten zet de regel weer aan; wie daarna afrondt, krijgt de vragenlijst zoals hij dan is.",
      "nothingHeld_test": "Er ligt niets klaar. Hervatten zet de regel weer aan; wie daarna afrondt, krijgt de toets zoals hij dan is.",
      "done": "De regel loopt weer. Opgepakt: {refrozen}, vervallen: {withdrawn}.",
      "done_test": "De toetsregel loopt weer. Opgepakt: {refrozen}, vervallen: {withdrawn}."
    },
    "duplicate": {
      "existing": "Dit is de bestaande regel: {name}.",
      "existing_test": "Dit is de bestaande toetsregel: {name}.",
      "existingUnknown": "De bestaande regel staat niet in deze lijst. Ververs de pagina om hem te zien.",
      "existingUnknown_test": "De bestaande toetsregel staat niet in deze lijst. Ververs de pagina om hem te zien.",
      "marker": "Bestaat al met hetzelfde moment en dezelfde voorwaarden",
      "toList": "Toon de bestaande regel in de lijst",
      "toList_test": "Toon de bestaande toetsregel in de lijst"
    },
    "errors": {
      "wholeNumber": "Vul een heel getal in, 0 of meer."
    },
    "saved": {
      "created": "De regel is toegevoegd.",
      "created_test": "De toetsregel is toegevoegd.",
      "updated": "De regel is opgeslagen.",
      "updated_test": "De toetsregel is opgeslagen.",
      "replaced": "De nieuwe regel is aangemaakt en de oude is gearchiveerd.",
      "replaced_test": "De nieuwe toetsregel is aangemaakt en de oude is gearchiveerd.",
      "replacedArchiveFailed": "De nieuwe regel is aangemaakt, maar de oude kon niet gearchiveerd worden. Archiveer die zelf, anders lopen ze allebei.",
      "replacedArchiveFailed_test": "De nieuwe toetsregel is aangemaakt, maar de oude kon niet gearchiveerd worden. Archiveer die zelf, anders lopen ze allebei."
    },
    "editor": {
      "newTitle": "Regel toevoegen",
      "newTitle_test": "Toets toevoegen",
      "editTitle": "Regel wijzigen",
      "editTitle_test": "Toetsregel wijzigen",
      "replaceTitle": "Nieuwe regel in plaats van deze",
      "replaceTitle_test": "Nieuwe toetsregel in plaats van deze",
      "replaceConfirm": "Aanmaken en de oude archiveren",
      "backToList": "Terug naar de regels van de training",
      "backToList_test": "Terug naar de toetsen van de training",
      "asideTitle": "Wat dit betekent",
      "nothingSkipped": "Bij dit moment wordt er niets overgeslagen.",
      "notFound": "Deze regel bestaat niet (meer) bij deze training.",
      "notFound_test": "Deze toetsregel bestaat niet (meer) bij deze training.",
      "archived": "Deze regel is gearchiveerd en kan niet meer gewijzigd worden. Maak een nieuwe aan als je iets wilt veranderen.",
      "archived_test": "Deze toetsregel is gearchiveerd en kan niet meer gewijzigd worden. Maak een nieuwe aan als je iets wilt veranderen.",
      "fromNow": "Een wijziging geldt voor uitnodigingen die vanaf nu ontstaan.",
      "locked_one": "Uit deze regel is al {count} uitnodiging ontstaan. Vragenlijst, rol, moment en voorwaarden liggen daarom vast. De invultermijn, de introductie, de herinnering en anonimiteit aanzetten kun je nog wijzigen.",
      "locked_test_one": "Uit deze regel is al {count} uitnodiging ontstaan. Toets, rol, moment en voorwaarden liggen daarom vast. De invultermijn, de introductie, de nakijker en de uitslag voor de deelnemer kun je nog wijzigen.",
      "locked_other": "Uit deze regel zijn al {count} uitnodigingen ontstaan. Vragenlijst, rol, moment en voorwaarden liggen daarom vast. De invultermijn, de introductie, de herinnering en anonimiteit aanzetten kun je nog wijzigen.",
      "locked_test_other": "Uit deze regel zijn al {count} uitnodigingen ontstaan. Toets, rol, moment en voorwaarden liggen daarom vast. De invultermijn, de introductie, de nakijker en de uitslag voor de deelnemer kun je nog wijzigen.",
      "replace": "Nieuw maken en deze archiveren",
      "replacing": "Je maakt een nieuwe regel op basis van {name}. Na het opslaan wordt die gearchiveerd: wat daar nog klaarligt vervalt, verstuurde links blijven werken.",
      "replacing_test": "Je maakt een nieuwe toetsregel op basis van {name}. Na het opslaan wordt die gearchiveerd: wat daar nog klaarligt vervalt."
    },
    "field": {
      "form": "Vragenlijst",
      "form_test": "Toets",
      "formPlaceholder": "Kies een gepubliceerde vragenlijst",
      "formPlaceholder_test": "Kies een gepubliceerde toets",
      "noForms": "Er is nog geen gepubliceerde vragenlijst.",
      "noForms_test": "Er is nog geen gepubliceerde toets.",
      "formsError": "De vragenlijsten om uit te kiezen konden niet geladen worden.",
      "formsError_test": "De toetsen om uit te kiezen konden niet geladen worden.",
      "toForms": "Naar de vragenlijsten",
      "toForms_test": "Naar de toetsen",
      "role": "Wie vult hem in?",
      "moment": "Wanneer gaat hij uit?",
      "conditions": "Voorwaarden",
      "attendance": "Minimale aanwezigheid (%)",
      "attendanceHint": "Leeg: geen voorwaarde.",
      "attendanceHelp": "Het deel van de bijeenkomsten dat iemand bijwoonde. Bijeenkomsten waarvoor iemand is afgemeld, tellen niet mee.",
      "attendanceBeforeEnd": "Kan niet bij een moment vóór het einde van de bijeenkomst: dan is de aanwezigheid nog niet bekend.",
      "outcome": "Uitkomst",
      "outcomeAfterFinalise": "Behaald of niet behaald kan alleen bij het moment na het afronden: eerder is er nog geen uitkomst.",
      "sending": "Versturen",
      "mailIntro": "Eigen introductie in de uitnodiging",
      "mailIntroHint": "Leeg: de standaardtekst van de uitnodiging.",
      "anonymous": "Anoniem: namen niet tonen bij de antwoorden",
      "anonymousHint": "Je ziet dan per stand hoeveel uitnodigingen er zijn, maar niet van wie.",
      "anonymousLocked": "Kan niet meer uit: er zijn al uitnodigingen met die belofte.",
      "anonymousWarning": "Let op: antwoorden worden alleen gezamenlijk getoond, en pas zodra minstens {floor} mensen hebben gereageerd, over alle uitvoeringen van deze training samen. Bij kleine groepen kan dat meerdere uitvoeringen duren.",
      "delayAmount": "Hoeveel later",
      "delayHint": "0 is meteen bij het afronden.",
      "delayUnit": "Eenheid",
      "session": "Welke bijeenkomst",
      "sessionHint": "Op datum en begintijd; bijeenkomsten zonder datum tellen niet mee.",
      "sessionNumber": "Nummer van de bijeenkomst",
      "offsetAmount": "Hoeveel",
      "offsetHint": "0 is bij het einde van de bijeenkomst.",
      "offsetUnit": "Eenheid",
      "offsetDirection": "Ten opzichte van het einde",
      "afterLastDays": "Aantal dagen na de laatste bijeenkomst",
      "afterLastDaysHint": "0 is bij het einde.",
      "afterLastDaysHelp": "In kalenderdagen, vanaf het einde van de laatste bijeenkomst.",
      "fixedAt": "Datum en tijd",
      "fixedAtHint": "In je eigen tijd. Een moment dat al voorbij is, kan niet.",
      "mandatory": "Verplicht voor het behalen",
      "mandatoryHint": "De training is pas behaald als deze vragenlijst is ingevuld. Hij wordt na inloggen ingevuld in Mijn vragenlijsten, zonder link, en verloopt niet.",
      "delivery": "Hoe wordt de toets afgenomen?",
      "deliveryDigital": "Digitaal",
      "deliveryDigitalHint": "De deelnemer maakt de toets in de app; de docent kijkt hem na.",
      "deliveryExternal": "Extern",
      "deliveryExternalHint": "De toets wordt buiten het systeem afgenomen en nagekeken. Hier leg je alleen de uitslag vast, per deelnemer in het presentieraster. Er gaat geen uitnodiging uit.",
      "deliveryExternalGrading": "De uitslag leg je vast in het presentieraster, bij het afsluiten van de uitvoering.",
      "externalTestTitle": "Externe toets",
      "mandatory_test": "Telt mee voor het behalen",
      "mandatoryHint_test": "De training is pas behaald als de toets is ingeleverd, nagekeken en geslaagd. Een kwalificatie die aan de training hangt, wordt pas dan verleend — niet door de aanwezigheid. Een toets die niet is geslaagd laat de deelnemer op niet behaald staan tot de docent anders besluit.",
      "mandatoryNeedsMoment": "Kan alleen bij een moment vóór het afronden: een vragenlijst na het afronden houdt een afronding die er al is niet meer tegen.",
      "mandatoryNotEach": "Kan niet bij elke bijeenkomst: dan is niet duidelijk welke uitnodiging het behalen tegenhoudt.",
      "mandatoryNoAttendance": "Kan niet samen met een voorwaarde op aanwezigheid: wie die niet haalt, krijgt de vragenlijst nooit en kan dan niet meer behalen.",
      "attendanceMandatory": "Kan niet bij een verplichte vragenlijst: wie de voorwaarde niet haalt, kan dan nooit meer behalen.",
      "reminderMandatory": "Een verplichte vragenlijst sluit niet op een datum, dus een herinnering vooraf heeft geen moment. Herinner vanuit het overzicht van de regel.",
      "grading": "Nakijken",
      "grader": "Nakijker",
      "graderPlaceholder": "Kies een nakijker (optioneel)",
      "graderHint": "Leeg: de docenten van de uitvoering kijken na.",
      "showAnswers": "Antwoorden inzien",
      "showAnswersHint": "Aan: na het nakijken ziet de deelnemer ook de vragen met zijn antwoorden en de opmerkingen per antwoord. Uit: hij ziet alleen de uitkomst, de score en de algemene opmerking. Die ziet hij altijd."
    },
    "role": {
      "participant": "Deelnemer",
      "teacher": "Docent",
      "manager": "Leidinggevende",
      "later": "Komt later: docent en leidinggevende vullen ingelogd in."
    },
    "moment": {
      "after_finalise": "Na het afronden",
      "after_finaliseHint": "Bij het vastleggen van de afronding, meteen of later.",
      "at_session": "Bij een bijeenkomst",
      "at_sessionHint": "Rond het einde van een bijeenkomst — bijvoorbeeld halverwege de training.",
      "after_last_session": "Na de laatste bijeenkomst",
      "after_last_sessionHint": "Een aantal dagen na het einde van de laatste bijeenkomst, los van het afronden.",
      "fixed_datetime": "Op een vaste datum",
      "fixed_datetimeHint": "Eén moment voor iedereen die dan ingeschreven of afgerond is."
    },
    "outcome": {
      "any": "Maakt niet uit",
      "passed": "Alleen wie heeft behaald",
      "not_passed": "Alleen wie niet heeft behaald"
    },
    "unit": {
      "minutes": "minuten",
      "hours": "uren",
      "days": "dagen"
    },
    "selector": {
      "number": "Bijeenkomst nummer…",
      "last": "De laatste",
      "each": "Elke bijeenkomst"
    },
    "direction": {
      "after": "na het einde",
      "before": "vóór het einde"
    },
    "skipped": {
      "counting": "Tellen wat er al voorbij is…",
      "failed": "Kon niet tellen hoeveel momenten al voorbij zijn.",
      "nothingPlanned": "Er staat nog geen bijeenkomst met een datum op het rooster waar dit moment op valt.",
      "sessionsNone_one": "{count} bijeenkomst gepland, nog in de toekomst.",
      "sessionsNone_other": "{count} bijeenkomsten gepland, allemaal nog in de toekomst.",
      "occurrencesNone_one": "{count} uitvoering gepland; daar ligt dit moment nog in de toekomst.",
      "occurrencesNone_other": "{count} uitvoeringen gepland; bij allemaal ligt dit moment nog in de toekomst.",
      "sessions_one": "{past} van de {count} bijeenkomst is al voorbij; daarvoor gaat niets uit.",
      "sessions_other": "{past} van de {count} bijeenkomsten zijn al voorbij; daarvoor gaat niets uit.",
      "occurrences_one": "Bij {past} van de {count} uitvoering is dit moment al voorbij; daar gaat niets uit.",
      "occurrences_other": "Bij {past} van de {count} uitvoeringen is dit moment al voorbij; daar gaat niets uit.",
      "rule": "Een regel verstuurt alleen op momenten die nog komen, gerekend vanaf het opslaan."
    },
    "duration": {
      "minutes_one": "{count} minuut",
      "minutes_other": "{count} minuten",
      "hours_one": "{count} uur",
      "hours_other": "{count} uur",
      "days_one": "{count} dag",
      "days_other": "{count} dagen"
    },
    "summary": {
      "afterFinaliseNow": "Meteen na het afronden",
      "afterFinaliseLater": "{delay} na het afronden",
      "sessionNumber": "bijeenkomst {number}",
      "session_last": "de laatste bijeenkomst",
      "session_each": "elke bijeenkomst",
      "atSessionEnd": "Bij het einde van {session}",
      "beforeSessionEnd": "{offset} vóór het einde van {session}",
      "afterSessionEnd": "{offset} na het einde van {session}",
      "afterLastSessionSameDay": "Bij het einde van de laatste bijeenkomst",
      "afterLastSession": "{days} na de laatste bijeenkomst",
      "fixed": "Op {date}",
      "noMoment": "Zonder moment",
      "attendance": "minimaal {percent}% aanwezig",
      "passed": "alleen behaald",
      "notPassed": "alleen niet behaald",
      "noConditions": "geen voorwaarden",
      "mandatory": "verplicht voor het behalen"
    }
  },
  "questionnaireOverview": {
    "intro": "Alle evaluatieregels van vragenlijsten op één plek: de regels bij een training en de losse vragenlijsten. Zonder keuze zie je de lopende en gepauzeerde evaluatieregels; kies bij Stand voor Alles om ook de gearchiveerde te zien.",
    "intro_test": "Alle toetsregels op één plek: de regels bij een training. Zonder keuze zie je de lopende en gepauzeerde toetsregels; kies bij Stand voor Alles om ook de gearchiveerde te zien.",
    "empty": "Er zijn nog geen evaluatieregels.",
    "empty_test": "Er zijn nog geen toetsregels.",
    "noMatch": "Geen evaluatieregels die bij deze filters passen.",
    "noMatch_test": "Geen toetsregels die bij deze filters passen.",
    "loadError": "De evaluatieregels konden niet geladen worden.",
    "loadError_test": "De toetsregels konden niet geladen worden.",
    "unknownForm": "Vragenlijst zonder naam",
    "unknownForm_test": "Toets zonder naam",
    "unknownTraining": "Onbekende training",
    "anonymous": "Anoniem",
    "survey": "Losse vragenlijst",
    "name": "{form} — {target}",
    "cols": {
      "form": "Vragenlijst",
      "form_test": "Toets",
      "target": "Training of doelgroep",
      "moment": "Moment",
      "status": "Stand",
      "mandatory": "Verplicht",
      "sent": "Verstuurd",
      "submitted": "Ingevuld",
      "open": "Open",
      "actions": "Acties"
    },
    "filters": {
      "status": "Stand",
      "statusDefault": "Lopend en gepauzeerd",
      "statusAll": "Alles",
      "kind": "Soort",
      "kindTraining": "Aan een training",
      "kindSurvey": "Losse vragenlijst",
      "form": "Vragenlijst",
      "form_test": "Toets",
      "training": "Training",
      "all": "Alle"
    },
    "actions": {
      "status": "Stand bekijken",
      "statusNamed": "De stand van {name} bekijken",
      "training": "Training",
      "trainingNamed": "De regels van de training bij {name} openen",
      "edit": "Wijzigen",
      "editNamed": "{name} wijzigen"
    }
  },
  "questionnaireWindow": {
    "field": {
      "window": "Invultermijn in dagen",
      "windowHint": "Hoe lang de link openstaat nadat hij verstuurd is. Standaard {days} dagen, nooit langer dan {ceiling} dagen. 0 betekent: zolang het mag.",
      "windowZero": "Geen vaste termijn: de link blijft open zolang het mag, maximaal {ceiling} dagen (bij versturen {from}: tot {date}).",
      "windowCapped": "Dat is langer dan het maximum: de link sluit na {ceiling} dagen (bij versturen {from}: op {date}).",
      "reminder": "Herinnering vóór het sluiten, in dagen",
      "reminderHint": "Zoveel dagen voordat de link sluit krijgt de ontvanger een herinnering met een nieuwe link; de eerste link blijft werken. Leeg: geen herinnering.",
      "reminderAt_one": "Herinnering {count} dag voor het sluiten, op {date} (bij versturen {from}).",
      "reminderAt_other": "Herinnering {count} dagen voor het sluiten, op {date} (bij versturen {from}).",
      "reminderOutside_one": "Een herinnering {count} dag voor het sluiten valt niet binnen de termijn van {window} dagen. Kies minder dagen.",
      "reminderOutside_other": "Een herinnering {count} dagen voor het sluiten valt niet binnen de termijn van {window} dagen. Kies minder dagen.",
      "today": "vandaag",
      "onDate": "op {date}",
      "afterSend": "Herinnering {number} na het versturen, in dagen",
      "afterSendHint_one": "Zoveel dagen na het versturen krijgt de ontvanger een herinnering met een nieuwe link; de eerste link blijft werken. Hooguit {max}, oplopend. De eerste kan na minstens {count} dag.",
      "afterSendHint_other": "Zoveel dagen na het versturen krijgt de ontvanger een herinnering met een nieuwe link; de eerste link blijft werken. Hooguit {max}, oplopend. De eerste kan na minstens {count} dagen.",
      "afterSendAdd": "Herinnering na het versturen toevoegen",
      "afterSendRemove": "Herinnering {number} na het versturen verwijderen",
      "afterSendRemoveLabel": "Verwijderen"
    }
  },
  "questionnaireSurveyRecipients": {
    "back": "Terug naar de losse vragenlijsten",
    "heading": "Ontvangers",
    "note": "Dit is de doelgroep zoals hij nu staat. De definitieve lijst wordt bepaald op het moment van versturen, op de ingestelde verzenddatum.",
    "notFound": "Deze losse vragenlijst bestaat niet (meer).",
    "loadError": "De ontvangers konden niet geladen worden.",
    "empty": "De doelgroep bevat nog niets om te tonen.",
    "total_one": "{count} ontvanger in totaal",
    "total_other": "{count} ontvangers in totaal",
    "duplicates_one": "{count} persoon staat in meer dan één onderdeel en telt één keer mee.",
    "duplicates_other": "{count} personen staan in meer dan één onderdeel en tellen één keer mee.",
    "countsOnly": "Je ziet alleen aantallen: namen en e-mailadressen zijn er voor wie gebruikers mag bekijken.",
    "treeLabel": "Onderdelen van de doelgroep",
    "subUnitsLabel": "Eenheden onder {name}",
    "count_one": "{count} persoon",
    "count_other": "{count} personen",
    "directly": "Rechtstreeks in {name}: {count}",
    "expandNamed": "{name} openklappen",
    "collapseNamed": "{name} inklappen",
    "branch": {
      "everyone": "Iedereen (alle actieve gebruikers)",
      "individuals": "Gekozen personen"
    },
    "people": {
      "name": "Naam",
      "email": "E-mailadres",
      "empty": "Hier staat nu niemand meer.",
      "forbidden": "Je mag de namen niet zien: daarvoor is het recht om gebruikers te bekijken nodig.",
      "loadError": "De mensen van {name} konden niet geladen worden."
    }
  },
  "questionnaireSurveys": {
    "intro": "Een losse vragenlijst hangt niet aan een training: je stuurt een gepubliceerde vragenlijst naar een doelgroep, nu of op een vaste datum. Wie erbij hoort, telt op het moment van versturen.",
    "new": "Nieuwe losse vragenlijst",
    "loadError": "De losse vragenlijsten konden niet geladen worden.",
    "empty": "Er zijn nog geen losse vragenlijsten.",
    "onlyArchived": "Er zijn alleen gearchiveerde losse vragenlijsten.",
    "showArchived_one": "Gearchiveerde vragenlijst tonen ({count})",
    "showArchived_other": "Gearchiveerde vragenlijsten tonen ({count})",
    "unknownForm": "Onbekende vragenlijst",
    "anonymous": {
      "chooseAudience": "Of anoniem kan, hangt af van hoe groot de doelgroep is. Kies eerst een doelgroep.",
      "unknown": "Of anoniem kan, is pas te zeggen als de doelgroep geteld is.",
      "unavailable_one": "Anoniem kan niet: deze doelgroep telt {count} persoon, minder dan de ondergrens van {floor}. Zo belooft de vragenlijst niets wat niet waar te maken is.",
      "unavailable_other": "Anoniem kan niet: deze doelgroep telt {count} mensen, minder dan de ondergrens van {floor}. Zo belooft de vragenlijst niets wat niet waar te maken is.",
      "willDrop": "Deze vragenlijst stond op anoniem; bij opslaan gaat dat eraf."
    },
    "name": "{form}, {date}",
    "actionFailed": "Dat lukte niet. Probeer het opnieuw.",
    "sentTo_one": "naar {count} persoon",
    "sentTo_other": "naar {count} mensen",
    "heldReason_one": "Niet verstuurd: anoniem beloofd, maar bij het versturen telde de doelgroep {count} persoon, minder dan de ondergrens. Bewerk hem om hem opnieuw klaar te zetten.",
    "heldReason_other": "Niet verstuurd: anoniem beloofd, maar bij het versturen telde de doelgroep {count} mensen, minder dan de ondergrens. Bewerk hem om hem opnieuw klaar te zetten.",
    "state": {
      "scheduled": "Gepland",
      "sent": "Verstuurd",
      "held": "Tegengehouden",
      "archived": "Gearchiveerd"
    },
    "table": {
      "caption": "Losse vragenlijsten, met hun doelgroep, moment en stand",
      "form": "Vragenlijst",
      "audience": "Doelgroep",
      "moment": "Moment",
      "state": "Stand",
      "invitations": "Uitnodigingen",
      "actions": "Acties",
      "invitationCount_one": "{count} uitnodiging",
      "invitationCount_other": "{count} uitnodigingen",
      "invitationsNamed_one": "{count} uitnodiging bij {name}: bekijk de stand",
      "invitationsNamed_other": "{count} uitnodigingen bij {name}: bekijk de stand",
      "recipientsNow": "Ontvangers (nu {count})",
      "recipientsNamed": "Ontvangers van {name}: nu {count}, bekijk wie dat zijn"
    },
    "actions": {
      "edit": "Bewerken",
      "editNamed": "{name} bewerken",
      "archive": "Archiveren",
      "archiveNamed": "{name} archiveren",
      "delete": "Verwijderen",
      "deleteNamed": "{name} verwijderen"
    },
    "archive": {
      "title": "Losse vragenlijst archiveren",
      "body": "Archiveren stopt deze vragenlijst voorgoed. Links die al verstuurd zijn, blijven werken tot ze verlopen.",
      "confirm": "Archiveren",
      "done": "De losse vragenlijst is gearchiveerd."
    },
    "delete": {
      "title": "Losse vragenlijst verwijderen",
      "body": "Uit deze vragenlijst is nog niets verstuurd, dus hij kan weg.",
      "confirm": "Verwijderen",
      "done": "De losse vragenlijst is verwijderd."
    },
    "saved": {
      "now_one": "De vragenlijst gaat meteen na je bevestiging naar {count} persoon.",
      "now_other": "De vragenlijst gaat meteen na je bevestiging naar {count} mensen. Bij een grote groep kan het enkele minuten duren voordat iedereen hem heeft.",
      "date_one": "De vragenlijst gaat op {date} uit; de doelgroep telt nu {count} persoon. Wie erbij hoort, telt op dat moment opnieuw.",
      "date_other": "De vragenlijst gaat op {date} uit; de doelgroep telt nu {count} mensen. Wie erbij hoort, telt op dat moment opnieuw."
    },
    "audience": {
      "everyone": "Iedereen",
      "units_one": "{count} eenheid",
      "units_other": "{count} eenheden",
      "roles_one": "{count} rol",
      "roles_other": "{count} rollen",
      "people_one": "{count} persoon",
      "people_other": "{count} personen",
      "none": "Geen doelgroep"
    },
    "editor": {
      "newTitle": "Nieuwe losse vragenlijst",
      "editTitle": "Losse vragenlijst bewerken",
      "backToList": "Naar de losse vragenlijsten",
      "notFound": "Deze losse vragenlijst bestaat niet (meer).",
      "loadError": "De losse vragenlijst kon niet geladen worden.",
      "closedSent_one": "Deze vragenlijst is op {date} verstuurd naar {count} persoon. Bewerken kan niet meer; archiveren kan vanuit de lijst.",
      "closedSent_other": "Deze vragenlijst is op {date} verstuurd naar {count} mensen. Bewerken kan niet meer; archiveren kan vanuit de lijst.",
      "closedArchived": "Deze vragenlijst is gearchiveerd en kan niet meer bewerkt worden.",
      "toInvitations": "Naar de uitnodigingen",
      "review": "Controleren en bevestigen",
      "heldNotice_one": "Deze vragenlijst is niet verstuurd: hij was anoniem, maar bij het versturen telde de doelgroep {count} persoon, minder dan de ondergrens. Kies een grotere doelgroep of laat anoniem los; opslaan zet hem opnieuw klaar.",
      "heldNotice_other": "Deze vragenlijst is niet verstuurd: hij was anoniem, maar bij het versturen telde de doelgroep {count} mensen, minder dan de ondergrens. Kies een grotere doelgroep of laat anoniem los; opslaan zet hem opnieuw klaar."
    },
    "field": {
      "form": "Vragenlijst",
      "formPlaceholder": "Kies een gepubliceerde vragenlijst",
      "formsError": "De vragenlijsten om uit te kiezen konden niet geladen worden.",
      "noForms": "Er is nog geen gepubliceerde vragenlijst.",
      "audience": "Doelgroep",
      "audienceHint": "Kies eenheden, rollen, personen of iedereen. Wie in meer regels valt, krijgt één uitnodiging. Alleen wie actief is, telt mee.",
      "addSegment": "Regel toevoegen",
      "moment": "Wanneer gaat hij uit?",
      "fixedAt": "Datum en tijd",
      "fixedAtHint": "In je eigen tijd. Een moment dat al voorbij is, kan niet.",
      "sending": "Versturen",
      "anonymous": "Anoniem: namen niet tonen bij de antwoorden",
      "anonymousHint": "Je ziet dan per stand hoeveel uitnodigingen er zijn, maar niet van wie. Kan vanaf {floor} mensen."
    },
    "moment": {
      "now": "Nu",
      "nowHint": "Meteen na je bevestiging. Bij een grote groep kan het enkele minuten duren voordat iedereen hem heeft.",
      "date": "Op een vaste datum",
      "dateHint": "Wie op dat moment bij de doelgroep hoort, krijgt hem."
    },
    "segment": {
      "label": "Regel {number} van de doelgroep",
      "type": "Soort, regel {number}",
      "org_units": "Organisatie-eenheden",
      "roles": "Rollen",
      "individuals": "Gekozen personen",
      "everyone": "Iedereen",
      "everyoneHint": "Alle actieve mensen in deze omgeving.",
      "includeSubUnits": "Ook de eenheden eronder",
      "remove": "Weghalen",
      "removeNamed": "Regel {number} weghalen"
    },
    "picker": {
      "units": "Zoek een eenheid",
      "unitsNamed": "Eenheden, regel {number}",
      "roles": "Zoek een rol",
      "rolesNamed": "Rollen, regel {number}",
      "people": "Zoek op naam of e-mailadres",
      "peopleNamed": "Personen, regel {number}",
      "loadError": "De lijst om uit te kiezen kon niet geladen worden."
    },
    "preview": {
      "title": "Ontvangers",
      "nothing": "Kies een doelgroep; dan zie je hier hoeveel mensen hij nu telt.",
      "counting": "Tellen…",
      "updating": "Bijwerken…",
      "count_one": "{count} persoon",
      "count_other": "{count} mensen",
      "failed": "Het aantal kon niet geteld worden.",
      "rule": "Alleen wie actief is, telt mee. Bij het versturen wordt de doelgroep opnieuw geteld."
    },
    "errors": {
      "noAudience": "Kies minstens één doelgroep.",
      "segmentIncomplete": "Kies wie er in deze regel valt, of haal de regel weg.",
      "nobody": "Deze doelgroep telt nu niemand: er zou niets uitgaan.",
      "countFailed": "Het aantal ontvangers kon niet geteld worden. Probeer het opnieuw."
    },
    "confirm": {
      "title": "Versturen bevestigen",
      "count_one": "Deze vragenlijst gaat naar {count} persoon.",
      "count_other": "Deze vragenlijst gaat naar {count} mensen.",
      "form": "Vragenlijst",
      "when": "Wanneer",
      "anonymous": "Anoniem",
      "yes": "Ja",
      "no": "Nee",
      "now": "Zodra je bevestigt",
      "nowHint": "Hij gaat meteen uit; bij een grote groep kan het enkele minuten duren voordat iedereen hem heeft. Daarna kun je hem niet meer bewerken, alleen archiveren.",
      "dateHint": "Tot dat moment kun je hem bewerken. Wie erbij hoort, telt dan opnieuw; het aantal kan anders zijn.",
      "sendNow": "Bevestigen en versturen",
      "schedule": "Bevestigen en inplannen",
      "changed_one": "Het aantal is veranderd: de doelgroep telt nu {count} persoon in plaats van {previous}. Bevestig opnieuw.",
      "changed_other": "Het aantal is veranderd: de doelgroep telt nu {count} mensen in plaats van {previous}. Bevestig opnieuw."
    }
  },
  "assetLimits": {
    "uploadHint": "{types} — max {max} MB",
    "fileTooLarge": "Dit bestand is {size} MB. Het maximum is {max} MB.",
    "fileTypeRejected": "Dit bestandstype kan niet. Toegestaan zijn: {types}."
  },
  "uploadLimits": {
    "platformDescription": "Deze waarden gelden voor elke omgeving die er geen eigen heeft. Klanten kunnen ze niet zelf wijzigen: een typelijst is een beveiligingsinstelling.",
    "tenantDescription": "Wat je hier zet geldt alleen voor deze omgeving. Laat een veld leeg om terug te vallen op de waarde die voor alle omgevingen geldt.",
    "storageUsage": "Deze omgeving gebruikt nu {used} van {quota} MB ({percent}%) aan eigen content.",
    "sources": {
      "tenant": "Eigen waarde voor deze omgeving",
      "platform": "Platform-breed ingesteld",
      "fallback": "Standaard"
    },
    "units": {
      "kilobytes": "Waarde (MB)",
      "megabytes": "Waarde (MB)",
      "count": "Waarde"
    },
    "types": "Toegestane bestandstypen",
    "addType": "Type toevoegen",
    "add": "Toevoegen",
    "removeType": "{type} verwijderen",
    "forbiddenHint": "Deze typen kunnen niet worden toegestaan omdat ze scripts kunnen dragen: {types}.",
    "ceilingHint": "Hoogstens {max} MB — meer laat de webserver niet door.",
    "overCeiling": "De grens kan niet hoger dan {max} MB.",
    "mustBeNumber": "Vul een positief getal in.",
    "notOverridable": "Deze grens geldt voor alle omgevingen en is hier niet aan te passen.",
    "clearOverride": "Terug naar de standaard",
    "fallbackNote": "Zonder eigen waarde geldt hier {value}.",
    "saved": "De grenzen zijn opgeslagen.",
    "nothingChanged": "Er is niets gewijzigd om op te slaan.",
    "loadError": "We konden de uploadgrenzen niet laden."
  },
  "platformSettings": {
    "title": "Globale instellingen",
    "sections": {
      "general": "Algemeen",
      "mail": "Mail",
      "files": "Bestanden"
    },
    "general": {
      "empty": "Nog geen globale instellingen onder dit kopje."
    },
    "mail": {
      "transportTitle": "Afzender & transport (default)",
      "mode": "Verzendmodus",
      "modeRelay": "Platform-relay (aanbevolen)",
      "modeSmtp": "Eigen SMTP-server",
      "fromAddress": "Afzender-adres",
      "fromName": "Afzender-naam",
      "replyTo": "Antwoord-aan (Reply-To)",
      "smtpHost": "SMTP-host",
      "smtpPort": "SMTP-poort",
      "smtpEncryption": "Encryptie",
      "smtpUsername": "SMTP-gebruikersnaam",
      "smtpPassword": "SMTP-wachtwoord",
      "passwordSet": "Een wachtwoord is ingesteld — leeg laten houdt het ongewijzigd.",
      "connectionTest": "Verbinding testen",
      "connectionHint": "Test de opgeslagen transport-instellingen zonder een mail te versturen. Sla eerst op.",
      "connectionOk": "Verbinding geslaagd.",
      "lifecycleTitle": "Verzending & bewaren (default)",
      "sendingEnabled": "Mails daadwerkelijk verzenden",
      "openTracking": "Open-tracking (pixel)",
      "storeTransactionalBody": "Inhoud van transactionele mails bewaren",
      "delayMinutes": "Vertraging (minuten)",
      "retentionDays": "Bewaartermijn (dagen)",
      "testTitle": "Test-mail",
      "testHint": "Stuurt een test-mail via het platform-transport, buiten iedere tenant om.",
      "testTo": "Test-adres",
      "testToInvalid": "Voer een geldig e-mailadres in.",
      "testSend": "Verstuur test",
      "testOk": "Test-mail verstuurd.",
      "dnsTitle": "DNS-controle (SPF/DKIM/DMARC)",
      "dnsHint": "Controleert de e-mail-authenticatie-records van het platform-From-domein. Sla eerst op.",
      "dnsCheck": "Controleer DNS",
      "dnsDomain": "Domein",
      "dkimSelector": "DKIM-selector (optioneel)",
      "dkimSelectorHint": "DKIM-selector bijv. 'default' of 's1' — nodig om het juiste DKIM-record op te vragen.",
      "dnsExpected": "Plaats een TXT-record op {host} met:",
      "spfNoRelay": "bevat onze relay niet",
      "dnsStatus": {
        "ok": "in orde",
        "warn": "let op",
        "missing": "ontbreekt",
        "skipped": "niet gecontroleerd"
      }
    }
  },
  "common": {
    "filePicker": {
      "drop": "Sleep een bestand hierheen of klik om te kiezen",
      "choose": "Bestand kiezen",
      "replace": "Vervangen",
      "remove": "Weghalen"
    },
    "dropzone": {
      "primary": "Sleep bestanden hierheen of klik om te kiezen",
      "secondary": "Meerdere bestanden tegelijk kan ook (max 10 MB per bestand)"
    },
    "cancel": "Annuleren",
    "close": "Sluiten",
    "copy": "Kopiëren",
    "copied": "Gekopieerd!",
    "create": "Aanmaken",
    "save": "Opslaan",
    "saved": "Opgeslagen",
    "loading": "Laden…",
    "error": "Er ging iets mis",
    "edit": "Wijzigen",
    "open": "Openen",
    "search": "Zoeken",
    "yes": "Ja",
    "no": "Nee",
    "tableEmpty": "Geen rijen om te tonen.",
    "tableNoMatch": "Geen resultaten voor deze zoekopdracht.",
    "tableMatchCount": "{matched} van {total}",
    "tableRange": "{from}–{to} van {total}",
    "tablePageSize": "Per pagina",
    "tablePageOf": "Pagina {current} van {total}",
    "tableExport": "Exporteer CSV",
    "tableExportHint": "Alle gefilterde rijen, in de huidige sortering. Actie-kolom wordt weggelaten.",
    "delete": "Verwijderen",
    "remove": "Verwijderen",
    "expand": "Uitklappen",
    "collapse": "Inklappen",
    "unknownError": "Er ging iets mis. Probeer het opnieuw.",
    "fieldRequired": "Dit veld is verplicht.",
    "invalidEmail": "Voer een geldig e-mailadres in.",
    "view": "Bekijken",
    "weekday": {
      "1": "maandag",
      "2": "dinsdag",
      "3": "woensdag",
      "4": "donderdag",
      "5": "vrijdag",
      "6": "zaterdag",
      "7": "zondag"
    },
    "saving": "Opslaan…",
    "actions": "Acties",
    "tableRowNumber": "#",
    "tableSelectAll": "Alle rijen selecteren",
    "tableSelectRow": "Rij {n} selecteren",
    "tableSortAsc": "oplopend gesorteerd",
    "tableSortDesc": "aflopend gesorteerd",
    "tableScrollRegion": "Tabel, horizontaal te scrollen",
    "tablePreviousPage": "Vorige pagina",
    "tableNextPage": "Volgende pagina",
    "helpFor": "Uitleg bij {field}",
    "moveUp": "Omhoog",
    "moveDown": "Omlaag"
  },
  "shadowBanner": {
    "stop": "Stop shadow",
    "startedAt": "actief sinds {time}",
    "userShadow": {
      "heading": "Je werkt als {name}",
      "subline": "Geïnitieerd door {impersonator}",
      "sublineWithOrigin": "Geïnitieerd door {impersonator} (als shadow van superadmin {origin})"
    },
    "superadminTenantAdmin": {
      "heading": "Je werkt als tenant-admin via superadmin-shadow",
      "subline": "Originele superadmin: {origin}"
    }
  },
  "localeOverrides": {
    "heading": "Teksten",
    "intro": "Overschrijf hier teksten in de app per taal. Lege override = oorspronkelijke tekst.",
    "searchPlaceholder": "Zoek op key of tekst…",
    "colKey": "Key",
    "default": "Standaard",
    "override": "Eigen tekst",
    "reset": "Reset",
    "resetNamespace": "Reset namespace",
    "historyAction": "Historie",
    "namespaceCount": "{total} keys · {overridden} aangepast",
    "requiredPlaceholders": "Gebruik: {list}",
    "confirmResetTitle": "Namespace resetten?",
    "confirmResetBody": "Alle eigen teksten in '{namespace}' verwijderen voor deze taal. Defaults worden weer gebruikt.",
    "historyTitle": "Historie — {key}",
    "empty": {
      "all": "Nog geen keys om te tonen.",
      "search": "Geen resultaten voor deze zoekopdracht."
    },
    "history": {
      "empty": "Geen wijzigingen vastgelegd.",
      "before": "Vorige waarde",
      "after": "Nieuwe waarde",
      "disabledHint": "Geen historie — nog geen eigen tekst ingesteld voor deze key.",
      "by": "door {actor}",
      "byShadow": "door {impersonator} (als shadow van {actor})",
      "byShadowFromSuperadmin": "door {impersonator} (als shadow van {actor}; ingelogd als superadmin {origin})",
      "bySuperadminShadow": "door {actor} (superadmin {origin} via shadow)",
      "action": {
        "created": "Aangemaakt",
        "updated": "Gewijzigd",
        "deleted": "Gewist"
      }
    },
    "errors": {
      "html": "HTML-tags zijn niet toegestaan.",
      "placeholder": "De volgende placeholder(s) ontbreken: {list}",
      "saveFailed": "Opslaan mislukt."
    }
  },
  "auth": {
    "login": {
      "title": "Inloggen",
      "subtitle": "Superadmin-toegang tot het BCS LMS/LXP-platform.",
      "email": "E-mailadres",
      "password": "Wachtwoord",
      "remember": "Aangemeld blijven",
      "submit": "Inloggen",
      "genericError": "Inloggen mislukt. Probeer het opnieuw."
    },
    "mfa": {
      "title": "Tweede stap",
      "subtitle": "Voer de code uit je authenticator-app in.",
      "code": "Code",
      "submit": "Bevestigen",
      "recoveryHint": "Geen toegang tot je app? Gebruik een van je herstelcodes.",
      "noRecoveryHint": "Je hebt geen herstelcodes meer over."
    }
  },
  "superadmin": {
    "dashboard": {
      "heading": "Dashboard",
      "intro": "Overzicht van het BCS LMS/LXP-platform.",
      "totalTenants": "Tenants totaal",
      "activeTenants": "Actieve tenants",
      "imports": {
        "activeImports": "Actieve imports",
        "allClearTitle": "Imports — alles in orde",
        "allClearBody": "Geen mislukte imports in de laatste 7 dagen.",
        "failuresTitle": "Imports — recent mislukt",
        "failuresBody": "{failed24h} mislukt in de laatste 24 uur · {failed7d} in de laatste 7 dagen."
      },
      "storage": {
        "allClearTitle": "Opslag — alles in orde",
        "allClearBody": "Geen van de {count} omgevingen zit tegen zijn opslaggrens aan.",
        "attentionTitle": "Opslag — vraagt aandacht",
        "attentionBody": "{warn} omgevingen zitten tegen hun grens aan · {over} zitten erover.",
        "usage": "{used} van {quota} MB ({percent}%)"
      }
    },
    "tenants": {
      "heading": "Tenants",
      "new": "Nieuwe tenant",
      "edit": "Tenant wijzigen — {name}",
      "empty": "Nog geen tenants. Maak de eerste aan om te beginnen.",
      "confirmDelete": "Tenant verwijderen?",
      "confirmDeleteBody": "Dit verwijdert {name} (soft-delete). Data blijft bewaard en kan door een engineer teruggezet worden.",
      "confirmSlugLabel": "Typ \"{slug}\" om te bevestigen",
      "confirmSlugHint": "De slug van de tenant. Hoofdlettergevoelig.",
      "confirmDeleteDomainTitle": "Domein verwijderen?",
      "confirmDeleteDomainBody": "Dit verwijdert {host} definitief. De host stopt daarna met resolven en gebruikers kunnen deze tenant er niet meer via bereiken.",
      "cols": {
        "name": "Naam",
        "slug": "Slug",
        "status": "Status",
        "locale": "Taal",
        "domains": "Domeinen"
      },
      "legacyDomainHint": "Achtergebleven host van een eerdere slug of eigen domein. Resolvet nog naar deze tenant; niet meer gebruikt voor nieuwe login-URL's. Gebruik de × om hem te verwijderen.",
      "removeDomain": "{host} verwijderen",
      "manageDomainHint": "Beheer-host — aparte sessie voor het tenant-beheer (ADR-0028).",
      "contentDomainHint": "Content-host — hier draait e-learning-materiaal, in een eigen origin (ADR-0033 § 4).",
      "loginUrlTitle": "Eenmalige admin-login-URL",
      "loginUrlBody": "Stuur deze URL naar de nieuwe tenant-beheerder. Hij werkt eenmalig en verloopt na 15 minuten.",
      "orgStructure": "Org-structuur",
      "manage": "Beheren",
      "fields": {
        "adminEmail": "E-mail eerste beheerder",
        "adminHint": "Optioneel — maak direct de eerste tenant-admin aan. Deze krijgt straks een login-URL.",
        "adminName": "Naam eerste beheerder",
        "availableLocales": "Beschikbare talen",
        "availableLocalesHint": "Talen waaruit tenant-gebruikers kunnen kiezen. Minstens één aanvinken; de standaardtaal moet ook aangevinkt staan.",
        "availableLocalesRequired": "Minstens één taal moet beschikbaar zijn.",
        "bcsNumber": "BCS-nummer",
        "bcsNumberHint": "Het klantnummer dat we binnen BCS voor deze klant gebruiken. Uniek per tenant.",
        "contentSlug": "Content-host-slug",
        "contentSlugHint": "De host waarop e-learning-content draait, als één label onder het centrale domein. Leeg laten = content-<slug>. Moet verschillen van de omgevings-slug en de beheer-slug: die scheiding is precies waarom deze host bestaat. Let op: er hoort per omgeving een DNS-/proxy-regel op deze naam te staan.",
        "currency": "Valuta",
        "currencyHint": "De valuta die binnen deze tenant gebruikt wordt, bijvoorbeeld voor prijzen en budgetten.",
        "customDomain": "Eigen domein",
        "customDomainHint": "Optioneel. Eén eigen hostname (bv. leren.acme.nl) waarop deze tenant ook bereikbaar is. DNS + TLS regel je zelf; leeg laten = alleen het standaard-subdomein.",
        "locale": "Standaardtaal",
        "localeHint": "Wordt toegepast op nieuwe tenant-gebruikers tenzij zij zelf een andere taal kiezen.",
        "localeNotAvailable": "De standaardtaal moet ook aangevinkt staan in de beschikbare talen.",
        "manageSlug": "Beheer-slug",
        "manageSlugHint": "Subdomein van de beheer-omgeving (één label onder het platform-domein). Leeg laten = standaard manage-<slug>.",
        "name": "Weergavenaam",
        "noPlatformLocales": "Nog geen platform-talen actief — voeg er minstens één toe via het menu Talen.",
        "retentionDays": "Bewaartermijn verwijderde gebruikers (dagen)",
        "retentionDaysHint": "Na hoeveel dagen soft-deleted gebruikers definitief (GDPR) gewist worden. Leeg = standaard 365 dagen. De dagelijkse retention-taak voert dit uit.",
        "slug": "Slug",
        "slugHint": "Kleine letters, cijfers en streepjes. Vormt het standaard-subdomein.",
        "status": "Status",
        "themeMode": "Thema",
        "themeModeHint": "Bepaal het kleurenthema voor deze tenant: gebruikers laten kiezen (schakelaar in de balk), of licht/donker afdwingen.",
        "themeModes": {
          "dark": "Altijd donker",
          "light": "Altijd licht",
          "switch": "Gebruiker kiest (schakelaar)"
        },
        "timezone": "Tijdzone",
        "timezoneHint": "Geplande imports draaien op de lokale tijd van deze tijdzone — een klant in Mexico_City met schedule 07:00 draait om 07:00 Mexicaanse tijd, niet om 07:00 Nederlandse tijd."
      },
      "seed": {
        "hint": "Optioneel — neem een set ingerichte config over uit een bestaande tenant. Niets aanvinken = blanco tenant.",
        "sourceLabel": "Kopiëren uit tenant",
        "sourceBlank": "— blanco tenant (niets overnemen) —",
        "scopesLegend": "Wat overnemen",
        "toastCopied": "Tenant aangemaakt. Overgenomen:",
        "toastSkipped": "Overgeslagen (niets te kopiëren):",
        "scopes": {
          "org_structure": {
            "label": "Org-structuur",
            "hint": "Categorieën + hiërarchie + custom velden per categorie. De echte units (afdelingen, teams) komen NIET mee."
          },
          "user_field_schema": {
            "label": "User-veldenschema",
            "hint": "Volledige definitie van custom user-velden voor deze tenant."
          },
          "display_name_format": {
            "label": "Display-name format",
            "hint": "Template waarmee de naam van een gebruiker wordt samengesteld. Het user-veldenschema komt automatisch mee."
          },
          "branding": {
            "label": "Branding",
            "hint": "Kleuren + logo-bestand."
          },
          "import_sources": {
            "label": "Import-bronnen",
            "hint": "De bron-rijen + hun slot/kolom-mapping. Vereist dat org-structuur en user-veldenschema ook meekomen — de mapping verwijst naar org-levels + user-velden. Credentials worden NOOIT gekopieerd; bronnen landen uitgeschakeld met lege credentials zodat de admin ze eerst invult voordat 'ie aanzet."
          },
          "workflow_templates": {
            "label": "Workflows",
            "hint": "De workflow-definities van de bron-tenant (trigger → conditie → stappen). Runs blijven tenant-eigen; alleen de definities reizen mee. De globale standaard-set komt sowieso al mee bij elke nieuwe tenant."
          }
        }
      },
      "statusLabels": {
        "implementation": "Implementatie",
        "active": "Actief",
        "suspended": "Gepauzeerd",
        "archived": "Gearchiveerd"
      },
      "statusHints": {
        "implementation": "Standaard bij nieuw aangemaakte tenants. De tenant werkt normaal voor het implementatie-team, maar er gaan geen transactionele mails uit — zet op Actief zodra het platform geconfigureerd is en je echte gebruikers kunt uitnodigen.",
        "active": "Live voor eindgebruikers. Logins, mail en alle functies werken normaal.",
        "suspended": "Tenant is gepauzeerd. Eindgebruikers kunnen niet inloggen; lopende sessies krijgen 503 bij de volgende request en worden uitgelogd. Superadmin shadow-login werkt nog wel, zodat je vanaf binnenuit kunt onderzoeken of de pauze kunt opheffen.",
        "archived": "Tenant is afgesloten. De site geeft 404 voor iedereen — ook voor superadmin shadow-login. Data blijft in de database; haal de archivering eerst weg als je weer toegang nodig hebt."
      },
      "cards": {
        "general": "Algemene gegevens",
        "generalHint": "Naam, slug, eigen domein en status van de tenant.",
        "languages": "Talen",
        "languagesHint": "Standaardtaal en de talen waaruit gebruikers van deze tenant kunnen kiezen."
      },
      "sections": {
        "general": "Algemeen",
        "locales": "Talen",
        "branding": "Layout",
        "mail": "Mail",
        "pickerLabel": "Sectie",
        "login": "Login",
        "limits": "Bestanden",
        "modules": "Modules",
        "documents": "Documenten"
      },
      "modules": {
        "intro": "Welke modules deze omgeving heeft. Alleen BCS zet een module aan of uit; de beheerder van de omgeving ziet een uitgezette module nergens.",
        "empty": "Er zijn nog geen modules geregistreerd. Alles wat het platform nu kan, is voor elke omgeving beschikbaar.",
        "loadError": "De modules konden niet worden geladen.",
        "retry": "Opnieuw proberen",
        "state": {
          "standard": "Standaard aanwezig",
          "sold": "Verkocht",
          "legacy_activatable": "Niet meer verkocht, wel te activeren",
          "retired": "Vervalt"
        },
        "on": "Aan",
        "off": "Uit",
        "alwaysOn": "Staat altijd aan en kan niet uit.",
        "retiredOff": "Vervalt: niet meer aan te zetten.",
        "enable": "Aanzetten",
        "disable": "Uitzetten",
        "enabledBy": "Aangezet door {name} op {date}",
        "disabledBy": "Uitgezet door {name} op {date}",
        "removedPerson": "een verwijderde beheerder",
        "unknownPerson": "onbekend",
        "neverSwitched": "Nog nooit aan- of uitgezet.",
        "confirmRetiredTitle": "Module uitzetten die vervalt?",
        "confirmRetiredBody": "Module {module} vervalt. Zet je hem nu uit, dan kan hij niet meer aan. De gegevens blijven bewaard.",
        "confirmRetired": "Toch uitzetten"
      },
      "mail": {
        "transportTitle": "Afzender & transport",
        "mode": "Verzendmodus",
        "modeInherit": "Globale standaard",
        "modeInheritHint": "Volgt de globale standaard: {mode}",
        "modeRelay": "Platform-relay (aanbevolen)",
        "modeSmtp": "Eigen SMTP-server",
        "fromAddress": "Afzender-adres",
        "fromName": "Afzender-naam",
        "replyTo": "Antwoord-aan (Reply-To)",
        "smtpHost": "SMTP-host",
        "smtpPort": "SMTP-poort",
        "smtpEncryption": "Encryptie",
        "smtpUsername": "SMTP-gebruikersnaam",
        "smtpPassword": "SMTP-wachtwoord",
        "passwordSet": "Een wachtwoord is ingesteld — leeg laten houdt het ongewijzigd.",
        "lifecycleTitle": "Verzending & bewaren",
        "sendingEnabled": "Mails daadwerkelijk verzenden",
        "openTracking": "Open-tracking (pixel)",
        "storeTransactionalBody": "Inhoud van transactionele mails bewaren",
        "delayMinutes": "Vertraging (minuten)",
        "retentionDays": "Bewaartermijn (dagen)",
        "testTitle": "Test-mail",
        "testHint": "Stuurt een test-mail via het ingestelde transport, ook als verzenden uit staat.",
        "testTo": "Test-adres",
        "testToInvalid": "Voer een geldig e-mailadres in.",
        "testSend": "Verstuur test",
        "testOk": "Test-mail verstuurd.",
        "connectionTest": "Verbinding testen",
        "connectionHint": "Test de opgeslagen transport-instellingen zonder een mail te versturen. Sla eerst op.",
        "connectionOk": "Verbinding geslaagd.",
        "dnsTitle": "DNS-controle (SPF/DKIM/DMARC)",
        "dnsHint": "Controleert de e-mail-authenticatie-records van het ingestelde From-domein. Voorspelt of mail door de spamfilters van ontvangers komt. Sla eerst op.",
        "dnsCheck": "Controleer DNS",
        "dnsDomain": "Domein",
        "dkimSelector": "DKIM-selector (optioneel)",
        "dkimSelectorHint": "DKIM-selector bijv. 'default' of 's1' — nodig om het juiste DKIM-record op te vragen.",
        "dnsExpected": "Plaats een TXT-record op {host} met:",
        "spfNoRelay": "bevat onze relay niet",
        "dnsStatus": {
          "ok": "in orde",
          "warn": "let op",
          "missing": "ontbreekt",
          "skipped": "niet gecontroleerd"
        }
      },
      "unsavedConfirm": "Er zijn niet-opgeslagen wijzigingen. Toch verlaten zonder opslaan?",
      "userFields": {
        "baseHeading": "Basisvelden",
        "baseHint": "Altijd aanwezig bij elke gebruiker. Vaste velden — alleen het label en 'verplicht' zijn aanpasbaar.",
        "requiredLabel": "Verplicht",
        "labelForLocale": "Label ({locale})",
        "schemaHeading": "Aanvullende velden",
        "schemaHint": "Elk veld dat je hier definieert verschijnt op het gebruikersprofiel. Types zijn dezelfde als voor units in de organisatiestructuur.",
        "displayNameHeading": "Weergavenaam-format",
        "displayNameHint": "Bepaalt hoe de weergavenaam wordt opgebouwd uit de naam-velden. Tokens tussen accolades (first_name, last_name, email, of een aangepaste-veldsleutel) worden vervangen door de waarde van de gebruiker. De standaard geeft \"Jan Janssen\"; schakel naar achternaam-eerst voor een sorteerbare directory, of combineer met een aangepast \"initialen\"-veld.",
        "displayNameFormat": "Format-template",
        "displayNamePreview": "Voorbeeld:",
        "displayNameUnknownTokens": "Onbekende tokens in template — los op of dit blijft leeg:",
        "displayNameTokensHeading": "Beschikbare tokens"
      },
      "branding": {
        "heading": "Layout",
        "hint": "Pas de uitstraling van deze tenant aan. Wijzigingen zijn zichtbaar bij de volgende paginalading.",
        "primaryColor": "Merkkleur",
        "primaryColorHint": "Hexwaarde (bijv. #1a56db). Gebruikt voor knoppen, links en de actieve navigatie-indicator. Leeg laten voor de platformstandaard.",
        "accentColor": "Accentkleur",
        "accentColorHint": "Hexwaarde (bijv. #13796d). Gebruikt als tweede kleur in de gradient van primaire knoppen en voor secundaire chips en iconen. Leeg laten voor de platformstandaard.",
        "buttonHoverColor": "Knop hover-kleur",
        "buttonHoverColorHint": "Hexwaarde. Achtergrond van primaire knoppen wanneer de cursor erop staat. Leeg laten gebruikt automatisch een iets donkerdere variant van de merkkleur.",
        "activeIndicatorColor": "Actief menu-item indicator",
        "activeIndicatorColorHint": "Hexwaarde. Het smalle gekleurde balkje links van het huidige menu-item in de zijbalk. Leeg laten volgt de merkkleur.",
        "sidebarColor": "Zijbalkkleur",
        "sidebarColorHint": "Hexwaarde (bijv. #1B1F33). Vervangt de standaard donkere zijbalk. Moet donker genoeg zijn voor witte tekst — te lichte waarden worden bij opslaan geweigerd.",
        "sidebarPreview": "Live voorbeeld van de zijbalk met deze kleur",
        "nameInUi": "Portaalnaam",
        "nameInUiHint": "Naam die in de zijbalk en het browsertabblad verschijnt. Standaard de weergavenaam van de tenant.",
        "senderName": "Afzendernaam opleidingen",
        "senderNameHint": "De naam waaronder de opleidingsfunctie bij deze klant bekend staat (HRM, HRD, Opleidingen). Ondertekent berichten over leren, bijvoorbeeld \"HRD — Zorggroep De Waarden\"; onder account- en toegangsberichten staat alleen de organisatienaam. Leeg laten kan: dan staat er overal alleen de organisatienaam.",
        "logo": "Logo",
        "logoHint": "PNG of JPG, max 2 MB. Vervangt het BCS-logo in de zijbalk.",
        "logoUpload": "Logo uploaden",
        "logoReplace": "Vervangen",
        "logoRemove": "Logo verwijderen",
        "logoPreview": "Logovoorbeeld",
        "logoInvalid": "Upload mislukt. Controleer het bestandstype (PNG/JPG) en de grootte (max 2 MB).",
        "logoLayout": "Indeling logo + naam",
        "logoLayoutHint": "Kies hoe het logo en de portaalnaam samen worden getoond in de zijbalk en op het inlogscherm.",
        "logoLayouts": {
          "logo_then_title": "Logo met de naam ernaast",
          "logo_above_title": "Logo met de naam eronder",
          "logo_only": "Alleen logo",
          "title_only": "Alleen naam"
        },
        "logoAlign": "Uitlijning logoblok",
        "logoAlignHint": "Of het logo + naam aan de linkerkant van de zijbalk-header staan of horizontaal gecentreerd zijn. Geldt voor welke indeling je hierboven ook kiest.",
        "logoAligns": {
          "left": "Links uitgelijnd",
          "center": "Gecentreerd"
        },
        "favicon": "Favicon",
        "faviconHint": "PNG, JPG of ICO, max 256 KB. Vervangt het BCS-icoon in het browsertabblad.",
        "faviconUpload": "Favicon uploaden",
        "faviconReplace": "Vervangen",
        "faviconRemove": "Favicon verwijderen",
        "faviconPreview": "Faviconvoorbeeld",
        "faviconInvalid": "Upload mislukt. Controleer het bestandstype (PNG/JPG/ICO) en de grootte (max 256 KB)."
      },
      "bcs": {
        "title": "BCS Login (OIDC)",
        "intro": "Kies de login-modus voor deze tenant en configureer BCS Login (Keycloak). Client-secrets worden nooit getoond; laat leeg om ongewijzigd te laten.",
        "mode": "Login-modus",
        "modePassword": "E-mail & wachtwoord",
        "modeBcs": "BCS Login (OIDC)",
        "modeDev": "Dev-login",
        "baseUrl": "Basis-URL",
        "realm": "Realm",
        "clientId": "Client-ID",
        "customerNr": "Klantnummer",
        "customerNrHint": "Leeg = {number}, het BCS-nummer onder Algemeen. Vul alleen iets in als deze omgeving een ander nummer nodig heeft.",
        "customerNrEmpty": "Nog geen BCS-nummer onder Algemeen",
        "customerNrMissing": "Zonder klantnummer kan BCS Login niet aan — vul het BCS-nummer in onder Algemeen, of hier een eigen nummer.",
        "environmentCode": "Omgevingscode",
        "applicationCode": "Applicatiecode",
        "scopes": "Scopes",
        "clientSecret": "Client-secret",
        "secretSet": "Laat leeg om het bestaande secret te behouden. Vul alleen iets in als je het wilt vervangen.",
        "secretRequired": "Verplicht om BCS Login in te schakelen.",
        "jitProvision": "Onbekende gebruikers automatisch aanmaken (JIT)",
        "provisioningTitle": "Accounts aanmaken bij BCS Login",
        "provisioningConfigured": "De provisioning-client is op de server ingesteld en geldt voor alle omgevingen. Hij staat niet hier, omdat hij bij de productlijn hoort en niet bij een klant.",
        "provisioningMissing": "Er is op deze server geen provisioning-client ingesteld, dus er worden geen accounts bij BCS Login aangemaakt of ingetrokken. Dat is een serverinstelling, geen instelling van deze omgeving.",
        "saveFailed": "Opslaan mislukt",
        "genericError": "Opslaan is niet gelukt. Controleer de gegevens en probeer opnieuw.",
        "customerNrNoGeneral": "Er staat nog geen BCS-nummer onder Algemeen. Vul het daar in, of geef deze omgeving hier een eigen nummer.",
        "customerNrOverrideTitle": "Eigen klantnummer voor deze omgeving",
        "customerNrOverride": "De login gebruikt {override} in plaats van {general} uit Algemeen. Klopt dat niet, maak dit veld dan leeg."
      },
      "documents": {
        "heading": "Documenten",
        "intro": "Of de certificaatsjablonen van BCS in deze omgeving te kiezen zijn. Uit gaat voor de instelling van de klant zelf.",
        "available": "BCS-sjablonen beschikbaar",
        "saveFailed": "Opslaan is niet gelukt.",
        "offNote": "Uit: de klant ziet de BCS-sjablonen niet en kan ze niet zelf aanzetten. Waar er al een gekozen is, blijft het certificaten maken."
      }
    },
    "auditLog": {
      "heading": "Audit-log",
      "intro": "Alleen-lezen overzicht van mutaties op deze tenant. Nieuwste bovenaan. Filter op actie-prefix, actor of target-type om de lijst te beperken.",
      "empty": "Geen audit-regels die voldoen aan de huidige filters.",
      "diffShow": "Toon diff",
      "pageOf": "Pagina {current} van {total}",
      "filters": {
        "actionPlaceholder": "user.",
        "actorComboPlaceholder": "Zoek op naam of e-mail…",
        "actorComboAria": "Filter op actor",
        "sectionSuperadmins": "Superadmins",
        "sectionUsers": "Gebruikers",
        "targetTypePlaceholder": "User, Tenant…",
        "from": "Vanaf",
        "to": "Tot en met",
        "clearAll": "Wis alle filters"
      },
      "cols": {
        "when": "Wanneer",
        "actor": "Actor",
        "action": "Actie",
        "target": "Target",
        "diff": "Diff"
      }
    },
    "superadmins": {
      "heading": "Superadmins",
      "intro": "Beheer het platform-team. Voeg een collega toe, hernoem of reset een wachtwoord, verwijder iemand die weggaat.",
      "new": "Superadmin toevoegen",
      "edit": "Superadmin aanpassen",
      "empty": "Nog geen superadmins — dat is vreemd; de geseede superadmin zou hier moeten staan.",
      "mfaOn": "MFA aan",
      "mfaOff": "MFA uit",
      "resetPassword": "Wachtwoord resetten",
      "resetPasswordSubmit": "Wachtwoord resetten",
      "resetPasswordBody": "Stel een nieuw wachtwoord in voor {name}. Bij de volgende login moet dit gebruikt worden.",
      "confirmDelete": "Superadmin verwijderen?",
      "confirmDeleteBody": "Soft-delete van {name}. Audit-log-entries blijven bewaard; eventuele sessie wordt bij het volgende verzoek geïnvalideerd.",
      "cols": {
        "name": "Naam",
        "email": "E-mail",
        "mfa": "MFA"
      },
      "fields": {
        "name": "Naam",
        "email": "E-mail",
        "password": "Wachtwoord",
        "passwordHint": "Minimaal 12 tekens met letters (hoofd- en kleine) en cijfers."
      }
    }
  },
  "tenantSetup": {
    "heading": "Tenant-setup",
    "intro": "Alles wat deze tenant nodig heeft om van start te gaan of om later aan te passen. Selecteer een onderdeel om erin te duiken.",
    "comingSoon": "Binnenkort",
    "impersonate": "Inloggen als tenant-beheerder",
    "impersonateGenericError": "Kon geen login-URL aanmaken voor deze tenant.",
    "impersonateUrlTitle": "Eenmalige tenant-beheerder login-URL",
    "impersonateUrlBody": "Open deze URL in deze browser, of kopieer hem om in een andere browser of incognitovenster te gebruiken. Hij werkt eenmalig en verloopt na korte tijd.",
    "impersonateUrlOpen": "Openen in nieuw tabblad",
    "sections": {
      "orgStructure": {
        "title": "Organisatiestructuur",
        "description": "Definieer de categorieën, hun hiërarchie en aanvullende velden die de tenant-beheerder per unit kan invullen."
      },
      "imports": {
        "title": "Gebruikersimport",
        "description": "CSV-uploads, SFTP-koppelingen of HR-systeem-integraties (AFAS, YouForce, HR2Day, Polaris)."
      },
      "platformSettings": {
        "title": "Platform-instellingen",
        "description": "Branding, auth-driver, licentie-limieten en andere tenant-brede instellingen."
      },
      "auditLog": {
        "title": "Audit-log",
        "description": "Alleen-lezen overzicht van mutaties op deze tenant: wie heeft wat wanneer aangepast. Filter op actie, actor of target-type."
      }
    }
  },
  "platformAssets": {
    "add": "Afbeeldingen toevoegen",
    "addError": "Toevoegen is niet gelukt. Probeer het opnieuw.",
    "confirmRemove": "Weet je het zeker? De afbeelding verdwijnt voor iedereen die hem gebruikt.",
    "empty": "Er staat nog geen afbeelding in de bibliotheek.",
    "heading": "Platform-bibliotheek",
    "intro": "De afbeeldingen die wij meeleveren. Ze worden niet gekopieerd naar omgevingen: ze staan hier één keer. Klik een afbeelding aan om te zien waar hij staat, hem uit te rollen of weer in te trekken. Alleen png en jpg, meerdere tegelijk mag.",
    "loadError": "De bibliotheek kon niet worden opgehaald.",
    "next": "Volgende",
    "pageOf": "Pagina {page} van {total}",
    "pagination": "Paginering",
    "prev": "Vorige",
    "push": "Uitrollen",
    "pushConfirm": "Uitrollen naar {count} omgeving(en)",
    "pushError": "Uitrollen is niet gelukt. Probeer het opnieuw.",
    "syncError": "Bijwerken in de omgevingen is niet gelukt.",
    "altError": "De alt-tekst kon niet worden opgeslagen.",
    "revokeError": "Intrekken is niet gelukt.",
    "pushHas": "Heeft hem al",
    "pushIntro": "Kies naar welke omgevingen dit beeld gaat. Er gebeurt niets bij omgevingen die je niet aanvinkt.",
    "sourceChangedHint": "Dit staat er nu bij de bron. Neem je het over, dan wordt dit de afbeelding — in élke omgeving die hem in haar bibliotheek heeft, overal waar hij gebruikt wordt.",
    "syncDone": "{pushed} beschikbaarheden toegevoegd over {tenants} omgevingen. Beelden die een beheerder had weggehaald zijn met rust gelaten.",
    "sync": "Bijwerken in alle omgevingen",
    "altHint": "Deze tekst krijgt elke omgeving erbij. Een omgeving kan hem per taal overschrijven met een eigen tekst; waar ze dat niet doet, blijft deze staan.",
    "altHeading": "Meegeleverde alt-tekst",
    "selectAll": "Alle omgevingen",
    "rolloutHeading": "Uitrollen naar omgevingen",
    "pushLoadError": "De omgevingen konden niet worden opgehaald.",
    "pushRemoved": "Weggehaald door klant",
    "revokeFor": "Intrekken bij {name}",
    "revoke": "Intrekken",
    "pushRevoked": "Door ons ingetrokken",
    "remove": "Verwijderen",
    "removeError": "Verwijderen is niet gelukt. Probeer het opnieuw.",
    "removeFor": "{name} verwijderen"
  },
  "platformLocales": {
    "heading": "Platform-talen",
    "intro": "De lijst met talen waaruit tenants kunnen kiezen. Uitgeschakelde talen blijven zichtbaar voor referentie maar verschijnen niet meer in tenant-formulieren. Een taal toevoegen betekent niet dat er direct een vertaling beschikbaar is — zorg dat de bijbehorende src/shared/i18n/locales/[code].json bundle bestaat, anders zien gebruikers Engelse fallback-teksten.",
    "new": "Taal toevoegen",
    "edit": "Taal wijzigen",
    "empty": "Nog geen talen. Voeg er één toe om tenants de keuze te geven.",
    "on": "Actief",
    "off": "Uit",
    "cols": {
      "code": "Code",
      "label": "Label",
      "enabled": "Actief"
    },
    "confirmDelete": "Taal verwijderen?",
    "confirmDeleteBody": "Verwijder {label} ({code}) uit de catalogus. Tenants die deze code nog in hun instellingen hebben staan, verliezen hem stilletjes bij de volgende opslag.",
    "fields": {
      "code": "Code",
      "codeHint": "Alleen een taal waarvoor het platform teksten heeft: {codes}.",
      "label": "Eigen naam",
      "labelHint": "Hoe sprekers van de taal de taalnaam zelf schrijven (Nederlands, Deutsch, Français, …).",
      "position": "Volgorde",
      "positionHint": "Lagere getallen komen bovenaan in tenant-dropdowns.",
      "enabled": "Actief"
    }
  },
  "orgStructure": {
    "userFields": {
      "heading": "Gebruikersvelden",
      "intro": "Geldt voor alle gebruikers van deze tenant. Definieer het externe-ID-label, aanvullende velden (dezelfde types als bij units) en het weergavenaam-format."
    },
    "userStructure": {
      "title": "Gebruikersstructuur",
      "summary": "{count} aanvullende velden · weergavenaam:"
    },
    "heading": "Organisatiestructuur",
    "intro": "Definieer de categorieën, hun hiërarchie en aanvullende velden die de tenant-beheerder per unit kan invullen. De volgorde verplaats je door de regels te slepen.",
    "new": "Categorie toevoegen",
    "edit": "Categorie wijzigen",
    "empty": "Nog geen categorieën gedefinieerd. Voeg de eerste toe om te beginnen.",
    "customFields": "aanvullend(e) veld(en)",
    "confirmDelete": "Categorie verwijderen?",
    "confirmDeleteBody": "Verwijdert {name}. Units op deze categorie en alle gebruikerstoewijzingen daarop verdwijnen — typ {name} ter bevestiging.",
    "confirmDeletePrompt": "Type de naam van de categorie om te bevestigen",
    "moveUpSibling": "Omhoog binnen zussen/broers",
    "moveDownSibling": "Omlaag binnen zussen/broers",
    "moveOutdent": "Eén niveau hoger (uit de bovenliggende categorie)",
    "moveIndent": "Eén niveau lager (onder de categorie erboven)",
    "dragHint": "Sleep een categorie: laat los op een andere categorie om die als ouder te kiezen, of laat boven/onder los om hem op dezelfde laag te plaatsen.",
    "dragHandle": "Versleep om te verplaatsen",
    "badge": {
      "required": "Verplicht",
      "multiple": "Meerdere"
    },
    "fields": {
      "key": "Sleutel",
      "keyHint": "Stabiele identifier, kleine letters/cijfers/streepjes/underscores. Wordt straks gebruikt in de HR-import-mapping-UI.",
      "parent": "Valt onder",
      "parentNone": "Geen (bovenste niveau)",
      "parentHint": "Bepaalt waar deze categorie in de boom hangt — hetzelfde als slepen, maar preciezer.",
      "labelFor": "Label ({locale})",
      "fieldSchema": "Aanvullende velden voor units in deze categorie",
      "fieldSchemaHint": "Vorm: { \"fields\": [{ \"key\": \"code\", \"type\": \"string\", \"required\": true, \"label\": { \"nl\": \"Code\" } }] }. Types: string, text, email, number, date, boolean, userid.",
      "fieldSchemaHintShort": "Elk veld dat je hier definieert wordt een getypeerde invoer op elke unit in deze categorie (in de tenant-omgeving)."
    },
    "membership": {
      "heading": "Gebruikers-lidmaatschap",
      "hint": "Bepaalt hoe gebruikers gekoppeld worden aan units in deze categorie.",
      "membershipRequired": "Elke gebruiker moet in minstens één unit van deze categorie zitten.",
      "allowMultipleUnits": "Een gebruiker mag in meerdere units van deze categorie zitten.",
      "allowNesting": "Een unit mag onder een andere unit van dezelfde categorie hangen.",
      "allowNestingHint": "Zet dit aan als uw structuur bijvoorbeeld teams binnen teams kent. Staat het uit, dan kan een unit alleen onder de bovenliggende categorie hangen.",
      "ancestorAutoRequiredHint": "Een verplichte categorie maakt zijn bovenliggende categorieën impliciet ook verplicht (anders kan de gebruiker geen unit kiezen).",
      "impactWarn": "{count} bestaande gebruiker(s) hebben nu geen unit in deze categorie — hun account blijft actief, maar bij een volgende bewerking moet er een keuze gemaakt worden.",
      "impactSoftValidated": "Deze categorie heeft nog geen units; verplicht-stellen heeft pas effect zodra je ze toevoegt."
    },
    "externalIdLabel": {
      "heading": "Label externe ID",
      "hint": "Het externe-ID veld is altijd aanwezig op elke unit in deze categorie. Hier kun je het label aanpassen — bijvoorbeeld \"Kostenplaats\". Leeg laten gebruikt het standaardlabel \"Externe ID\".",
      "labelFor": "Label ({locale})"
    }
  },
  "tenant": {
    "dashboard": {
      "heading": "Mijn dashboard",
      "intro": "Wat er op je wacht, op één plek.",
      "loading": "Je dashboard wordt geladen…",
      "loadError": "Je dashboard kon niet worden geladen.",
      "retry": "Opnieuw proberen",
      "emptyTitle": "Er wacht nu niets op je",
      "emptyBody": "Zodra er een taak, een goedkeuring, een training of een aanvraag voor je is, staat die hier.",
      "block": {
        "loading": "Laden…",
        "loadError": "Dit blok kon niet worden geladen.",
        "retry": "Opnieuw proberen",
        "viewAll": "Bekijk alles",
        "count_one": "{count} open",
        "count_other": "{count} open"
      },
      "tasks": {
        "title": "Mijn taken",
        "empty": "Je hebt geen openstaande taken.",
        "openUntil": "Open tot {date}",
        "submittedOn": "Ingestuurd op {date}",
        "attendanceSince": "Presentie open sinds {date}",
        "untitledActivity": "Training zonder titel",
        "typeLink": "{label} ({count})",
        "kind": {
          "questionnaire": "Vragenlijst",
          "grading": "Nakijken",
          "attendance": "Presentie"
        }
      },
      "approvals": {
        "title": "Openstaande goedkeuringen",
        "empty": "Er wachten geen goedkeuringen op je.",
        "unknownApplicant": "Onbekende aanvrager",
        "decideBefore": "Beslis vóór {date}",
        "kind": {
          "enrollment": "Inschrijving",
          "cancellation": "Annulering",
          "external_request": "Externe opleiding",
          "other": "Aanvraag"
        }
      },
      "myCourses": {
        "title": "Mijn opleidingen",
        "count_one": "{count} opleiding",
        "count_other": "{count} opleidingen",
        "empty": "Je staat nergens voor ingeschreven waar iets van je gevraagd wordt of dat nu loopt.",
        "progress": "{percent}% doorlopen",
        "state": {
          "waiting": "Wacht op jou",
          "active": "Bezig",
          "upcoming": "Komt eraan"
        },
        "action": {
          "respond_offer": "Je hebt een plek aangeboden gekregen: reageer erop",
          "fill_questionnaire_one": "Een vragenlijst of toets wacht op je",
          "fill_questionnaire_other": "{count} vragenlijsten of toetsen wachten op je",
          "start": "Nog niet gestart",
          "continue": "Ga verder",
          "attend": "Bijeenkomst"
        }
      },
      "nextTraining": {
        "title": "Mijn eerstvolgende training",
        "empty": "Er staat geen training meer voor je gepland."
      },
      "myLessons": {
        "title": "Mijn lessen deze week",
        "empty": "Je geeft deze week geen les.",
        "count_one": "{count} les",
        "count_other": "{count} lessen"
      },
      "session": {
        "inZone": "{when} (tijdzone {zone})"
      },
      "myRequests": {
        "empty": "Je hebt geen lopende aanvragen.",
        "emptyCanStart": "Vraag een opleiding aan die niet in de catalogus staat."
      }
    },
    "adminDashboard": {
      "heading": "Dashboard",
      "intro": "Wat er op je bord ligt, wat er vandaag gebeurde en wat er in je omgeving staat.",
      "loading": "Het dashboard wordt geladen…",
      "loadError": "Het dashboard kon niet worden geladen.",
      "retry": "Opnieuw proberen",
      "emptyTitle": "Hier staat nog niets voor je",
      "emptyBody": "Je rechten geven geen van de blokken van het beheerders-dashboard. Gebruik het menu om verder te gaan.",
      "nothingWaiting": "Niets wat op je wacht.",
      "zones": {
        "waiting": "Wat wacht op mij",
        "today": "Wat gebeurde er vandaag",
        "now": "Wat gebeurt er nu",
        "environment": "Wat is er in mijn omgeving"
      },
      "signals": {
        "title": "Signalen",
        "empty": "Geen signalen.",
        "count_one": "{count} signaal",
        "count_other": "{count} signalen",
        "cancelledToday_one": "{count} annulering vandaag",
        "cancelledToday_other": "{count} annuleringen vandaag",
        "belowMinimum": "Onder het minimum: {taken} van minimaal {minimum} deelnemers",
        "decide": "Gaat deze training door?"
      },
      "logins": {
        "title": "Ingelogd",
        "today": "Vandaag",
        "yesterday": "Gisteren voor het laatst"
      },
      "enrollmentsToday": {
        "title": "Inschrijvingen vandaag",
        "enrolled": "Inschrijvingen",
        "cancelled": "Annuleringen"
      },
      "logStrip": {
        "title": "Recent in het logboek",
        "empty": "Nog geen inlogs, inschrijvingen of annuleringen in het logboek.",
        "someone": "Iemand",
        "login": "{name} logde in",
        "enrollment": "{name} schreef in voor {course}",
        "enrollmentNoCourse": "{name} schreef in",
        "cancellation": "{name} annuleerde voor {course}",
        "cancellationNoCourse": "{name} annuleerde een inschrijving",
        "enrollmentByOther": "{actor} schreef {participant} in voor {course}",
        "enrollmentByOtherNoCourse": "{actor} schreef {participant} in",
        "enrollmentNoActor": "{participant} is ingeschreven voor {course}",
        "enrollmentNoActorNoCourse": "{participant} is ingeschreven",
        "cancellationByOther": "{actor} annuleerde de inschrijving van {participant} voor {course}",
        "cancellationByOtherNoCourse": "{actor} annuleerde de inschrijving van {participant}",
        "cancellationNoActor": "De inschrijving van {participant} voor {course} is geannuleerd",
        "cancellationNoActorNoCourse": "De inschrijving van {participant} is geannuleerd",
        "erased": "Verwijderde gebruiker"
      },
      "shortcuts": {
        "title": "Snelkoppelingen",
        "empty": "Geen snelkoppelingen.",
        "users": "Actieve gebruikers",
        "catalog": "Catalogus"
      },
      "failedCertificates": {
        "title": "Certificaten niet gemaakt",
        "count_one": "{count} certificaat",
        "count_other": "{count} certificaten",
        "empty": "Alle certificaten zijn gemaakt."
      },
      "documentTemplateUpdates": {
        "title": "Nieuwe versie van een BCS-sjabloon",
        "count_one": "{count} sjabloon",
        "count_other": "{count} sjablonen",
        "empty": "Geen nieuwe versies.",
        "versions": "Versie {from} → {to}",
        "tenant_logo_changed": "Nieuw logo van de omgeving",
        "tenant_logo_removed": "Logo van de omgeving verwijderd"
      }
    },
    "sendMessage": {
      "title": "Stuur bericht",
      "intro": "Stel een bericht op en kies wie het ontvangt. Je ziet vooraf hoeveel gebruikers het bereikt.",
      "subject": "Onderwerp",
      "body": "Bericht",
      "audience": "Ontvangers",
      "segmentType": "Doelgroep",
      "types": {
        "individuals": "Losse gebruikers",
        "orgUnits": "Organisatie-units",
        "orgUnitManagers": "Managers van units",
        "everyone": "Iedereen",
        "everyoneHint": "Alle actieve gebruikers."
      },
      "pickUsers": "Zoek en kies gebruikers…",
      "pickUnits": "Zoek en kies units…",
      "includeDescendants": "Inclusief onderliggende units",
      "addSegment": "Doelgroep toevoegen",
      "attachments": "Bijlagen",
      "addAttachment": "Bijlage toevoegen",
      "attachmentError": "Uploaden mislukt — controleer bestandstype en grootte (max 10 MB).",
      "timing": "Verzendmoment",
      "when": "Wanneer verzenden",
      "whenNow": "Direct",
      "whenLater": "Plannen op datum/tijd",
      "scheduledFor": "Verzenden op",
      "reaches": "Bereikt {count} gebruiker(s)",
      "noAudience": "Nog geen doelgroep gekozen.",
      "send": "Verzenden",
      "sent": "Bericht ingepland voor {count} ontvanger(s).",
      "confirmTitle": "Bericht verzenden?",
      "confirmBody": "Dit bericht wordt verstuurd naar {count} gebruiker(s).",
      "confirmBodyUnknown": "Weet je zeker dat je dit bericht wilt verzenden?",
      "confirmSend": "Ja, verzenden",
      "editor": {
        "toolbar": "Opmaak",
        "bold": "Vet",
        "italic": "Cursief",
        "underline": "Onderstrepen",
        "heading": "Kop",
        "bulletList": "Opsomming",
        "numberList": "Genummerde lijst",
        "alignLeft": "Links uitlijnen",
        "alignCenter": "Centreren",
        "alignRight": "Rechts uitlijnen",
        "link": "Link invoegen",
        "linkPrompt": "Voer een https-URL in:",
        "linkTitle": "Link invoegen",
        "linkTextLabel": "Tekst",
        "linkUrlLabel": "URL",
        "linkInsert": "Invoegen",
        "linkInvalid": "Gebruik een https:// of mailto: link.",
        "linkChipHint": "De tag {tag} wordt de klikbare link.",
        "linkRemove": "Link verwijderen"
      }
    }
  },
  "orgChart": {
    "heading": "Organogram",
    "coverage": {
      "title": "Wie zit er in {name}?",
      "back": "Terug naar de groep",
      "today": "Dit is wie er vandaag in valt. Een groep werkt met regels, dus morgen kan dat een ander zijn.",
      "ofTotal": "{members} van de {total}",
      "emptyUnit": "geen mensen",
      "namedIncluded": "door de regel ingesloten",
      "namedExcluded": "door de regel uitgesloten",
      "legendFull": "iedereen zit erin",
      "legendSome": "een deel zit erin",
      "legendNone": "niemand zit erin",
      "legendNamedIncluded": "regel noemt deze eenheid: insluiten",
      "legendNamedExcluded": "regel noemt deze eenheid: uitsluiten",
      "total": "In totaal {count} mensen.",
      "unplaced": "Daarvan zitten er {count} in geen enkele eenheid, dus die staan hier niet op.",
      "unavailable": "We konden niet ophalen wie deze groep omvat."
    },
    "hint": "Sleep een blok op z'n nieuwe bovenliggende unit om te verplaatsen; sleep de achtergrond om te verschuiven, scroll om te zoomen. Toetsenbord: pijltjes = navigeren, Enter = unit bewerken, spatie = in-/uitklappen.",
    "levelFilter": "Toon categorieën",
    "search": "Zoek een unit…",
    "expandAll": "Alles uitklappen",
    "collapseAll": "Alles inklappen",
    "export": "Exporteer als afbeelding (PNG)",
    "exportPdf": "Download als PDF — scherpe vector-tekst, ook bij grote organogrammen",
    "print": "Print organogram",
    "hits_one": "{count} treffer — Enter springt ernaartoe",
    "hits_other": "{count} treffers — Enter springt ernaartoe",
    "back": "Tabelweergave",
    "fit": "Passend in beeld",
    "zoomIn": "Inzoomen",
    "zoomOut": "Uitzoomen",
    "expand": "Onderliggende units uitklappen",
    "collapse": "Onderliggende units inklappen",
    "members_one": "{count} lid",
    "members_other": "{count} leden",
    "empty": "Nog geen units — maak ze eerst aan in de tabelweergave.",
    "toUnits": "Naar organisatie-units"
  },
  "orgUnitsList": {
    "heading": "Units per categorie",
    "viewChart": "Organogram",
    "intro": "Overzicht per categorie. Klik op een tab voor een andere categorie en op een rij voor de detailpagina.",
    "level": "Categorie",
    "searchPlaceholder": "Zoeken op naam, externe ID, bovenliggende of attribuut…",
    "addFor": "Nieuwe {level}",
    "empty": "Geen units in deze categorie. Voeg er een toe of pas je zoekopdracht aan.",
    "unknownUser": "Onbekende gebruiker",
    "viewMembers": "Bekijk de {count} leden van deze unit",
    "col": {
      "name": "Naam",
      "parent": "Bovenliggend",
      "members": "Leden"
    }
  },
  "unitDetail": {
    "loading": "Laden…",
    "detailsHeading": "Details",
    "membersHeading": "Leden",
    "membersNonLeafHint": "Gebruikers hangen doorgaans aan het diepste niveau; deze unit kan ook leden hebben maar dat is uitzonderlijk.",
    "noMembers": "Nog geen leden.",
    "childrenHeading": "Onderliggende units",
    "noChildren": "Nog geen onderliggende units."
  },
  "userProfile": {
    "avatar": {
      "heading": "Profielfoto",
      "upload": "Foto uploaden",
      "replace": "Foto vervangen",
      "remove": "Verwijderen",
      "present": "Er staat een profielfoto",
      "cropTitle": "Foto bijsnijden",
      "cropHint": "Sleep om te verplaatsen en gebruik de schuif om te zoomen.",
      "cropZoom": "Zoomen",
      "cropConfirm": "Toepassen"
    },
    "loading": "Laden…",
    "openLink": "Profiel",
    "detailsHeading": "Profielgegevens",
    "assignmentsHeading": "Organisatie-lidmaatschap",
    "assignmentsHint": "Per categorie kies je in welke unit(s) deze gebruiker zit. Een sub-categorie wordt actief zodra de bovenliggende categorie is gevuld.",
    "noCategories": "Geen categorieën gedefinieerd — vraag BCS Learning om de organisatiestructuur in te vullen.",
    "noUnitsForCategory": "Geen units in \"{category}\" — voeg eerst toe via Organisatiestructuur.",
    "pickPlaceholder": "Kies…",
    "pickerLockedNoParent": "Vul eerst \"{parent}\" om hier een keuze te kunnen maken.",
    "cascadeClearedToast": "Verwijderd uit \"{category}\": {names} (parent gewijzigd)",
    "save": "Opslaan",
    "savedToast": "Toewijzingen opgeslagen.",
    "saveError": "Opslaan mislukt — controleer de foutmeldingen per categorie.",
    "customFieldsHeading": "Aanvullende gegevens",
    "deletedBanner": "Deze gebruiker is verwijderd. Bewerken is uitgeschakeld — je kunt de gebruiker herstellen of de gegevens definitief wissen.",
    "lastLogin": "Laatst ingelogd: {when}",
    "lastLoginNever": "Nog nooit ingelogd",
    "restore": "Gebruiker herstellen",
    "restoreError": "Herstellen mislukt. Probeer het opnieuw.",
    "gdpr": {
      "heading": "Privacy (AVG)",
      "intro": "Exporteer alle gegevens van deze gebruiker, of wis ze definitief op verzoek.",
      "export": "Gegevens exporteren",
      "exportError": "Exporteren mislukt. Probeer het opnieuw.",
      "erase": "Gegevens wissen",
      "eraseError": "Wissen mislukt. Probeer het opnieuw.",
      "eraseConfirmTitle": "Gegevens definitief wissen?",
      "eraseConfirmBody": "Dit verwijdert {name} onherstelbaar: profiel, koppelingen en lidmaatschappen. Voor de audit-trail blijven geanonimiseerde sporen bewaard. Dit kan niet ongedaan worden gemaakt.",
      "eraseConfirmLabel": "Typ ter bevestiging het e-mailadres: {email}"
    }
  },
  "tenantUsers": {
    "heading": "Gebruikers",
    "new": "Nieuwe gebruiker",
    "edit": "Gebruiker wijzigen — {name}",
    "empty": "Nog geen gebruikers.",
    "impersonate": "Inloggen als",
    "impersonateFailed": "Inloggen als deze gebruiker is niet gelukt.",
    "confirmDelete": "Gebruiker verwijderen?",
    "confirmDeleteBody": "Soft-delete {name}. De audit-trail blijft bewaard.",
    "viewDeleted": "Verwijderde gebruikers",
    "backToActive": "Terug naar actieve gebruikers",
    "deletedHeading": "Verwijderde gebruikers",
    "deletedListIntro": "Je bekijkt verwijderde gebruikers. Open een profiel om de gebruiker te herstellen of de gegevens definitief te wissen.",
    "deletedEmpty": "Geen verwijderde gebruikers.",
    "bulkErase": "Definitief wissen ({count})",
    "bulkEraseTitle": "Gebruikers definitief wissen?",
    "bulkEraseBody": "Je staat op het punt {count} gebruiker(s) onherstelbaar te wissen: profielen, koppelingen en lidmaatschappen. Voor de audit-trail blijven geanonimiseerde sporen bewaard. Dit kan niet ongedaan worden gemaakt.",
    "bulkEraseConfirmLabel": "Typ ter bevestiging het aantal: {count}",
    "bulkEraseConfirm": "Definitief wissen",
    "bulkEraseError": "Wissen mislukt. Probeer het opnieuw.",
    "bulkEraseDone": "{count} gebruiker(s) definitief verwijderd.",
    "bulkEraseDoneSkipped": "{count} gebruiker(s) definitief verwijderd; {skipped} overgeslagen (laatste beheerder).",
    "bulkEraseDonePartial": "{count} gebruiker(s) definitief verwijderd. {failed} konden niet worden gewist en staan nog in de lijst; de fout is gemeld.",
    "bulkEraseDonePartialSkipped": "{count} gebruiker(s) definitief verwijderd; {skipped} overgeslagen (laatste beheerder). {failed} konden niet worden gewist en staan nog in de lijst; de fout is gemeld.",
    "fields": {
      "name": "Naam",
      "firstName": "Voornaam",
      "lastName": "Achternaam",
      "displayNameLabel": "Weergavenaam:",
      "email": "E-mail",
      "role": "Rol",
      "status": "Status",
      "isExternal": "Externe gebruiker",
      "isExternalHint": "Geen dienstverband bij deze organisatie — bijvoorbeeld een auditor, een freelance docent of een ZZP'er. Een bericht aan \"iedereen\" gaat standaard niet naar externe accounts.",
      "isLearner": "Volgt opleidingen",
      "isLearnerHint": "Deze persoon leert en telt mee in de rapportage over gevolgde activiteiten. Staat los van extern: een ZZP'er is extern én lerend, een auditor extern en niet-lerend. Uit betekent ook: geen basisrol Gebruiker.",
      "externalId": "Externe ID",
      "phone": "Telefoon",
      "hireDate": "Datum in dienst",
      "endDate": "Datum uit dienst",
      "accountValidFrom": "Account geldig vanaf",
      "accountValidFromHint": "Vóór deze datum kan de gebruiker nog niet inloggen. Leeg = meteen geldig.",
      "accountValidUntil": "Account geldig tot",
      "accountValidUntilHint": "Na deze datum kan de gebruiker niet meer inloggen. Leeg = onbeperkt geldig.",
      "deletedAt": "Verwijderd op",
      "roles": "Rollen"
    },
    "status": {
      "active": "Actief",
      "invited": "Uitgenodigd",
      "suspended": "Geschorst",
      "expired": "Verlopen",
      "not_yet_valid": "Nog niet geldig"
    },
    "roles": {
      "tenant-admin": "Beheerder",
      "user": "Gebruiker"
    },
    "filteredByUnit": "Gefilterd op leden van \"{unit}\".",
    "clearFilter": "Toon alle gebruikers",
    "baseRoleNote": "Iedere nieuwe gebruiker krijgt daarnaast de basisrol Gebruiker.",
    "createdButRoleFailed": "De gebruiker is aangemaakt, maar niet alle rollen konden worden toegekend:",
    "toProfile": "Naar het profiel",
    "filteredByRole": "Alleen gebruikers met de rol \"{role}\".",
    "manageRoles": "Rollen en bereik beheren →",
    "pickRoles": "Kies een of meer rollen"
  },
  "orgUnits": {
    "heading": "Organisatie-units",
    "missingParent": "Mist verplichte bovenliggende unit",
    "missingParentBanner_one": "{count} unit hoort volgens de huidige structuur onder een bovenliggende unit te hangen, maar heeft er geen. Koppel de unit via Bewerken.",
    "missingParentBanner_other": "{count} units horen volgens de huidige structuur onder een bovenliggende unit te hangen, maar hebben er geen. Koppel ze via Bewerken.",
    "intro": "Vul de boom in die door de superadmin is gedefinieerd. Voeg kinderen toe, wijzig attributen en wijs gebruikers toe.",
    "new": "Unit toevoegen",
    "edit": "Unit wijzigen",
    "empty": "Nog geen units. Voeg bovenaan je eerste organisatie toe.",
    "noLevelsTitle": "Geen categorieën gedefinieerd",
    "noLevelsBody": "Vraag BCS Learning om eerst ten minste één categorie te definiëren voordat je units kunt toevoegen.",
    "confirmDelete": "Unit verwijderen?",
    "confirmDeleteBody": "Soft-delete {name}. Dit kan pas als de eenheid leeg is: geen medewerkers erin en geen onderliggende eenheden eronder.",
    "impactUnavailable": "We konden niet ophalen wat er aan deze eenheid hangt. Probeer het opnieuw voor je verwijdert.",
    "impact": {
      "blockedLead": "Dit kan nu niet — de eenheid is niet leeg:",
      "losingLead": "Dit vervalt zodra je verwijdert:",
      "users": "{count} medewerker(s) zitten er nog in",
      "children": "{count} onderliggende eenheid(en) hangen eronder",
      "roleAssignments": "{count} rol-toewijzing(en) met een bereik op deze eenheid geven daarmee niets meer",
      "accessGroups": "{count} toegangsgroep(en) worden kapot en omvatten niemand meer",
      "exclusions": "Let op: {count} toegangsgroep(en) sluiten deze eenheid juist uit. Ook die worden kapot en omvatten niemand meer — tot je ze repareert.",
      "nothingAttached": "Er hangt verder niets aan deze eenheid.",
      "groupNames": "Het gaat om: {names}."
    },
    "assignTitle": "Gebruiker aan unit toewijzen",
    "assignBody": "Kies een gebruiker om aan {name} toe te wijzen. Alleen actieve toewijzingen staan op het profiel.",
    "assign": "Toewijzen",
    "fields": {
      "level": "Categorie",
      "name": "Naam",
      "externalId": "Externe ID",
      "externalIdHint": "Stabiele id uit je HR-systeem — gebruikt bij her-import van hetzelfde record.",
      "attributes": "Aanvullende attributen",
      "attributesHint": "Waarden voor de aanvullende velden die bij deze categorie gedefinieerd zijn.",
      "parent": "Bovenliggende unit",
      "parentOf": "Bovenliggende {level}",
      "parentHintFree": "Optioneel. De unit waaronder deze hangt in de boom.",
      "parentHintConstrained": "Deze categorie hangt onder \"{level}\" — alleen units in die categorie worden getoond.",
      "parentRequired": "Deze categorie moet onder een bovenliggende unit hangen — kies er een.",
      "pickParent": "kies een bovenliggende unit",
      "noParent": "— geen bovenliggende (root) —",
      "user": "Gebruiker"
    }
  },
  "fieldSchema": {
    "empty": "Nog geen aanvullende velden. Klik op \"Veld toevoegen\" om de eerste te definiëren.",
    "addField": "Veld toevoegen",
    "fields": {
      "key": "Sleutel",
      "type": "Type",
      "required": "Verplicht",
      "labelFor": "Label ({locale})",
      "role": "Rol"
    },
    "dragHandle": "Sleep om te verplaatsen",
    "labels": {
      "expand": "Toon labels",
      "collapse": "Verberg labels",
      "none": "Geen labels ingevuld",
      "collapsedSummary": "Labels ingevuld voor:"
    },
    "errors": {
      "invalidKey": "Gebruik kleine letters, cijfers, streepjes of underscores (bv. \"kostenplaats\").",
      "duplicateKey": "Deze sleutel wordt al gebruikt in deze categorie."
    },
    "roles": {
      "none": "Geen rol (eigen veld)"
    }
  },
  "orgFields": {
    "types": {
      "string": "Tekst (één regel)",
      "text": "Tekst (meerdere regels)",
      "email": "E-mail",
      "number": "Getal",
      "date": "Datum",
      "boolean": "Ja / Nee",
      "userid": "Gebruiker (bv. manager)"
    }
  },
  "attributeForm": {
    "noFields": "Deze categorie heeft geen aanvullende velden.",
    "required": "Dit veld is verplicht.",
    "boolean": {
      "label": "Ja"
    }
  },
  "profile": {
    "prefs": {
      "heading": "Voorkeuren",
      "rememberDrafts": "Concepten onthouden op formulieren",
      "rememberDraftsHint": "Bewaart wat je invult lokaal, op alle pagina's, zodat je het niet kwijtraakt."
    },
    "mfa": {
      "title": "Tweestapsverificatie",
      "intro": "Een extra stap bij het inloggen, naast je wachtwoord. Je hebt er een authenticator-app voor nodig.",
      "start": "Instellen",
      "qrAlt": "QR-code voor je authenticator-app",
      "secretHint": "Geen camera? Voer deze sleutel met de hand in:",
      "code": "Code uit de app",
      "confirm": "Inschakelen",
      "on": "Tweestapsverificatie staat aan.",
      "newCodes": "Nieuwe herstelcodes",
      "disable": "Uitschakelen",
      "codesTitle": "Bewaar deze herstelcodes",
      "codesHint": "Je ziet ze één keer. Bewaar ze ergens buiten je telefoon — zonder een van deze codes kom je er niet meer in als je je app kwijt bent.",
      "genericError": "Dat lukte niet. Probeer het opnieuw."
    },
    "heading": "Mijn profiel",
    "intro": "Pas je eigen gegevens aan. Je e-mail is vast: daar hangt je audit-trail aan.",
    "saved": "Opgeslagen.",
    "fields": {
      "email": "E-mail",
      "name": "Naam",
      "locale": "Taal",
      "localeHint": "De taal waarin jouw schermen worden weergegeven."
    }
  },
  "tenantAuth": {
    "title": "Bezig met inloggen",
    "verifying": "Je login-link wordt geverifieerd…",
    "success": "Ingelogd! Je wordt doorgestuurd naar je werkomgeving.",
    "failedTitle": "Inloggen mislukt",
    "genericError": "Inloggen is niet gelukt. Vraag je beheerder om een nieuwe login-link.",
    "sessionExpired": "Je sessie is verlopen. Open je dev-login-URL opnieuw om in te loggen.",
    "needLoginUrl": "Log in door de dev-login-URL te openen die je beheerder je heeft gestuurd.",
    "loginUrlHint": "Elke URL werkt één keer en verloopt na 15 minuten — vraag een nieuwe aan als je hem al hebt gebruikt.",
    "backHome": "Terug naar home",
    "form": {
      "title": "Inloggen",
      "email": "E-mailadres",
      "password": "Wachtwoord",
      "remember": "Ingelogd blijven",
      "submit": "Inloggen",
      "forgotLink": "Wachtwoord vergeten?",
      "loading": "Laden…",
      "genericError": "Inloggen mislukt. Controleer je gegevens en probeer het opnieuw."
    },
    "forgot": {
      "title": "Wachtwoord vergeten?",
      "intro": "Vul je e-mailadres in en we sturen je een link om een nieuw wachtwoord in te stellen.",
      "email": "E-mailadres",
      "submit": "Reset-link versturen",
      "done": "Als er een account bij dit adres hoort, is er een reset-link onderweg. Bekijk je inbox.",
      "backToLogin": "Terug naar inloggen",
      "genericError": "Er ging iets mis. Probeer het opnieuw."
    },
    "reset": {
      "title": "Nieuw wachtwoord instellen",
      "intro": "Kies een nieuw wachtwoord voor je account.",
      "password": "Nieuw wachtwoord",
      "passwordConfirmation": "Bevestig nieuw wachtwoord",
      "submit": "Wachtwoord instellen",
      "success": "Je wachtwoord is ingesteld. Je kunt nu inloggen.",
      "toLogin": "Naar inloggen",
      "invalid": "Deze reset-link is ongeldig of verlopen. Vraag een nieuwe aan.",
      "genericError": "Er ging iets mis. Probeer het opnieuw.",
      "missingToken": "Deze pagina heeft een geldige reset-link nodig. Gebruik de link uit je e-mail."
    },
    "bcs": {
      "title": "Inloggen",
      "lead": "Log in met je BCS-account.",
      "button": "Inloggen met BCS",
      "failedTitle": "Inloggen mislukt",
      "failedBody": "Er ging iets mis bij het inloggen met BCS. Probeer het opnieuw."
    }
  },
  "imports": {
    "heading": "Gebruikersimport",
    "intro": "Geconfigureerde import-bronnen voor deze tenant. Elke bron beschrijft één HR-export-feed (bestand of feed) en hoe de kolommen omgezet worden naar gebruikers + units. Bronnen kunnen op een planning gaan draaien zodra ze actief gezet zijn.",
    "sources": {
      "heading": "Import-bronnen",
      "intro": "Elke regel is een geconfigureerde feed — bestandsupload, FTP-folder of API. Open er een om door de wizard te lopen.",
      "new": "Nieuwe import-bron",
      "run": "Uitvoeren",
      "empty": "Nog geen import-bronnen geconfigureerd. Klik op \"Nieuwe import-bron\" om de wizard te starten.",
      "confirmDelete": "Bron \"{name}\" verwijderen? Gebruikers en units die er al mee zijn geïmporteerd blijven bestaan — alleen de bron-koppeling vervalt.",
      "scheduleActive": "Actief",
      "scheduleOff": "Planning uit",
      "scheduleNoTimes": "Actief, maar nog geen tijdstippen ingesteld",
      "scheduleAt": "Draait dagelijks om {times}",
      "types": {
        "csv_upload": "CSV-upload",
        "csv_sftp": "FTP / SFTP",
        "api": "API"
      }
    },
    "preview": {
      "results": "Preview-resultaten",
      "downloadExcel": "Download als Excel",
      "columnMismatchBanner": "Eén of meer bestanden komen niet overeen met de opgeslagen kolommapping — velden zonder kolom blijven leeg bij de import. Check per slot de lijst met ontbrekende kolommen voor je doorgaat.",
      "missingColumns": "Mist in bestand",
      "extraColumns": "Extra in bestand (wordt genegeerd)",
      "errorClustersHeading": "Foutsamenvatting ({n} in totaal) — klik om uit te klappen",
      "summary": {
        "rows": "rijen",
        "users": "Gebruikers",
        "units": "Units",
        "assignments": "Toewijzingen",
        "errors": "Fouten",
        "create": "{n} aanmaken",
        "update": "{n} bijwerken",
        "unchanged": "{n} ongewijzigd",
        "skip": "{n} overslaan",
        "noFile": "Geen bestand aangeleverd voor dit slot."
      },
      "table": {
        "row": "#",
        "actions": "Geplande acties",
        "errors": "Fouten",
        "empty": "Niets te tonen — het bestand bevat geen rijen.",
        "capped": "De eerste 50 rijen + alle foutrijen worden getoond. Download Excel voor de volledige lijst."
      },
      "ops": {
        "create": "Aanmaken",
        "update": "Bijwerken",
        "skip_unchanged": "Ongewijzigd",
        "skip": "Overslaan",
        "skip_duplicate": "Duplicaat",
        "excluded": "Uitgesloten",
        "error": "Fout"
      },
      "opsShort": {
        "create": "nieuw",
        "update": "bijgewerkt",
        "unchanged": "ongewijzigd"
      }
    },
    "run": {
      "title": "Import uitvoeren",
      "intro": "Lever de bronbestanden voor deze configuratie aan. Elk bestand wordt op naam gekoppeld aan een geconfigureerd slot — check de matches, los eventuele mismatches op en draai een dry-run voor je commit.",
      "dropHere": "Sleep CSV-bestanden hierheen",
      "orPick": "of klik om bestanden te kiezen",
      "filesHeading": "Bestanden",
      "filesEmpty": "Nog geen bestanden. Sleep één of meer CSV-bestanden hierboven.",
      "vendorHeading": "Vendor-import — geen upload nodig",
      "vendorBody": "Records worden live opgehaald uit de {vendor}-API bij Preview of Run. De slots uit de mapping-stap worden in volgorde bevraagd.",
      "matchedSlot": "Gekoppeld slot",
      "noMatch": "Geen matchend slot",
      "skip": "Bestand overslaan",
      "duplicateMatch": "Twee bestanden zijn aan hetzelfde slot gekoppeld — kies voor één van beide een ander slot.",
      "missingSlots": "Voor deze geconfigureerde slots is nog geen bestand aangeleverd: {slots}",
      "headerToggle": "Eerste regel bevat kolomnamen",
      "headerToggleHint": "Uit = de eerste regel is data; kolomsleutels worden A/B/C/… in Excel-stijl.",
      "removeFile": "Verwijderen",
      "runPreview": "Preview starten",
      "rerun": "Preview opnieuw draaien",
      "running": "Preview wordt gedraaid…",
      "noFilesPicked": "Kies minstens één CSV om de preview te draaien.",
      "commit": "Import doorvoeren",
      "skipExisting": "{n} al gekoppeld",
      "confirmTitle": "Import doorvoeren?",
      "confirmBody": "De dry-run is read-only; bij deze stap wordt alles écht naar de database geschreven. Dezelfde bestanden later opnieuw importeren is veilig — al geïmporteerde rijen worden in-place bijgewerkt.",
      "confirmErrorsHint": "Een aantal rijen had fouten in de preview. Die rijen worden bij de commit overgeslagen; de rest landt normaal.",
      "confirmGo": "Ja, doorvoeren",
      "successTitle": "Import doorgevoerd",
      "successCount": "{n} rijen gewijzigd",
      "successDone": "Terug naar overzicht",
      "remoteFilesHeading": "Bestanden op de server",
      "slotResolveHeading": "Slot → bestandsmatch",
      "slotResolveNoPattern": "(geen match-patroon ingesteld; slot draait niet)",
      "slotResolveNoMatch": "(geen bestand op de server matcht)",
      "remoteFilesHint": "Wat er momenteel in {path} staat op de FTP-server. De import-job pakt het nieuwste bestand dat matcht met het patroon van elk slot.",
      "refreshRemote": "Verversen",
      "remoteEmpty": "Nog geen bestanden in de geconfigureerde externe map.",
      "confirmCommit": "Definitief doorvoeren"
    },
    "runs": {
      "heading": "Recente runs",
      "intro": "Alle import-pogingen — concepten in behandeling, voltooide runs en eventuele fouten.",
      "empty": "Nog geen runs voor deze tenant.",
      "discard": "Weggooien",
      "confirmDiscard": "Deze import-run weggooien? De geüploade bestanden en geparseerde rijen worden verwijderd. Voltooide runs kunnen niet worden weggegooid.",
      "unnamedMapping": "(mapping verwijderd)",
      "rowsSummary": "+{created} nieuw · ~{updated} bijgewerkt · {failed} mislukt",
      "status": {
        "draft": "Concept",
        "dry_run": "Dry-run",
        "running": "Bezig",
        "succeeded": "Voltooid",
        "failed": "Mislukt",
        "cancelled": "Geannuleerd"
      }
    },
    "runDetail": {
      "title": "Import-run",
      "source": "Bron",
      "noSource": "(onbekende bron)",
      "mapping": "Mapping",
      "actor": "Gestart door",
      "noActor": "(automatisch)",
      "startedAt": "Gestart",
      "finishedAt": "Afgerond",
      "duration": "Duur",
      "totalsHeading": "Totalen",
      "noChange": "Geen wijzigingen",
      "slotsHeading": "Per bestand",
      "errorRowsHeading": "Rijen met fouten",
      "errorRowsHint": "Gecapt op 50 rijen ter opslag. De dry-run Excel-export bevat de volledige lijst.",
      "noDetail": "Deze run is aangemaakt door een oudere import-flow die geen gedetailleerde samenvatting opslaat.",
      "failureTitle": "Run mislukt — er is niets opgeslagen",
      "failureBody": "De engine gooide een fout en de transactie is volledig teruggedraaid. De data staat in de toestand van vóór de run; los de input op en start een nieuwe run."
    },
    "wizard": {
      "titleNew": "Nieuwe import-bron",
      "titleEdit": "Import-bron wijzigen",
      "stepperLabel": "Wizard-stappen",
      "back": "Terug",
      "nextStep": "Volgende",
      "finish": "Afronden",
      "vendorDocsLink": "{vendor}-documentatie →",
      "steps": {
        "type": "Type & naam",
        "connection": "Verbinding",
        "mapping": "Mapping",
        "exclusions": "Uitsluitingen",
        "schedule": "Planning"
      },
      "step1": {
        "heading": "Stap 1 — type & naam",
        "hint": "Kies hoe deze tenant gegevens aanlevert. Fase 1 levert alleen bestandsupload; FTP en API volgen.",
        "name": "Naam",
        "nameRequired": "Geef de bron een herkenbare naam.",
        "type": "Type bron",
        "types": {
          "csv_upload": "CSV-upload",
          "csv_uploadHint": "Het implementatieteam upload het bestand of de bestanden zelf bij elke run.",
          "csv_sftp": "FTP / SFTP",
          "csv_sftpHint": "Bestanden worden volgens een planning opgehaald van een FTP-, SFTP- of FTPS-server.",
          "api": "API",
          "comingSoon": "Binnenkort"
        },
        "vendorConfig": "{vendor}-configuratie",
        "testVendorConn": "Test verbinding",
        "testVendorOk": "Verbinding werkt! Slot \"{slot}\" geprobeerd, {n} voorbeeldrecord opgehaald.",
        "testVendorFail": "Verbinding mislukt"
      },
      "fileBrowser": {
        "heading": "Bestanden op server",
        "hint": "Klik een bestand om het als sample voor dit slot te gebruiken. De bestandsnaam wordt ook het match-patroon voor geplande runs (telkens wordt het nieuwste matchende bestand gekozen).",
        "empty": "Geen CSV / TXT / TSV-bestanden in de geconfigureerde externe map."
      },
      "connection": {
        "heading": "Verbindingsgegevens",
        "hint": "Vanwaar de import-job bestanden moet ophalen. Kies het protocol dat je HR-systeem ondersteunt — de rest van het formulier past zich daarop aan.",
        "protocol": "Protocol",
        "protocols": {
          "sftp": "SFTP (SSH)",
          "ftp": "FTP (zonder TLS)",
          "ftps_explicit": "FTPS — expliciete TLS (poort 21)",
          "ftps_implicit": "FTPS — impliciete TLS (poort 990)"
        },
        "host": "Hostnaam",
        "port": "Poort",
        "portHint": "Laat leeg voor de standaardpoort van het protocol (22 voor SFTP, 21 voor FTP/FTPS-expliciet, 990 voor FTPS-impliciet).",
        "remotePath": "Externe map",
        "remotePathHint": "Waar de import naar bestanden zoekt. Standaard de home-map van de server.",
        "username": "Gebruikersnaam",
        "password": "Wachtwoord",
        "passwordSftpHint": "Optioneel bij SFTP — laat leeg als je in plaats daarvan een SSH-key gebruikt.",
        "passwordFtpHint": "Verplicht voor FTP / FTPS.",
        "passwordSavedPlaceholder": "(opgeslagen — leeg laten om te behouden)",
        "privateKey": "SSH-private-key",
        "privateKeyHint": "Kies het .pem / .key-bestand. We lezen alleen de tekst-inhoud; het bestand zelf gaat niet naar de server. Versleuteld opgeslagen.",
        "privateKeyLoaded": "Key geladen — wordt opgeslagen bij volgende stap.",
        "privateKeyAlreadySaved": "(opgeslagen — kies nieuw bestand om te vervangen)",
        "passphrase": "Key-wachtwoord",
        "passphraseHint": "Vul dit alleen in als het key-bestand zelf met een wachtwoord beveiligd is.",
        "passphraseSavedPlaceholder": "(opgeslagen — leeg laten om te behouden)",
        "hostFingerprint": "Host-fingerprint (optioneel)",
        "hostFingerprintHint": "SHA-256 fingerprint van de public host-key van de server. Bij ingevuld weigeren we te verbinden bij een mismatch — bescherming tegen MITM bij langlopende schedules.",
        "testButton": "Verbinding testen",
        "testNeedsSave": "Sla de verbinding eerst op, en test daarna.",
        "testSuccess": "Verbonden — {n} bestand(en) gevonden in de externe map.",
        "testFailure": "Verbinding mislukt"
      },
      "step2": {
        "heading": "Stap 2 — mapping",
        "hint": "Per bestand: upload een CSV om vijf voorbeeldrijen te zien, en koppel elke kolom aan een platformveld. Eén rij kan een gebruiker plus units op meerdere org-niveaus tegelijk vullen — kies per kolom het juiste doel.",
        "hintVendor": "Per endpoint: haal een sample op bij de vendor om vijf voorbeeld-records te zien, en koppel elk veld aan een platformveld. Eén rij kan een gebruiker plus units op meerdere org-niveaus tegelijk vullen — kies per kolom het juiste doel.",
        "addFile": "Bestand toevoegen",
        "addEndpoint": "Endpoint toevoegen",
        "empty": "Nog geen bestanden geconfigureerd. Klik op \"Bestand toevoegen\" om te beginnen.",
        "slotLabel": "Bestand {n}",
        "slotName": "Slot-naam",
        "matchFilename": "Bestandsnaam-match (optioneel)",
        "hasHeaderRow": "Eerste regel bevat kolomnamen",
        "uploadSample": "Sample-CSV uploaden",
        "replaceSample": "Sample vervangen",
        "pickServerFile": "Bestand kiezen van server",
        "replaceServerFile": "Server-bestand vervangen",
        "serverFileSampleNeeded": "geen preview — kies het bestand opnieuw om te verversen",
        "fetchVendorSample": "Sample ophalen bij vendor",
        "refreshVendorSample": "Vendor-sample verversen",
        "slotNameNeededForSample": "Kies eerst een slot zodat we weten welk vendor-endpoint we moeten samplen.",
        "pickVendorSlot": "— kies een endpoint —",
        "slotLabelInput": "Label (optioneel)",
        "slotLabelInputHint": "Vriendelijke naam die in run-rapporten en dashboards verschijnt. Leeg laten = endpoint-key wordt getoond.",
        "slotLabelPlaceholder": "Medewerkers — Hoofdkantoor",
        "rowCount": "({n} rijen)",
        "sampleHeading": "Sample-preview (5 rijen verspreid over het bestand)",
        "mapHeading": "Kolommapping",
        "mapHint": "Kies welk platformveld elke CSV-kolom vult. Laat \"Overslaan\" staan als de kolom niet meegenomen hoeft te worden. Verschillende kolommen mogen naar verschillende entiteiten wijzen (bv. user-velden + afdeling-velden + functie-velden in dezelfde rij).",
        "mapWithoutSampleHint": "Upload de CSV opnieuw om de voorbeeldrijen te zien. De onderstaande mapping is eerder opgeslagen en blijft van toepassing.",
        "skipColumn": "Deze kolom overslaan",
        "groupUser": "Gebruiker",
        "groupOrgUnit": "Org-unit: {level}",
        "fields": {
          "external_id": "Externe ID",
          "name": "Volledige naam",
          "first_name": "Voornaam",
          "last_name": "Achternaam",
          "email": "E-mail",
          "locale": "Taal",
          "status": "Status",
          "parent_external_id": "Bovenliggend (externe ID)",
          "parent_external_id_named": "Bovenliggend {parent} (externe ID)",
          "parent_same_level_external_id": "Bovenliggend {level} op hetzelfde niveau (externe ID)",
          "user_unit_link": "Koppeling aan {level} (via externe ID)"
        },
        "transformLabel": "Normaliseer",
        "transforms": {
          "none": "Geen (ruwe waarde)",
          "trim": "Spaties bijsnijden",
          "digits_only": "Alleen cijfers (310.031.100.010 → 310031100010)",
          "strip_dots": "Punten verwijderen (1.234 → 1234)",
          "lowercase": "Kleine letters",
          "uppercase": "Hoofdletters"
        },
        "prefixLabel": "Prefix",
        "prefixPlaceholder": "vaste tekst of een template",
        "idHint": "Identificerende kolommen kunnen vóór het matchen worden genormaliseerd + voorzien van een prefix. Een prefix-template kan andere cellen uit dezelfde rij ophalen door de kolomnaam tussen accolades te zetten. Stel beide kanten van een cross-bestand-koppeling met dezelfde prefix + transform in — anders behandelt de engine ze als verschillende ID's."
      },
      "exclusions": {
        "heading": "Uitsluitingen",
        "hint": "Gebruikers + units die overgeslagen moeten worden, ook als ze in de bronbestanden staan. ID's worden vergeleken met de DEFINITIEVE waarde na prefix + transform (dezelfde ID die op het platform getoond wordt). Eén invoer per regel.",
        "unitsLabel": "Uit te sluiten units — {level}",
        "unitsHint": "Externe ID's van units op dit niveau die overgeslagen moeten worden. Gebruikers zonder overgebleven koppeling op dit niveau worden ook uitgesloten.",
        "unitsPlaceholder": "4587\n9999",
        "userIdsLabel": "Uit te sluiten gebruikers — op externe ID",
        "userIdsHint": "Exacte vergelijking met de externe ID inclusief prefix.",
        "userIdsPlaceholder": "afas:12345",
        "emailsLabel": "Uit te sluiten gebruikers — op e-mailadres",
        "emailsHint": "Exacte vergelijking, hoofdletter-ongevoelig. Gebruik een * vooraan voor een domeinregel, bv. *@oudbedrijf.nl",
        "emailsPlaceholder": "foo@old.nl\n*@oudbedrijf.nl"
      },
      "step3": {
        "heading": "Stap 3 — planning",
        "hint": "Wanneer deze bron automatisch moet starten. Fase-1-bronnen draaien alleen als de planning actief is EN er minstens één tijdstip is ingesteld.",
        "uploadHint": "Een bron op basis van bestandsupload draait alleen wanneer het implementatieteam de bestanden zelf upload en de run start — er is geen automatische planning. Dry-run + commit gaan via de \"Uitvoeren\"-pagina van de bron.",
        "activate": "Bron is actief",
        "timesHeading": "Dagelijkse uitvoertijden",
        "timesHint": "Voeg zoveel tijdstippen toe als nodig — de bron draait dagelijks op elk tijdstip.",
        "noTimes": "Nog geen tijdstippen. Klik hieronder om er een toe te voegen.",
        "addTime": "Tijdstip toevoegen"
      }
    },
    "editor": {
      "newTitle": "Nieuwe mapping",
      "editTitle": "Mapping wijzigen",
      "intro": "Een mapping bestaat uit slots. Elk slot wijst naar één CSV-bestandsvorm (bv. \"users.csv\") en beschrijft welke kolom op welk platformveld terechtkomt.",
      "name": "Naam",
      "description": "Omschrijving",
      "slotsHeading": "Slots",
      "slotsIntro": "Voeg een slot toe per CSV-bestandsvorm. Drop een sample-CSV om de kolomnamen automatisch te detecteren — controleer de matches en pas aan.",
      "addUserSlot": "Gebruikers-slot",
      "addOrgUnitSlot": "Org-unit-slot",
      "noSlots": "Nog geen slots. Voeg een gebruikers- of org-unit-slot toe om te beginnen.",
      "slotLabel": "Slot {n}",
      "slotName": "Slot-naam",
      "targetUser": "gebruikers",
      "targetOrgUnit": "org-units",
      "targetLevelKey": "Org-niveau",
      "targetLevelKeyHint": "Aan welke categorie van de organisatiestructuur deze rijen toebehoren.",
      "pickLevel": "— kies een categorie —",
      "matchFilename": "Bestandsnaam-match (optioneel)",
      "matchFilenameHint": "Wordt bij upload gebruikt om automatisch dit slot te kiezen als de gebruiker een bestand met deze naam dropt.",
      "sampleDrop": "Drop hier een sample-CSV, of klik om te bladeren.",
      "sampleReplace": "Sample-CSV vervangen",
      "sampleLoaded": "{n} kolommen + {rows} sample-rij(en). Sample wordt niet bewaard — alleen gebruikt voor mapping-suggesties.",
      "sampleParseError": "Bestand kon niet als CSV gelezen worden. Probeer het op te slaan als UTF-8 met komma- of puntkomma-scheiding.",
      "columnsHeading": "Kolommen",
      "columnsHint": "Kies welke CSV-kolom elk platformveld vult. Verplichte velden zijn aangeduid met *.",
      "pickColumn": "kies kolom",
      "columnHeaderPlaceholder": "Type de CSV-kolomnaam",
      "field": {
        "external_id": "Externe ID",
        "email": "E-mail",
        "name": "Naam",
        "locale": "Taal",
        "status": "Status",
        "parent_external_id": "Bovenliggend (externe ID)"
      },
      "unitAssignmentsHeading": "Unit-toewijzingen",
      "unitAssignmentsHint": "Per categorie: welke CSV-kolom geeft aan tot welke unit deze gebruiker behoort.",
      "addUnitAssignment": "Toewijzing toevoegen",
      "via": {
        "external_id": "via externe ID",
        "email": "via e-mail",
        "name": "via naam"
      },
      "previewHeading": "Sample-preview ({n} rij(en))",
      "strategyHeading": "Strategie",
      "strategyHint": "Kies \"verrijken\" als dit CSV-bestand extra velden bevat voor gebruikers of units die door een ander slot worden aangemaakt — bv. assignments.csv met team en functie voor gebruikers uit users.csv.",
      "strategy": {
        "createOrUpdate": "Aanmaken of bijwerken — matcht op de identifying key, maakt aan als niets gevonden wordt.",
        "enrich": "Alleen bestaande verrijken — matcht via de join-kolom hieronder; rijen zonder match worden fouten in de dry-run."
      },
      "joinOnHint": "Welke CSV-kolom bevat de lookup-key, en met welk platformveld moet die gematcht worden.",
      "joinOnFrom": "Join-kolom (dit bestand)",
      "joinOnVia": "Match op"
    }
  },
  "locations": {
    "heading": "Trainingslocaties",
    "intro": "Beheer de trainingslocaties waaruit bij het plannen van een uitvoering per dag gekozen kan worden.",
    "new": "Nieuwe trainingslocatie",
    "empty": "Er zijn nog geen trainingslocaties. Voeg er een toe om ze bij het plannen te kunnen kiezen.",
    "editTitle": "Trainingslocatie bewerken",
    "active": "Actief",
    "inactive": "Inactief",
    "confirmDelete": "Trainingslocatie verwijderen?",
    "confirmDeleteBody": "Weet je zeker dat je “{name}” wilt verwijderen? Uitvoeringen die deze trainingslocatie gebruikten, houden hun vrije-tekst-locatie.",
    "cols": {
      "name": "Naam",
      "city": "Plaats",
      "capacity": "Capaciteit",
      "position": "Volgorde",
      "active": "Actief",
      "kind": "Soort"
    },
    "fields": {
      "name": "Naam",
      "city": "Plaats",
      "address": "Adres",
      "capacity": "Capaciteit",
      "capacityHint": "Fysieke zaal-capaciteit (informatief). Leeg = onbekend.",
      "position": "Volgorde",
      "positionHint": "Lager = hoger in de lijst.",
      "active": "Actief (kiesbaar bij plannen)",
      "isExternal": "Externe trainingslocatie (door een andere partij geleverd)"
    },
    "internal": "Intern",
    "external": "Extern"
  },
  "externalPeople": {
    "heading": "Externe personen",
    "intro": "Beheer de externe personen (zonder account) waaruit bij het plannen een trainer gekozen kan worden.",
    "new": "Nieuwe externe persoon",
    "empty": "Er zijn nog geen externe personen. Voeg er een toe om ze bij het plannen als trainer te kunnen kiezen.",
    "editTitle": "Externe persoon bewerken",
    "active": "Actief",
    "inactive": "Inactief",
    "confirmDelete": "Externe persoon verwijderen?",
    "confirmDeleteBody": "Weet je zeker dat je “{name}” wilt verwijderen? Je kunt deze persoon daarna niet meer als trainer kiezen. Uitvoeringen waar hij al trainer van is, houden hem als trainer.",
    "cols": {
      "name": "Naam",
      "email": "E-mail",
      "position": "Volgorde",
      "active": "Actief",
      "company": "Bedrijf",
      "deletedAt": "Verwijderd op"
    },
    "tabs": {
      "current": "Huidig",
      "deleted": "Verwijderd"
    },
    "deleted": {
      "intro": "Verwijderde externe personen staan niet meer in de lijst en de trainerkeuze, maar hun naam, e-mail en opmerking zijn er nog. Komt er een wisverzoek binnen, dan wis je ze hier.",
      "empty": "Er zijn geen verwijderde externe personen die nog gewist kunnen worden."
    },
    "fields": {
      "name": "Naam",
      "email": "E-mail",
      "note": "Opmerking",
      "position": "Volgorde",
      "positionHint": "Lager = hoger in de lijst.",
      "active": "Actief (kiesbaar als trainer)",
      "company": "Extern bedrijf / opleider",
      "companyHint": "Optioneel. Leeg = losse freelancer."
    },
    "noCompany": "Geen bedrijf (freelancer)",
    "erase": {
      "action": "Wissen",
      "actionLabel": "Wissen: {name}",
      "title": "Externe persoon wissen?",
      "irreversible": "Wissen is onomkeerbaar. Je kunt dit niet terugdraaien.",
      "body": "De naam, het e-mailadres en de opmerking van “{name}” worden definitief verwijderd, net als deze gegevens in het logboek. De persoon verdwijnt uit deze lijst en kan niet meer als trainer gekozen worden.",
      "history": "De trainergeschiedenis blijft bewaard: uitvoeringen waarvan deze persoon trainer was, houden hun trainer en tonen die voortaan als “Verwijderde externe persoon”.",
      "confirmLabel": "Typ “{name}” om te bevestigen",
      "confirmHint": "Typ de naam precies zoals hij hierboven staat.",
      "submit": "Definitief wissen",
      "done": "“{name}” is gewist. Uitvoeringen waarvan deze persoon trainer was, tonen nu “Verwijderde externe persoon”."
    }
  },
  "cancellationReasons": {
    "heading": "Annuleer-redenen",
    "intro": "Beheer de redenen waaruit een lerende kan kiezen bij het annuleren van een inschrijving.",
    "new": "Nieuwe reden",
    "empty": "Er zijn nog geen annuleer-redenen. Voeg er een toe om ze in de annuleer-keuzelijst te tonen.",
    "editTitle": "Reden bewerken",
    "active": "Actief",
    "inactive": "Inactief",
    "confirmDelete": "Reden verwijderen?",
    "confirmDeleteBody": "Weet je zeker dat je “{label}” wilt verwijderen? Reeds geannuleerde inschrijvingen behouden hun reden.",
    "cols": {
      "label": "Reden",
      "position": "Volgorde",
      "active": "Actief"
    },
    "fields": {
      "label": "Reden",
      "position": "Volgorde",
      "positionHint": "Lager = hoger in de lijst.",
      "active": "Actief (tonen aan lerenden)"
    }
  },
  "externalCompanies": {
    "heading": "Externe bedrijven",
    "intro": "Beheer de externe bedrijven (opleiders, leveranciers). Markeer een bedrijf als opleider zodat je bij het plannen eerst de opleider en dan de docent kunt kiezen.",
    "new": "Nieuw extern bedrijf",
    "empty": "Er zijn nog geen externe bedrijven. Voeg er een toe om ze te kunnen gebruiken.",
    "editTitle": "Extern bedrijf bewerken",
    "active": "Actief",
    "inactive": "Inactief",
    "confirmDelete": "Extern bedrijf verwijderen?",
    "confirmDeleteBody": "Weet je zeker dat je \"{name}\" wilt verwijderen? Docenten die bij dit bedrijf hoorden, worden weer losse freelancers.",
    "cols": {
      "name": "Naam",
      "email": "E-mail",
      "educator": "Opleider",
      "position": "Volgorde",
      "active": "Actief",
      "origin": "Herkomst"
    },
    "fields": {
      "name": "Naam",
      "email": "E-mail",
      "phone": "Telefoon",
      "note": "Opmerking",
      "position": "Volgorde",
      "positionHint": "Lager = hoger in de lijst.",
      "isEducator": "Is opleider (verschijnt bij de trainer-keuze)",
      "active": "Actief (kiesbaar bij plannen)"
    },
    "promote": "Naar beheerde lijst",
    "origin": {
      "admin": "Beheerder",
      "request": "Aanvraag"
    },
    "suggestions": {
      "heading": "Zoekt u dit misschien?",
      "hint": "Staat het bedrijf hierboven al? Kies dan dat bedrijf in plaats van een tweede aan te maken."
    }
  },
  "roles": {
    "heading": "Rollen & rechten",
    "intro": "Een rol is een bundel rechten. Wát iemand mag komt uit de rol; wáár hij het mag kies je bij het toekennen. Rollen zijn van jouw organisatie: je mag ze aanpassen, dupliceren en zelf nieuwe maken.",
    "empty": "Er zijn nog geen rollen in deze omgeving.",
    "loading": "Rollen worden geladen…",
    "loadError": "De rollen konden niet worden geladen.",
    "new": "+ Nieuwe rol",
    "column": {
      "role": "Rol",
      "rank": "Rang",
      "origin": "Herkomst",
      "permissions": "Rechten",
      "assigned": "Toegekend aan",
      "actions": "Acties"
    },
    "permissionCount": "{held} van {total}",
    "origin": {
      "standard": "Standaard",
      "standard_customised": "Standaard · aangepast",
      "self_made": "Zelf gemaakt"
    },
    "action": {
      "view": "Bekijken",
      "edit": "Bewerken",
      "duplicate": "Dupliceren",
      "delete": "Verwijderen"
    },
    "rankHint": "Hoger getal = minder macht",
    "readOnlyBanner": "Deze rol heeft rang {rank}. Je kunt alleen rollen met een hoger getal dan je eigen rang ({own}) bewerken.",
    "readOnlyBannerNoRank": "Deze rol heeft rang {rank}. Je hebt zelf geen rol met een rang, dus je kunt geen rollen bewerken.",
    "rankRangeHint": "Van {min} tot {max}. Hoger getal = minder macht",
    "rankFixedHint": "De rang van deze rol ligt vast",
    "rankOutOfRange": "Kies een rang van {min} tot {max}.",
    "newAtoms": {
      "title_one": "Er is een nieuw recht bijgekomen",
      "title_other": "Er zijn {count} nieuwe rechten bijgekomen",
      "body": "Ze staan nog op geen enkele rol. Nieuwe rechten worden nooit automatisch aangezet.",
      "show": "Bekijk wat er nieuw is"
    },
    "delete": {
      "title": "Rol verwijderen?",
      "body": "De rol {label} wordt verwijderd. Toewijzingen aan deze rol verdwijnen mee.",
      "confirm": "Verwijderen",
      "inUse": "Deze rol is in gebruik door een goedkeuringsflow en kan niet verwijderd worden: {flows}"
    },
    "builder": {
      "newHeading": "Nieuwe rol",
      "name": "Naam van de rol",
      "nameHint": "Wat gebruikers zien. Per taal aan te passen; de interne sleutel verandert niet mee.",
      "otherLanguages": "Andere talen",
      "rank": "Rang",
      "search": "Zoek in rechten…",
      "onlyEnabled": "Alleen wat aan staat",
      "expandAll": "Alles uitklappen",
      "collapseAll": "Alles inklappen",
      "moduleCount": "{held} van {total}",
      "summary": "Wat je verandert",
      "summaryOn": "Rechten aan",
      "summaryRequired": "Meegekomen als vereiste",
      "summaryUnavailable": "Niet beschikbaar voor jou",
      "summaryPeople": "Mensen met deze rol",
      "lockedBy": "Komt mee met: {atoms}",
      "notYours": "Je houdt dit recht zelf niet, dus je kunt het niet uitdelen.",
      "dangerous": "Gevaarlijk",
      "indispensable": "Onmisbaar",
      "impact_one": "Deze wijziging raakt {count} persoon.",
      "impact_other": "Deze wijziging raakt {count} mensen.",
      "save": "Opslaan",
      "cancel": "Annuleren",
      "saving": "Opslaan…",
      "saved": "De rol is opgeslagen.",
      "templateDiff_one": "Er is {count} recht uit de standaard dat deze rol nog niet heeft.",
      "templateDiff_other": "Er zijn {count} rechten uit de standaard die deze rol nog niet heeft.",
      "addFromTemplate": "Toevoegen",
      "viewPeople_one": "Bekijk de persoon met deze rol",
      "viewPeople_other": "Bekijk de {count} mensen met deze rol"
    },
    "confirm": {
      "title": "Weet je het zeker?",
      "added": "Rechten erbij",
      "removed": "Rechten eraf",
      "dangerousAdded_one": "Hiervan is er {count} gevaarlijk",
      "dangerousAdded_other": "Hiervan zijn er {count} gevaarlijk",
      "impact_one": "Dit raakt {count} persoon met deze rol.",
      "impact_other": "Dit raakt {count} mensen met deze rol.",
      "nothing": "Er verandert niets aan de rechten.",
      "confirm": "Opslaan",
      "back": "Terug"
    },
    "count_one": "{count} rol",
    "count_other": "{count} rollen"
  },
  "roleAssignment": {
    "heading": "Rol toekennen aan {name}",
    "userLoadError": "Deze gebruiker kon niet worden geladen.",
    "intro": "Wát iemand mag komt uit de rol. Wáár het geldt kies je hier.",
    "backToProfile": "← Terug naar het profiel",
    "revoke": "Intrekken",
    "includeSubtree": "Ook de onderliggende eenheden",
    "subtreeHint": "Zonder dit vinkje geldt de rol alleen in de gekozen eenheid zelf.",
    "pickRole": "Kies een rol",
    "pickOrgUnit": "Zoek een eenheid",
    "current": {
      "heading": "Huidige rollen",
      "empty": "Deze gebruiker heeft nog geen rol.",
      "loadError": "De rollen van deze gebruiker konden niet worden geladen."
    },
    "add": {
      "heading": "Rol toekennen",
      "submit": "Toekennen"
    },
    "fields": {
      "role": "Rol",
      "scope": "Waar geldt deze rol?",
      "orgUnit": "Organisatie-eenheid"
    },
    "blocked": {
      "rank": "je mag deze rol niet uitdelen",
      "delta": "je houdt zelf niet: {atoms}"
    },
    "scopeOption": {
      "tenant_wide": "De hele omgeving",
      "org_unit": "Eén organisatie-eenheid",
      "ownership": "Alleen wat aan deze persoon gekoppeld is",
      "direct_reports": "Alleen de directe medewerkers van deze persoon"
    },
    "scopeHint": {
      "tenant_wide": "De rol geldt overal in deze omgeving.",
      "org_unit": "De rol geldt binnen de gekozen eenheid.",
      "ownership": "De rol geldt voor de dingen waar deze persoon aan gekoppeld is — bijvoorbeeld cursussen waarvan zij inhoudelijk eigenaar is, of uitvoeringen die zij als trainer verzorgt.",
      "direct_reports": "De rol geldt alleen voor de mensen van wie deze persoon de leidinggevende is. Heeft niemand deze persoon als leidinggevende ingesteld, dan ziet zij niemand. Uitvoeringen en de catalogus vallen niet onder dit bereik: een leidinggevende werkt in Mijn team in de app."
    },
    "scope": {
      "tenant_wide": "De hele omgeving",
      "ownership": "Alleen wat aan deze persoon gekoppeld is",
      "direct_reports": "Alleen de directe medewerkers van deze persoon",
      "orgUnitWithSubtree": "{unit} en alles daaronder",
      "orgUnitOnly": "Alleen {unit}"
    },
    "preview": {
      "heading": "Wat dit oplevert",
      "pickRoleFirst": "Kies eerst een rol — zonder rol valt er niets te berekenen.",
      "calculating": "Bezig met berekenen…",
      "failed": "De berekening lukte niet. Je kunt gewoon opslaan; je mist alleen het vooruitzicht.",
      "tenantWide": "Deze rol geldt overal in deze omgeving.",
      "ownership": "Vandaag is dat: cursussen waarvoor deze persoon verantwoordelijk is · uitvoeringen waarop deze persoon trainer is · de eigen inschrijvingen · het eigen profiel.",
      "directReports": "Vandaag is dat: de gebruikers, inschrijvingen, deelnames en kwalificaties van de mensen die deze persoon rechtstreeks aanstuurt. Niet hun leidinggevenden en niet de uitvoeringen of de catalogus.",
      "units_one": "{count} organisatie-eenheid",
      "units_other": "{count} organisatie-eenheden",
      "people_one": "{count} persoon valt hieronder",
      "people_other": "{count} mensen vallen hieronder",
      "widerThanChosen": "Let op: je koos één eenheid, maar door de onderliggende eenheden dekt dit er meer."
    }
  },
  "effectiveAccess": {
    "heading": "Wat deze persoon mag",
    "heldCount_one": "{count} van {total} recht",
    "heldCount_other": "{count} van {total} rechten",
    "search": "Zoeken in rechten",
    "searchPlaceholder": "Bijvoorbeeld: inschrijving",
    "showUnheld": "Toon ook wat deze persoon niet mag",
    "noMatch": "Geen rechten die hierop passen.",
    "moduleCount": "{count} van {total}",
    "dangerous": "Gevaarlijk",
    "notHeld": "Heeft deze persoon niet.",
    "via": "via {role} — {scope} — {surface}",
    "impliedBy": "(kwam mee met {atom})",
    "surface": {
      "app": "telt in de app",
      "manage": "telt in het beheer"
    }
  },
  "attendance": {
    "title": "Presentie",
    "myTeaching": "Mijn bijeenkomsten",
    "myTeachingEmpty": "Je staat nog niet als docent aan een bijeenkomst gekoppeld.",
    "openBadge": "Presentie open",
    "participant": "Deelnemer",
    "day": "Dag",
    "save": "Presentie opslaan",
    "saved": "Presentie opgeslagen.",
    "noParticipants": "Nog geen deelnemers met een plek op deze uitvoering.",
    "noDays": "Deze uitvoering heeft nog geen dagen ingepland.",
    "status": {
      "not_recorded": "Nog niet vastgelegd",
      "present": "Aanwezig",
      "absent": "Afwezig",
      "excused": "Afwezig met reden",
      "substituted": "Vervangen"
    },
    "completion": {
      "label": "Afgerond",
      "true": "Ja",
      "false": "Nee",
      "null": "Nog niet te zeggen",
      "explainNull": "Er is nog minstens één dag niet vastgelegd, dus hierover is nog geen uitspraak te doen."
    },
    "loadError": "De presentie kon niet geladen worden.",
    "saveError": "De presentie kon niet opgeslagen worden.",
    "closeOut": {
      "action": "Uitvoering afsluiten",
      "achievedOn": "Behaald op",
      "achievedOnHint": "Standaard vandaag. Niet in de toekomst, en niet vóór een eerdere afronding van dezelfde deelnemer op deze activiteit.",
      "achievedOnInFuture": "De datum van behalen kan niet in de toekomst liggen.",
      "outcome": "Uitkomst",
      "outcomeFor": "Uitkomst voor {name}",
      "skip": "Overslaan",
      "passed": "Behaald",
      "failed": "Niet behaald",
      "reason": "Reden van de afwijking",
      "reasonHint": "Deze uitkomst wijkt af van wat de presentie zegt. De reden wordt ernaast vastgelegd.",
      "reasonRequired": "Er staat nog een afwijking zonder reden. Vul die in voor je afsluit.",
      "needsForce": "Er staat nog een dag open, dus er valt niets af te leiden. Alleen wie het recht heeft om te forceren kan hier een uitkomst zetten.",
      "notOpen": "Niet af te ronden",
      "notOpenExplain": "Deze inschrijving is niet meer lopend. Hij staat nog in het overzicht omdat er presentie van hem is vastgelegd.",
      "alreadyDone": "Al afgerond",
      "alreadyDoneOn": "Afgerond op {date}",
      "wasDeviation": "Afgeweken van de presentie",
      "confirmTitle": "Uitvoering afsluiten?",
      "confirmBody": "{finalized} deelnemers krijgen nu een uitkomst; {skipped} worden overgeslagen en kunnen later alsnog afgerond worden.",
      "confirmTerminal": "De uitvoering komt daarna op afgesloten te staan. Dat is niet terug te draaien.",
      "done": "Afgesloten. {finalized} deelnemers afgerond, {skipped} overgeslagen.",
      "error": "De uitvoering kon niet afgesloten worden.",
      "withdraw": "Intrekken",
      "withdrawTitle": "Uitspraak intrekken voor {name}",
      "withdrawExplain": "De uitspraak blijft bewaard met wie hem deed en waarom hij is ingetrokken — hij telt alleen nergens meer mee. Het vakje staat daarna weer open, zodat je opnieuw kunt afronden.",
      "withdrawReason": "Waarom trek je dit in?",
      "withdrawReasonHint": "Dit is later de enige uitleg die er nog staat.",
      "withdrawError": "Intrekken is niet gelukt. Probeer het opnieuw, of ververs de pagina.",
      "withdrawKind": "Wat geldt er vanaf nu?",
      "withdrawKindPlaceholder": "Maak een keuze",
      "withdrawKindFromNow": "Hij had hem — vanaf nu niet meer",
      "withdrawKindNeverValid": "De uitspraak was onjuist — hij heeft hem nooit gehad",
      "withdrawKindHint": "Dit bepaalt hoe een rapport over een periode in het verleden eruitziet. De eerste laat die geschiedenis staan; de tweede zegt dat een eerder rapport onjuist was."
    },
    "cellLabel": "{name} op {day} — {status}",
    "notes": {
      "column": "Notities",
      "title": "Aantekeningen over {name}",
      "open": "Aantekeningen over {name} ({count})",
      "empty": "Er staat nog niets over deze deelnemer.",
      "new": "Nieuwe aantekening",
      "newHint": "Alleen jij ziet dit, tenzij je hem hieronder deelt.",
      "add": "Opschrijven",
      "share": "Zichtbaar voor de manager van deze deelnemer",
      "sharedMarker": "gedeeld met de manager",
      "by": "{author} — {date}",
      "unknownAuthor": "Onbekend",
      "error": "De aantekening kon niet opgeslagen worden.",
      "delete": "Weghalen",
      "edit": "Aantekening bijstellen",
      "editAction": "Bijstellen",
      "editedMarker": "bijgesteld"
    },
    "showCancelled": "Ook {count} geannuleerde deelnemer(s) tonen",
    "markAllPresent": "Allen aanwezig",
    "markAllRow": "Hele dag",
    "external": {
      "column": "Externe toets",
      "choose": "Uitslag van de externe toets voor {participant}",
      "placeholder": "Uitslag",
      "record": "Vastleggen",
      "error": "De uitslag kon niet worden vastgelegd.",
      "outcome": {
        "passed": "Behaald",
        "not_passed": "Niet behaald"
      },
      "resultLabel": "Uitslag van de externe partij voor {participant} (percentage of cijfer)",
      "resultPlaceholder": "Bijv. 72% of 7,5"
    }
  },
  "accessGroups": {
    "heading": "Toegangsgroepen",
    "lead": "Eén omschrijving van wie, op meerdere plekken bruikbaar. Een groep beschrijft mensen met regels — niet met een lijst namen — dus hij klopt nog als iemand van afdeling wisselt.",
    "new": "Nieuwe toegangsgroep",
    "empty": "Er zijn nog geen toegangsgroepen. Maak er een zodra je een leeractiviteit voor een bepaalde groep wilt bedoelen.",
    "loadError": "We konden de toegangsgroepen niet laden.",
    "backToList": "Terug naar het overzicht",
    "memberCount": "{count} personen",
    "showOnChart": "Toon op het organogram waar deze mensen zitten",
    "usedByCount": "gebruikt door {count} leeractiviteiten",
    "usage": {
      "title": "Gebruikt door {count} training(en)",
      "nowhere": "Deze groep wordt nergens gebruikt.",
      "hidden": "En {count} training(en) die je niet mag zien.",
      "unavailable": "We konden niet ophalen waar deze groep gebruikt wordt."
    },
    "impact": {
      "title": "Wat verandert er?",
      "lead": "Deze groep bepaalt de zichtbaarheid van {count} training(en). Je wijziging geldt daar meteen.",
      "gaining": "{count} perso(o)n(en) krijgen toegang die ze nu niet hebben.",
      "losing": "{count} perso(o)n(en) verliezen toegang die ze nu wel hebben.",
      "nobodyChanges": "Voor niemand verandert er iets — de groep omvat dezelfde mensen.",
      "totals": "Nu {current} lid/leden, straks {proposed}.",
      "confirm": "Toch opslaan",
      "unavailable": "We konden niet berekenen wat deze wijziging betekent. Probeer het opnieuw."
    },
    "columns": {
      "name": "Naam",
      "members": "Omvang",
      "usedBy": "Gebruikt door"
    },
    "fields": {
      "name": "Naam",
      "description": "Omschrijving"
    },
    "branch": {
      "include": "Wie hoort erbij",
      "includeHint": "Voldoet iemand aan één van deze groepen, dan hoort hij erbij.",
      "exclude": "Wie valt af",
      "excludeHint": "Uitsluiten wint: wie hieraan voldoet valt af, ook als hij hierboven wél past."
    },
    "addGroup": "Groep toevoegen",
    "removeGroup": "Groep verwijderen",
    "noGroups": "Nog geen groepen.",
    "allOf": "Voldoet aan alles hieronder",
    "and": "en",
    "or": "of",
    "emptyGroupMatchesNobody": "Deze groep heeft nog geen conditie en omvat daarom niemand.",
    "addCondition": "Conditie toevoegen",
    "removeCondition": "Verwijderen",
    "chooseKind": "Kies een soort…",
    "choose": "Kies…",
    "searchPerson": "Zoek een persoon…",
    "includeSubtree": "Ook de eenheden hieronder",
    "unitWithSubtree": "{name} (en alles daaronder)",
    "unitOnly": "alleen {name}",
    "unknownReference": "onbekend",
    "atom": {
      "org_unit": "Organisatie-eenheid",
      "user": "Persoon",
      "role": "Rol"
    },
    "plain": {
      "label": "In gewone taal:",
      "nobody": "Niemand — er is nog geen enkele conditie om bij te horen.",
      "except": "behalve"
    },
    "broken": {
      "badge": "Kapot",
      "notice": "Deze groep verwijst naar iets dat niet meer bestaat ({count} verwijzing(en)). Zolang dat zo is omvat de groep niemand — ook niet via een uitsluit-regel. Verwijder de verwijzing of kies iets anders."
    },
    "references": {
      "title": "Dit komt voor in toegangsgroepen",
      "lead": "Verwijder je dit, dan worden deze groepen kapot: ze omvatten dan niemand tot je ze repareert.",
      "excluding": "(sluit uit)"
    }
  },
  "ltiProviders": {
    "heading": "LTI-koppelingen",
    "intro": "Leveranciers die je via LTI 1.1 of 1.3 aan je catalogus kunt hangen. Je registreert er hier één keer een; daarna kies je hem bij een leeractiviteit.",
    "new": "Leverancier toevoegen",
    "editTitle": "Leverancier bewerken",
    "empty": "Er is nog geen leverancier geregistreerd.",
    "active": "Actief",
    "inactive": "Niet actief",
    "secretSet": "Ingesteld",
    "secretUnset": "Niet ingesteld",
    "confirmDelete": "Leverancier verwijderen",
    "confirmDeleteBody": "Weet je zeker dat je {name} wilt verwijderen?",
    "confirmDeleteUnknown": "Trainingen die deze leverancier gebruiken worden gearchiveerd — ze verdwijnen uit de catalogus, maar behaalde resultaten blijven bewaard.",
    "confirmDeleteNone": "Geen enkele training gebruikt deze leverancier.",
    "confirmDeleteAffected_one": "Eén training wordt gearchiveerd — hij verdwijnt uit de catalogus, maar behaalde resultaten blijven bewaard.",
    "confirmDeleteAffected_other": "{count} trainingen worden gearchiveerd — ze verdwijnen uit de catalogus, maar behaalde resultaten blijven bewaard.",
    "confirmDeleteRest_one": "en nog één andere",
    "confirmDeleteRest_other": "en nog {count} andere",
    "cols": {
      "name": "Naam",
      "issuer": "Uitgever",
      "clientId": "Client-ID",
      "secret": "Geheim",
      "active": "Actief"
    },
    "fields": {
      "name": "Naam",
      "issuer": "Uitgever (issuer)",
      "issuerHint": "Het adres dat de leverancier als issuer opgeeft, bijvoorbeeld https://lti.voorbeeld.nl",
      "clientId": "Client-ID",
      "deploymentId": "Deployment-ID",
      "authLoginUrl": "Inlog-adres (OIDC)",
      "redirectUris": "Redirect-adressen",
      "redirectUrisHint": "Eén adres per regel. Hier stuurt het systeem de ondertekende launch naartoe; adressen die hier niet staan worden geweigerd.",
      "jwksUrl": "JWKS-adres",
      "jwksUrlHint": "Hier haalt het systeem de publieke sleutels van de leverancier op. Een adres binnen ons eigen netwerk wordt geweigerd.",
      "supportsDeepLinking": "Je kunt bij deze leverancier een cursus kiezen",
      "supportsDeepLinkingHint": "Staat dit aan, dan kun je bij een training op 'Cursus kiezen' klikken en de cursus bij de leverancier aanwijzen. Wij kunnen niet zelf zien of een leverancier dit ondersteunt — vraag het na als je het niet zeker weet. Staat het uit, dan vul je het adres van de cursus met de hand in.",
      "version": "LTI-versie",
      "version13": "LTI 1.3 (aanbevolen)",
      "version11": "LTI 1.1",
      "consumerKey": "Sleutel (consumer key)",
      "consumerKeyHint": "De sleutel die je van de leverancier hebt gekregen. Het bijbehorende wachtwoord vul je hieronder in.",
      "clientSecret": "Client secret",
      "clientSecretHint": "Wordt versleuteld opgeslagen en daarna nooit meer getoond.",
      "clientSecretKeepHint": "Laat leeg om het opgeslagen geheim te laten staan. Vul iets in om het te vervangen.",
      "active": "Actief"
    }
  },
  "digestSettings": {
    "heading": "Verzamelmail",
    "intro": "Meldingen die niet meteen een eigen bericht hoeven te zijn, worden gebundeld in één periodieke mail per ontvanger. Je stelt hier in wanneer die vertrekt; wélke meldingen meerijden, kies je per workflow.",
    "enabled": "Verzamelmail versturen",
    "enabledHint": "Staat dit uit, dan blijven gebundelde meldingen wachten en gaat er niets weg. Er wordt niets verwijderd — zet je hem weer aan, dan komt alles alsnog mee.",
    "willFallSilent_one": "Er is {count} melding die via de verzamelmail gaat. Die valt stil zolang dit uit staat.",
    "willFallSilent_other": "Er zijn {count} meldingen die via de verzamelmail gaan. Die vallen stil zolang dit uit staat.",
    "frequencyLabel": "Hoe vaak",
    "frequency": {
      "daily": "Elke dag",
      "weekly": "Elke week"
    },
    "weekdayLabel": "Op welke dag",
    "timeLabel": "Hoe laat",
    "timeHint": "In de tijdzone van je organisatie. De mail vertrekt in blokken van een kwartier, dus je kiest een tijd op :00, :15, :30 of :45.",
    "saved": "De instellingen zijn opgeslagen.",
    "saveFailed": "Opslaan is niet gelukt."
  },
  "combobox": {
    "noResults": "Geen resultaten.",
    "loading": "Bezig met laden…"
  },
  "aurora": {
    "modalClose": "Sluiten",
    "alertDismiss": "Melding sluiten",
    "passwordShow": "Wachtwoord tonen",
    "passwordHide": "Wachtwoord verbergen",
    "comboboxRemove": "{label} verwijderen"
  },
  "returnTrail": {
    "afterSave": {
      "form": "Na opslaan wordt dit onderaan formulier ‘{title}’ toegevoegd en ga je daarheen terug.",
      "form_test": "Na opslaan wordt dit onderaan toets ‘{title}’ toegevoegd en ga je daarheen terug.",
      "category": "Na opslaan wordt dit onderaan categorie ‘{title}’ toegevoegd en ga je daarheen terug."
    },
    "fromParent": {
      "form": "Je werkt hier vanuit formulier ‘{title}’.",
      "form_test": "Je werkt hier vanuit toets ‘{title}’.",
      "category": "Je werkt hier vanuit categorie ‘{title}’."
    },
    "back": {
      "form": "Terug naar het formulier",
      "form_test": "Terug naar de toets",
      "category": "Terug naar de categorie"
    },
    "cancel": {
      "form": "Annuleren, terug naar het formulier",
      "form_test": "Annuleren, terug naar de toets",
      "category": "Annuleren, terug naar de categorie"
    },
    "saveAndReturn": {
      "form": "Opslaan en terug naar het formulier",
      "form_test": "Opslaan en terug naar de toets",
      "category": "Opslaan en terug naar de categorie"
    },
    "discard": {
      "title": "Wijzigingen weggooien?",
      "body": "Wat je hier hebt ingevuld is nog niet opgeslagen en gaat verloren als je teruggaat.",
      "keep": "Blijven bewerken",
      "confirm": "Weggooien en terug"
    },
    "added": {
      "category": "De nieuwe categorie is aangemaakt en onderaan het formulier toegevoegd.",
      "category_test": "De nieuwe categorie is aangemaakt en onderaan de toets toegevoegd.",
      "question": "De nieuwe vraag is aangemaakt en onderaan de categorie toegevoegd."
    },
    "attachFailed": {
      "category": "De nieuwe categorie is opgeslagen, maar kon niet aan het formulier worden toegevoegd. Pas het aan en sla opnieuw op om het nog eens te proberen, of ga terug via de knop hierboven.",
      "category_test": "De nieuwe categorie is opgeslagen, maar kon niet aan de toets worden toegevoegd. Pas het aan en sla opnieuw op om het nog eens te proberen, of ga terug via de knop hierboven.",
      "question": "De nieuwe vraag is opgeslagen, maar kon niet aan de categorie worden toegevoegd. Pas het aan en sla opnieuw op om het nog eens te proberen, of ga terug via de knop hierboven."
    }
  },
  "answerReadout": {
    "notAnswered": "Niet beantwoord",
    "scale": "{value} van {max}",
    "scaleLabelled": "{value} van {max}: {label}",
    "other": "Anders: {text}"
  },
  "testGrading": {
    "retry": "Opnieuw proberen",
    "outcome": {
      "passed": "Geslaagd",
      "not_passed": "Niet geslaagd"
    },
    "queue": {
      "title": "Nakijken",
      "description": "Ingestuurde toetsen die op jou wachten, per uitvoering. Klap een uitvoering open om de toetsen te zien.",
      "loading": "Toetsen laden…",
      "loadError": "De toetsen die nagekeken moeten worden konden niet worden geladen.",
      "emptyTitle": "Er is niets na te kijken",
      "emptyBody": "Zodra een deelnemer een toets instuurt waarvoor jij nakijker bent, staat die hier.",
      "noTitle": "Training zonder naam",
      "noDate": "Geen datum",
      "count_one": "{count} toets",
      "count_other": "{count} toetsen",
      "column": {
        "training": "Training",
        "date": "Datum",
        "count": "Te beoordelen"
      },
      "responsesOf": "Toetsen van {title}",
      "unknownRespondent": "Onbekende deelnemer",
      "submittedAt": "Ingestuurd op {date}",
      "grade": "Nakijken",
      "gradeNamed": "Toets van {name} nakijken",
      "expand": "Toon de toetsen",
      "collapse": "Verberg de toetsen"
    },
    "grade": {
      "back": "Terug naar nakijken",
      "title": "Toets van {name}",
      "loading": "Toets laden…",
      "loadError": "De toets kon niet worden geladen.",
      "notFoundTitle": "Deze toets staat niet voor je klaar",
      "notFoundBody": "Hij bestaat niet, is nog niet ingestuurd, of je bent geen nakijker van deze toets.",
      "refused": "Deze toets kun je niet nakijken.",
      "answers": "Antwoorden",
      "answerComment": "Opmerking bij dit antwoord (optioneel)",
      "answerCommentHintVisible": "De deelnemer ziet deze opmerking bij zijn antwoord.",
      "answerCommentHintHidden": "Antwoorden inzien staat uit: deze opmerking blijft bij jou en het beheer.",
      "answerCommentGiven": "Opmerking van de nakijker",
      "respondentRemarks": "Opmerking van de deelnemer",
      "judgement": "Oordeel",
      "outcome": "Uitkomst",
      "score": "Score (optioneel)",
      "scoreHint": "Alleen ter informatie: de score bepaalt niets. De uitkomst kies je zelf.",
      "scoreInvalid": "Vul een getal van nul of hoger in.",
      "scoreGiven": "Score: {score} (alleen ter informatie)",
      "comment": "Opmerking bij de toets (optioneel)",
      "commentHint": "De deelnemer ziet deze opmerking altijd bij zijn uitslag.",
      "save": "Nakijken opslaan",
      "saving": "Opslaan…",
      "saved": "De toets van {name} is nagekeken.",
      "conflict": "Een andere nakijker was je net voor: deze toets is intussen nagekeken. Wat je invulde is niet opgeslagen. Hieronder staat het oordeel zoals het nu is.",
      "saveError": "Opslaan is niet gelukt. Controleer je verbinding en probeer het opnieuw.",
      "gradedBy": "Nagekeken door {name} op {date}",
      "answersVisibleToRespondent": "De deelnemer ziet deze uitslag, met zijn antwoorden en de opmerkingen per antwoord.",
      "answersHiddenFromRespondent": "De deelnemer ziet de uitkomst, de score en de algemene opmerking, maar niet zijn antwoorden en de opmerkingen per antwoord."
    }
  },
  "testResult": {
    "title": "Uitslag van {title}",
    "loading": "Uitslag laden…",
    "loadError": "De uitslag kon niet worden geladen.",
    "retry": "Opnieuw proberen",
    "closedTitle": "Deze uitslag is niet beschikbaar",
    "closedBody": "De toets is nog niet nagekeken.",
    "gradedOn": "Nagekeken op {date}",
    "outcome": "Uitkomst",
    "score": "Score: {score}",
    "scoreNote": "(alleen ter informatie)",
    "graderComment": "Opmerking van de nakijker",
    "answers": "Je antwoorden",
    "answerComment": "Opmerking van de nakijker",
    "answersHidden": "Bij deze toets worden je antwoorden en de opmerkingen per vraag niet getoond."
  },
  "questionnaireResults": {
    "anonymous": "Anoniem",
    "retry": "Opnieuw proberen",
    "backToList": "Terug naar resultaten",
    "notFoundTitle": "Niet gevonden",
    "notFoundBody": "Dit rapport bestaat niet of is niet voor jou te lezen.",
    "responses_one": "{count} reactie",
    "responses_other": "{count} reacties",
    "suppressed": "Te weinig reacties — {count} van minimaal {floor}",
    "suppressedWhy": "Onder die ondergrens tonen we geen uitkomst, ook geen gemiddelde. Zo kan niemand achteraf worden herkend.",
    "list": {
      "title": "Resultaten",
      "description": "De uitkomst van de evaluaties van je uitvoeringen. Een uitkomst verschijnt pas als er genoeg reacties zijn.",
      "loading": "Resultaten laden…",
      "loadError": "De uitvoeringen konden niet worden geladen.",
      "emptyTitle": "Nog geen uitvoeringen met evaluaties",
      "emptyBody": "Zodra een van je uitvoeringen een evaluatie heeft, staat die hier.",
      "noTitle": "Zonder naam",
      "noDate": "Geen datum",
      "noRules": "Geen evaluaties",
      "column": {
        "training": "Training",
        "date": "Datum",
        "rules": "Evaluaties"
      }
    },
    "occurrence": {
      "loading": "Rapport laden…",
      "loadError": "Het rapport kon niet worden geladen.",
      "emptyTitle": "Geen evaluaties op deze uitvoering",
      "emptyBody": "Er loopt voor deze uitvoering geen evaluatie, dus er valt niets te lezen."
    },
    "rule": {
      "loading": "Rapport laden…",
      "loadError": "Het rapport kon niet worden geladen.",
      "subject": "{kind} · {training}",
      "kind": {
        "training": "Training",
        "elearning": "E-learning",
        "survey": "Losse vragenlijst"
      },
      "totalTitle": "Totaal over alle uitvoeringen",
      "totalComplementWhy": "Het totaal blijft verborgen zolang het, naast wat je per uitvoering kunt lezen, een kleine uitvoering zou prijsgeven. Het verschijnt zodra dat niet meer kan.",
      "textsPerOccurrence": "De teksten die mensen hebben geschreven lees je per uitvoering.",
      "byOccurrenceTitle": "Per uitvoering",
      "byOccurrenceHint": "Hier staan alleen aantallen. De uitkomst van een uitvoering staat in zijn eigen rapport.",
      "column": {
        "occurrence": "Uitvoering",
        "counted": "Reacties",
        "status": "Rapport"
      },
      "occurrenceGone": "Uitvoering niet meer beschikbaar",
      "statusDisclosed": "Genoeg reacties"
    },
    "question": {
      "untitled": "Vraag zonder tekst",
      "answers_one": "{count} antwoord",
      "answers_other": "{count} antwoorden",
      "mean": "Gemiddelde: {mean} (schaal {min} tot {max})",
      "distributionOf": "Verdeling van de antwoorden op: {prompt}",
      "yes": "Ja",
      "no": "Nee",
      "other": "Anders, namelijk",
      "multipleHint": "Er konden meerdere antwoorden worden gekozen; de aandelen tellen daarom niet op tot 100%.",
      "divergedTitle": "Deze vraag is anders geformuleerd",
      "divergedBody": "De tekst van deze vraag is in de loop van de tijd aangepast. De antwoorden zijn bij elkaar opgeteld. Zo is de vraag gesteld:",
      "formulation": "{prompt} — {count}×",
      "notAggregated": "Deze vraag is geteld, maar niet opgeteld: het soort vraag verschilt per formulier of is nog niet te rapporteren."
    },
    "table": {
      "value": "Waarde",
      "answer": "Antwoord",
      "count": "Aantal",
      "share": "Aandeel",
      "shareOf": "Aandeel"
    },
    "remarks": {
      "title": "Opmerkingen"
    },
    "freeText": {
      "show": "Toon de antwoorden bij {label} ({count})",
      "hide": "Verberg de antwoorden bij {label}",
      "loading": "Antwoorden laden…",
      "loadError": "De antwoorden konden niet worden geladen.",
      "order": "De antwoorden staan zonder naam en in willekeurige volgorde.",
      "listLabel": "Antwoorden bij {label}",
      "pagerLabel": "Pagina’s met antwoorden bij {label}",
      "previous": "Vorige",
      "next": "Volgende",
      "pageOf": "Pagina {page} van {last}"
    }
  },
  "qualifications": {
    "heading": "Kwalificaties",
    "intro": "De kwalificaties die jouw organisatie bijhoudt, zoals BHV, VCA of een heftruckcertificaat. Een training kan er een verlenen: wie de training afrondt, houdt de kwalificatie vanaf dan.",
    "tabs": {
      "definitions": "Definities",
      "held": "Wie wat houdt"
    },
    "new": "Nieuwe kwalificatie",
    "newTitle": "Nieuwe kwalificatie",
    "editTitle": "Kwalificatie bewerken",
    "count_one": "{count} kwalificatie",
    "count_other": "{count} kwalificaties",
    "empty": "Nog geen kwalificaties. Maak de eerste aan om hem aan een training te koppelen.",
    "emptyFiltered": "Geen kwalificaties gevonden met deze filters.",
    "loadError": "De kwalificaties konden niet worden geladen.",
    "filter": {
      "status": "Toon",
      "active": "Actief",
      "archived": "Gearchiveerd",
      "all": "Alle"
    },
    "cols": {
      "name": "Naam",
      "validity": "Geldigheid",
      "held": "Gehouden door",
      "grants": "Trainingen"
    },
    "duration": {
      "none": "Verloopt niet",
      "day_one": "{count} dag",
      "day_other": "{count} dagen",
      "month_one": "{count} maand",
      "month_other": "{count} maanden",
      "year_one": "{count} jaar",
      "year_other": "{count} jaar"
    },
    "unit": {
      "day": "Dagen",
      "month": "Maanden",
      "year": "Jaren"
    },
    "status": {
      "archived": "Gearchiveerd"
    },
    "fields": {
      "name": "Naam",
      "description": "Omschrijving",
      "expires": "Deze kwalificatie verloopt",
      "amount": "Periode",
      "unit": "Eenheid",
      "unitPlaceholder": "Kies een eenheid",
      "durationHint": "Hoe lang de kwalificatie geldig blijft nadat hij is verleend.",
      "durationChangeHint": "Wijzigen raakt bestaande houders niet: hun einddatum lag vast op het moment dat ze hem kregen.",
      "noEndHint": "Deze kwalificatie heeft geen einddatum. Houders houden hem tot iemand hem intrekt.",
      "active": "Actief",
      "activeHint": "Een gearchiveerde kwalificatie is niet meer te kiezen of te verlenen. Wie hem houdt, houdt hem."
    },
    "actions": {
      "editNamed": "{name} bewerken",
      "archive": "Archiveren",
      "archiveNamed": "{name} archiveren",
      "restore": "Terugzetten",
      "restoreNamed": "{name} terugzetten"
    },
    "archiveConfirm": {
      "title": "Deze kwalificatie archiveren?",
      "body": "{name} is daarna niet meer te kiezen of aan een training te koppelen. Je kunt hem later terugzetten.",
      "bodyHeld_one": "{name} wordt gehouden door {count} persoon. Die houdt hem, maar hij is niet meer te kiezen of aan een training te koppelen. Je kunt hem later terugzetten.",
      "bodyHeld_other": "{name} wordt gehouden door {count} personen. Zij houden hem, maar hij is niet meer te kiezen of aan een training te koppelen. Je kunt hem later terugzetten."
    },
    "discard": {
      "title": "Wijzigingen weggooien?",
      "body": "Je hebt wijzigingen die nog niet zijn opgeslagen. Als je nu sluit, gaan ze verloren.",
      "confirm": "Weggooien",
      "keep": "Verder bewerken"
    },
    "notice": {
      "created": "Kwalificatie aangemaakt.",
      "updated": "Kwalificatie opgeslagen.",
      "archived": "{name} gearchiveerd.",
      "restored": "{name} teruggezet."
    },
    "grantedBy": {
      "title": "Verleend door",
      "intro": "De trainingen die deze kwalificatie verlenen. Je koppelt een training op het scherm van de training zelf.",
      "empty": "Nog geen training verleent deze kwalificatie.",
      "loadError": "De trainingen konden niet worden geladen.",
      "noEnd": "geen einddatum",
      "own": "eigen periode: {duration}",
      "inherited": "standaardperiode: {duration}"
    }
  },
  "heldQualifications": {
    "heading": "Wie wat houdt",
    "intro": "Elke kwalificatie die iemand houdt, met zijn geldigheid en waar hij vandaan komt. Filter op wie, wat en wanneer hij verloopt.",
    "count_one": "{count} resultaat",
    "count_other": "{count} resultaten",
    "empty": "Nog niemand houdt een kwalificatie. Rijen verschijnen hier zodra iemand een training afrondt die er een verleent.",
    "emptyFiltered": "Geen rijen gevonden met deze filters.",
    "loadError": "De gehouden kwalificaties konden niet worden geladen.",
    "noEnd": "geen einddatum",
    "daysLeft_one": "nog {count} dag",
    "daysLeft_other": "nog {count} dagen",
    "renewalStopped": "Verlenging gestopt",
    "note": "Notitie (optioneel)",
    "filter": {
      "qualification": "Kwalificatie",
      "person": "Persoon",
      "personPlaceholder": "Zoek een persoon",
      "status": "Status",
      "expiring": "Verloopt",
      "any": "Op elk moment",
      "expiringOption": "Binnen {days} dagen",
      "all": "Alle",
      "archivedName": "{name} (gearchiveerd)",
      "clear": "Filters wissen"
    },
    "status": {
      "valid": "Geldig",
      "not_yet_valid": "Nog niet geldig",
      "expired": "Verlopen",
      "ended_by_choice": "Beëindigd, niet verlengd",
      "superseded": "Vervangen",
      "corrected": "Gecorrigeerd",
      "withdrawn": "Ingetrokken",
      "never_valid": "Nooit geldig geweest",
      "active": "Actief (geldig of aanstaand)",
      "ended": "Beëindigd (elke reden)"
    },
    "origin": {
      "completion": "Training afgerond",
      "external_training": "Externe training",
      "self_declared": "Zelf opgegeven",
      "administrative": "Geregistreerd door een beheerder"
    },
    "evidence": {
      "trusted": "Vastgelegd door het systeem",
      "verifiable": "Controleerbaar bewijs",
      "declaration": "Verklaring, niet gecontroleerd"
    },
    "sourceType": {
      "completion_record": "Afronding",
      "import_run": "Importrun",
      "migration_run": "Migratierun"
    },
    "endReason": {
      "superseded": "Vervangen door een nieuwere",
      "corrected": "Gecorrigeerd",
      "withdrawn_from_now": "Ingetrokken per nu",
      "never_valid": "Nooit geldig geweest"
    },
    "cols": {
      "person": "Persoon",
      "qualification": "Kwalificatie",
      "window": "Geldig",
      "origin": "Herkomst",
      "ground": "Grond",
      "status": "Status"
    },
    "detail": {
      "window": "Geldigheid",
      "origin": "Herkomst",
      "evidence": "Grond",
      "source": "Bron",
      "noSource": "Geen bron-gebeurtenis (met de hand geregistreerd)",
      "run": "Run",
      "ended": "Beëindigd",
      "renewalStopped": "Verlenging gestopt",
      "recorded": "Vastgelegd op"
    },
    "actions": {
      "withdraw": "Intrekken",
      "withdrawNamed": "{name} intrekken",
      "stopRenewal": "Stop verlenging",
      "stopRenewalNamed": "Verlenging van {name} stoppen",
      "resumeRenewal": "Hervat verlenging",
      "resumeRenewalNamed": "Verlenging van {name} hervatten"
    },
    "withdraw": {
      "title": "Deze kwalificatie intrekken?",
      "body": "{name}: hiermee eindigt de kwalificatie. Dit is niet terug te draaien.",
      "reason": "Reden",
      "reasonPlaceholder": "Kies een reden",
      "reasonRequired": "Kies een reden voor het intrekken.",
      "reasons": {
        "withdrawn_from_now": "Per nu",
        "never_valid": "Nooit geldig geweest"
      },
      "reasonHints": {
        "withdrawn_from_now": "De persoon had hem tot nu toe. Rapporten over het verleden tellen hem nog mee.",
        "never_valid": "Hij had nooit verleend mogen worden. Rapporten over het verleden tellen hem niet meer mee."
      },
      "confirm": "Intrekken"
    },
    "stopRenewal": {
      "title": "Verlenging stoppen?",
      "body": "{name}: de kwalificatie wordt niet verlengd. Zodra hij afloopt staat hij als beëindigd, niet als verlopen. Je kunt dit terugdraaien zolang hij nog geldig is.",
      "confirm": "Stop verlenging"
    },
    "resumeRenewal": {
      "title": "Verlenging hervatten?",
      "body": "{name}: de kwalificatie is weer te verlengen.",
      "confirm": "Hervat verlenging"
    },
    "notice": {
      "withdrawn": "{name} ingetrokken.",
      "stopped": "Verlenging van {name} gestopt.",
      "stoppedMany": "Verlenging van {name} gestopt op {count} rijen.",
      "resumed": "Verlenging van {name} hervat.",
      "resumedMany": "Verlenging van {name} hervat op {count} rijen."
    }
  },
  "activityQualifications": {
    "title": "Verleent kwalificatie",
    "intro": "Wie deze training afrondt, houdt vanaf dan deze kwalificaties.",
    "loadError": "De gekoppelde kwalificaties konden niet worden geladen.",
    "empty": "Deze training verleent geen kwalificatie.",
    "emptyNew": "Nog geen kwalificatie gekozen. De koppeling wordt gemaakt zodra je de activiteit opslaat.",
    "notForComposition": "Een bundel of leerlijn verleent zelf geen kwalificatie; kies een losse activiteit om er een te koppelen.",
    "noEnd": "geen einddatum",
    "own": "eigen periode: {duration}",
    "inherited": "standaardperiode: {duration}",
    "add": "Kwalificatie koppelen",
    "addTitle": "Kwalificatie koppelen",
    "editTitle": "Geldigheid wijzigen",
    "qualification": "Kwalificatie",
    "qualificationPlaceholder": "Kies een kwalificatie",
    "qualificationRequired": "Kies een kwalificatie.",
    "ownDurationHint": "Laat leeg om de standaardperiode van de kwalificatie te gebruiken.",
    "ownDurationHintWithDefault": "Laat leeg om de standaard te gebruiken: {duration}.",
    "noEndHint": "Deze kwalificatie heeft geen einddatum, dus er is geen periode in te stellen.",
    "editNamed": "{name} bewerken",
    "removeNamed": "{name} ontkoppelen",
    "remove": "Ontkoppelen",
    "removeConfirm": {
      "title": "Deze kwalificatie ontkoppelen?",
      "body": "{name} wordt niet meer verleend door deze training. Wie hem al houdt, houdt hem."
    },
    "notice": {
      "added": "Kwalificatie gekoppeld.",
      "updated": "Geldigheid opgeslagen.",
      "removed": "{name} ontkoppeld."
    }
  },
  "externalRequestTypes": {
    "list": {
      "heading": "Soorten aanvraag externe opleiding",
      "intro": "Een soort is bijvoorbeeld training of coaching, met een eigen formulier, kostenregels en keten. Er is geen standaardsoort: richt er eerst een in en zet hem daarna aan. Zonder live versie is er voor medewerkers nergens een ingang.",
      "new": "Nieuwe soort",
      "empty": "Er zijn nog geen soorten. Maak er een aan om externe opleidingen aan te kunnen vragen.",
      "on": "Aan (v{number})",
      "off": "Uit",
      "open": "Openen",
      "cols": {
        "name": "Soort",
        "status": "Status",
        "versions": "Versies"
      },
      "fields": {
        "name": "Naam",
        "key": "Sleutel",
        "keyHint": "Kleine letters, cijfers en _. Je kunt de sleutel daarna niet meer wijzigen."
      }
    },
    "detail": {
      "empty": "Deze soort heeft nog geen versies.",
      "cols": {
        "version": "Versie",
        "status": "Status",
        "liveFrom": "Live vanaf"
      },
      "edit": "Bewerken",
      "view": "Bekijken",
      "goLive": "Live zetten",
      "schedule": "Inplannen",
      "unschedule": "Inplannen ongedaan maken",
      "discard": "Weggooien",
      "newConceptFrom": "Nieuw concept hieruit",
      "newConcept": "Nieuw leeg concept",
      "conceptExists": "Er is al een concept; er kan er maar één tegelijk zijn.",
      "notValid": "Deze versie kan nog niet live. Dit moet eerst kloppen:",
      "isOn": "De soort staat aan: medewerkers kunnen hem aanvragen.",
      "isOff": "De soort staat uit: er is geen live versie, dus medewerkers hebben geen ingang.",
      "rename": "Naam wijzigen",
      "scheduleTitle": "Versie {number} inplannen",
      "liveFrom": "Live vanaf",
      "liveFromHint": "Tijdzone van de omgeving ({timezone}). Op dat moment wordt de versie opnieuw gecontroleerd; klopt er dan iets niet meer, dan blijft de huidige versie live.",
      "discardTitle": "Concept weggooien?",
      "discardBody": "Versie {number} wordt verwijderd. Een live of afgesloten versie blijft altijd bewaard.",
      "catalogTile": {
        "heading": "Tegel in de catalogus",
        "label": "Toon een tegel in de catalogus",
        "hintOn": "Medewerkers die mogen aanvragen zien in de catalogus een tegel waarmee ze deze soort aanvragen.",
        "hintOff": "De tegel verschijnt pas als deze soort aan staat (een live versie heeft)."
      }
    },
    "status": {
      "concept": "Concept",
      "scheduled": "Gepland",
      "live": "Live",
      "phasing_out": "Uitlopend",
      "archived": "Gearchiveerd",
      "failed": "Mislukt"
    },
    "transition": {
      "version_not_editable": "Alleen een concept is te wijzigen. Maak een nieuw concept uit deze versie.",
      "version_wrong_state": "Dit kan niet met een versie in deze toestand.",
      "concept_exists": "Er is al een concept voor deze soort. Maak dat af of gooi het weg.",
      "schedule_exists": "Er staat al een omschakeling gepland voor deze soort.",
      "moment_not_in_future": "Kies een moment in de toekomst."
    },
    "role": {
      "title": "Titel",
      "provider": "Opleider",
      "cost": "Kosten",
      "period": "Periode",
      "qualification": "Kwalificatie"
    },
    "phase": {
      "request": "Aanvraag",
      "agreement": "Overeenkomst",
      "verification": "Verificatie",
      "change": "Wijziging"
    },
    "cost": {
      "kind": {
        "fixed": "Vast bedrag",
        "unit": "Prijs × aantal"
      },
      "vat": {
        "none": "Geen btw bekend",
        "excl": "Bedrag excl. btw",
        "incl": "Bedrag incl. btw"
      },
      "empty": "Nog geen kostenregels. Voeg er minstens één toe: het totaal van de regels is de rol Kosten.",
      "key": "Sleutel",
      "type": "Type",
      "vatLabel": "Btw",
      "rate": "Percentage",
      "remove": "Verwijderen",
      "add": "Kostenregel toevoegen"
    },
    "preview": {
      "heading": "Live voorbeeld",
      "language": "Taal van het voorbeeld",
      "empty": "Voeg velden toe om het formulier te zien.",
      "noCostLines": "Voeg een kostenregel toe om de kosten te zien.",
      "price": "{name} — prijs",
      "quantity": "{name} — aantal",
      "totalExcl": "Totaal excl. btw",
      "totalIncl": "Totaal incl. btw",
      "vatUnknown": "onbekend (niet elke regel kent zijn btw)",
      "firstDay": "eerste dag",
      "lastDay": "laatste dag",
      "allDays": "De medewerker geeft hier alle dagen van de opleiding op.",
      "providerPlaceholder": "Opleider kiezen of zoeken…",
      "qualificationPlaceholder": "Kwalificatie kiezen…"
    },
    "editor": {
      "heading": "Versie {number}",
      "introConcept": "Dit concept is te bewerken. Live zetten en inplannen controleren het eerst.",
      "introReadOnly": "Deze versie is onveranderlijk. Wijzigen kan via een nieuw concept uit deze versie.",
      "back": "Terug naar de soort",
      "check": "Controleren",
      "checkOk": "Alles klopt: deze versie kan live.",
      "checkMissing_one": "Er is nog {count} ding dat niet klopt:",
      "checkMissing_other": "Er zijn nog {count} dingen die niet kloppen:",
      "checkStale": "Je hebt iets gewijzigd sinds de controle. Bewaar en controleer opnieuw.",
      "saved": "Het concept is bewaard.",
      "saveFailed": "Het concept kon niet worden bewaard.",
      "failed": "De omschakeling naar deze versie is niet doorgegaan; de oude versie bleef live. Dit klopte op dat moment niet meer:",
      "settings": "Instellingen",
      "settingsHint": "De kosten worden gelezen op de gekozen basis, zodat er nooit wordt omgerekend. De regels met voorwaarden per fase komen met de procesgrafiek; hier kies je de keten voor de aanvraag.",
      "costBasis": "Kosten lezen op basis van",
      "basis": {
        "excl": "Totaal excl. btw",
        "incl": "Totaal incl. btw"
      },
      "periodMode": "Periode van de opleiding",
      "period": {
        "all_days": "Alle dagen",
        "first_last": "Eerste en laatste dag",
        "none": "Geen datum"
      },
      "requestChain": "Goedkeuringsketen voor de aanvraag",
      "noChain": "Nog geen keten gekozen",
      "learningForm": "Leervorm van de opleiding",
      "learningFormHelp": "Een goedgekeurde aanvraag wordt een externe opleiding op naam van de medewerker, met deze leervorm. De lijst komt uit de leervormen van de catalogusinstellingen.",
      "learningFormDefault": "Standaard ({name})",
      "agreementTemplate": "Overeenkomst",
      "noAgreement": "Geen overeenkomst",
      "agreementUnavailable": "Beschikbaar zodra overeenkomsten uitgegeven kunnen worden",
      "moreRules": "Deze versie heeft meer dan één regel voor de aanvraag (bijvoorbeeld uit een import). Die blijven staan; bewerken kan met de procesgrafiek.",
      "form": "Formulier",
      "formHint": "Titel, opleider en kosten zijn altijd verplicht. Geef elk veld een naam in elke taal van de omgeving.",
      "costLines": "Kostenregels",
      "costHint": "Het platform rekent het totaal uit en bewaart de regels en het totaal samen als momentopname op de aanvraag."
    },
    "violation": {
      "cost_basis_missing": "Kies op welke basis de kosten worden gelezen (excl. of incl. btw).",
      "period_mode_missing": "Kies wat de soort aan datums vraagt.",
      "learning_form_unknown": "De gekozen leervorm \"{key}\" staat niet meer in de leervormen van de omgeving. Kies een andere of laat hem leeg.",
      "field_key_invalid": "De sleutel \"{key}\" is niet geldig: gebruik kleine letters, cijfers en _, beginnend met een letter.",
      "field_key_duplicate": "De sleutel \"{key}\" staat op twee velden.",
      "field_type_invalid": "Het veld \"{key}\" heeft een onbekend type.",
      "field_label_missing": "Het veld \"{key}\" mist een label in het {locale}.",
      "role_duplicate": "De rol {role} staat op meer dan één veld.",
      "role_type_invalid": "Het veld \"{key}\" heeft een type dat niet past bij de rol {role}.",
      "role_must_be_required": "Het veld \"{key}\" met de rol {role} moet verplicht zijn.",
      "role_missing": "Koppel een veld aan de rol {role}.",
      "period_role_without_period": "Er staat een veld met de rol Periode, maar de soort vraagt geen datum.",
      "cost_lines_missing": "Voeg minstens één kostenregel toe.",
      "cost_line_key_invalid": "De sleutel \"{key}\" van een kostenregel is niet geldig.",
      "cost_line_key_duplicate": "De sleutel \"{key}\" staat op twee kostenregels.",
      "cost_line_kind_invalid": "De kostenregel \"{key}\" heeft een onbekend type.",
      "cost_line_label_missing": "De kostenregel \"{key}\" mist een naam in het {locale}.",
      "cost_line_vat_invalid": "De kostenregel \"{key}\" heeft een onbekende btw-instelling.",
      "cost_line_vat_rate_unknown": "De kostenregel \"{key}\" heeft een btw-percentage dat niet in de lijst staat.",
      "cost_basis_unavailable": "De soort leest de kosten incl. btw, maar de kostenregel \"{key}\" kent zijn btw niet.",
      "phase_request_missing": "Kies een goedkeuringsketen voor de aanvraag.",
      "phase_unknown": "De fase \"{phase}\" bestaat niet.",
      "rules_no_catch_all": "De regels voor de fase {phase} eindigen niet op een regel zonder voorwaarde.",
      "rules_catch_all_not_last": "Regel {index} voor de fase {phase} heeft geen voorwaarde, dus de regels erna worden nooit bereikt.",
      "rule_chain_missing": "Regel {index} voor de fase {phase} wijst geen keten aan.",
      "chain_not_found": "De keten voor de fase {phase} bestaat niet meer.",
      "chain_empty": "De keten voor de fase {phase} heeft geen stappen.",
      "chain_unresolvable": "In de keten voor de fase {phase} kan niemand beslissen: de gekozen rol of persoon bestaat niet of is leeg.",
      "chain_all_of": "De keten voor de fase {phase} heeft een stap waarin iedereen moet beslissen. In een aanvraag externe opleiding kan alleen \"één van hen\".",
      "agreement_not_available": "Regel {index} voor de fase {phase} kiest een overeenkomst. Het uitgeven van een overeenkomst komt nog; kies voorlopig \"geen overeenkomst\".",
      "rule_step_keys_invalid": "Regel {index} voor de fase {phase} heeft een ongeldige of dubbele stapsleutel.",
      "mail_template_missing": "De e-mail \"{slug}\" voor \"{event}\" bestaat niet."
    }
  },
  "themes": {
    "heading": "Categorieën",
    "intro": "Beheer de categorieën waaruit je bij een activiteit kiest en waarop de catalogus filtert. Een categorie kan onder een hoofdcategorie hangen als subcategorie; de naam kun je per taal invullen.",
    "new": "Nieuwe categorie",
    "editTitle": "Categorie bewerken",
    "empty": "Er zijn nog geen categorieën. Voeg de eerste toe om hem bij een activiteit te kunnen kiezen.",
    "fields": {
      "name": "Naam ({language})",
      "parent": "Valt onder",
      "noParent": "Geen (hoofdcategorie)",
      "parentHint": "Kies een hoofdcategorie om deze categorie eronder te hangen.",
      "parentLocked": "Deze categorie heeft zelf subcategorieën en blijft daarom een hoofdcategorie."
    },
    "cols": {
      "name": "Categorie",
      "usage": "Activiteiten",
      "actions": "Acties"
    },
    "moveUp": "{name} een plek omhoog",
    "moveDown": "{name} een plek omlaag",
    "merge": "Samenvoegen",
    "mergeTitle": "Categorie samenvoegen",
    "mergeBody": "De {count} activiteit(en) van “{name}” gaan naar de categorie die je kiest. “{name}” verdwijnt daarna.",
    "mergeInto": "Voeg samen met",
    "mergeChoose": "Kies een categorie",
    "deleteBlockedInUse": "Deze categorie wordt gebruikt. Voeg haar samen met een andere categorie.",
    "deleteBlockedChildren": "Deze categorie heeft subcategorieën.",
    "confirmDelete": "Categorie verwijderen?",
    "confirmDeleteBody": "“{name}” wordt verwijderd. Dit kan niet ongedaan worden gemaakt."
  },
  "media": {
    "heading": "Mediabibliotheek",
    "intro": "De afbeeldingen van deze omgeving, voor gebruik bij catalogus-items. Je ziet per afbeelding hoe vaak hij gebruikt wordt, of er nog een alt-tekst ontbreekt, en of er bij de bron een nieuwere versie klaarstaat. Klik een afbeelding aan voor alles wat je ermee kunt. Alleen png en jpg, meerdere tegelijk mag.",
    "add": "Afbeeldingen toevoegen",
    "addError": "Toevoegen is niet gelukt. Probeer het opnieuw.",
    "removeError": "Verwijderen is niet gelukt. Probeer het opnieuw.",
    "loadError": "De bibliotheek kon niet worden opgehaald.",
    "usageError": "Kon niet ophalen waar deze afbeelding gebruikt wordt.",
    "empty": "Er staat nog geen afbeelding in de bibliotheek.",
    "inUse": "In gebruik",
    "notInUse": "Niet in gebruik",
    "altMissing": "Geen alt-tekst",
    "editAlt": "Alt-tekst",
    "saveAlt": "Alt-tekst opslaan",
    "altError": "De alt-tekst kon niet worden opgeslagen.",
    "altFor": "Alt-tekst ({language})",
    "altHint": "Beschrijf wat er op de afbeelding te zien is, voor wie hem niet kan zien. Laat een taal leeg als je hem niet gebruikt.",
    "remove": "Verwijderen",
    "removeFor": "{name} verwijderen",
    "confirmRemove": "Weet je het zeker? De afbeelding verdwijnt uit de bibliotheek.",
    "pagination": "Paginering",
    "prev": "Vorige",
    "next": "Volgende",
    "pageOf": "Pagina {page} van {total}",
    "defaultHeading": "Standaard-afbeelding",
    "defaultNone": "Nog geen standaard ingesteld",
    "defaultElsewhere": "Ingesteld — staat op een andere pagina",
    "defaultClear": "Standaard weghalen",
    "defaultBadge": "Standaard",
    "defaultError": "De standaard-afbeelding kon niet worden ingesteld.",
    "setDefaultFor": "{name} als standaard instellen",
    "deliveredHeading": "Meegeleverd door BCS",
    "deliveredIntro": "Deze afbeeldingen komen van BCS en staan er voor iedereen hetzelfde bij. Je kunt ze uit je bibliotheek halen en je eigen alt-tekst geven; het bestand zelf blijft van BCS.",
    "removeDelivered": "Uit mijn bibliotheek halen",
    "removeDeliveredFor": "{name} uit mijn bibliotheek halen",
    "confirmRemoveDelivered": "Deze afbeelding verdwijnt uit jouw bibliotheek. Het bestand blijft bestaan en BCS kan hem opnieuw beschikbaar maken.",
    "addFromUrl": "Via een adres",
    "addFromPexels": "Zoek op Pexels",
    "fromUrlTitle": "Afbeelding toevoegen via een adres",
    "fromUrlField": "Adres van de afbeelding",
    "fromUrlHint": "We downloaden de afbeelding en bewaren hem hier. Wijzigt hij later bij de bron, dan kun je hem met één knop opnieuw ophalen.",
    "fromUrlSubmit": "Ophalen en toevoegen",
    "fromUrlError": "De afbeelding kon niet worden opgehaald.",
    "creditField": "Vermelding (optioneel)",
    "creditHint": "De naam die bij de afbeelding getoond moet worden, als de bron dat vraagt.",
    "creditBy": "Foto: {name}",
    "fetching": "Bezig met ophalen…",
    "sourceChanged": "Bron gewijzigd",
    "sourceCheck": "Bron controleren",
    "sourceChecking": "Bezig met controleren…",
    "pexelsTitle": "Zoeken op Pexels",
    "pexelsField": "Waar zoek je naar?",
    "pexelsSearch": "Zoeken",
    "pexelsHint": "Pexels zoekt het beste op Engelse woorden. De naam van de fotograaf wordt bij de afbeelding bewaard — dat vraagt Pexels.",
    "pexelsImport": "Toevoegen aan bibliotheek",
    "pexelsPartial": "{count} afbeeldingen konden niet worden opgehaald:",
    "pexelsImportCount": "Importeren ({count})",
    "pexelsEmpty": "Geen resultaten voor dit woord.",
    "pexelsError": "Zoeken op Pexels is niet gelukt.",
    "pexelsImportError": "De afbeelding kon niet worden toegevoegd.",
    "pickerTitle": "Afbeelding kiezen",
    "pickerSearch": "Zoeken op bestandsnaam",
    "pickerConfirm": "Deze gebruiken",
    "pickerAdd": "Niet gevonden?",
    "pickerNoMatch": "Geen afbeelding met dit woord in de naam.",
    "pickOrUpload": "Kiezen of uploaden",
    "uploadFromComputer": "Uploaden vanaf je computer",
    "uploadField": "Afbeelding uploaden",
    "uploadError": "De afbeelding kon niet worden geüpload.",
    "packagePickerTitle": "E-learningbestand uploaden",
    "packageField": "Zip-bestand",
    "packageUse": "Dit bestand gebruiken",
    "shareWithLibrary": "Ook in de mediabibliotheek bewaren",
    "shareWithLibraryHint": "Laat dit uit als de afbeelding alleen bij dit item hoort — dan verdwijnt hij er ook mee.",
    "detailTitle": "Afbeelding",
    "openDetail": "{name} openen",
    "dimensions": "Afmeting",
    "pixels": "{width} × {height} pixels",
    "fileSize": "Bestandsgrootte",
    "fileType": "Type",
    "credit": "Vermelding",
    "source": "Bron",
    "inUseCount": "{count}× in gebruik",
    "setDefault": "Als standaard instellen",
    "actionError": "De wijziging is niet gelukt. Probeer het opnieuw.",
    "dropHere": "Sleep afbeeldingen hierheen of klik om te kiezen",
    "dropHint": "png of jpg, meerdere tegelijk",
    "uploading": "Bezig met uploaden…",
    "uploadingPercent": "Bezig met uploaden… {percent}%",
    "sourceUnchanged": "De bron is ongewijzigd.",
    "sourceChangedHint": "Dit staat er nu bij de bron. Neem je hem over, dan wordt dit de afbeelding — overal waar hij gebruikt wordt.",
    "sourcePreviewAlt": "De afbeelding zoals die nu bij de bron staat",
    "sourcePreviewGone": "De klaargezette voorvertoning is er niet meer. Controleer de bron opnieuw om te zien wat er nu staat.",
    "sourceUpdate": "Bijwerken",
    "sourceCheckAgain": "Opnieuw controleren",
    "usage": {
      "activity_image": "Beeld van een leeractiviteit",
      "activity_source": "Bron van een leeractiviteit",
      "occurrence_image": "Beeld van een uitvoering",
      "elearning_package": "E-learning-pakket",
      "external_request_attachment": "Bijlage bij een aanvraag",
      "message_attachment": "Bijlage bij een bericht",
      "tenant_default": "Standaard-afbeelding van deze omgeving",
      "user_avatar": "Profielfoto van een gebruiker",
      "certificate": "Uitgereikt certificaat",
      "document_template": "Logo van een documentsjabloon",
      "document_settings": "Logo van de omgeving op certificaten"
    }
  },
  "studyLoad": {
    "heading": "Studielast",
    "durationLabel": "Duur van de training",
    "durationDeviation": "Afwijkende duur",
    "durationChoose": "Kies een duur",
    "durationCustom": "Anders…",
    "studyLoadLabel": "Totale studielast",
    "hours": "Uren",
    "minutes": "Minuten",
    "hoursShort": "u",
    "minutesShort": "min",
    "inherited": "Standaard van de activiteit: {value}",
    "useInherited": "Terug naar de standaard van de activiteit ({value})",
    "inheritedFromPlanning": "Uit de planning: {value}",
    "useInheritedFromPlanning": "Terug naar de duur uit de planning ({value})",
    "belowDuration": "De totale studielast is korter dan de duur. Controleer of dat klopt."
  },
  "catalogs": {
    "references": {
      "deleteTitle": "{name} wordt nog gebruikt",
      "deleteBody": "Verwijder je deze catalogus, dan gebeurt het volgende:",
      "deleteConfirm": "Toch verwijderen",
      "slugTitle": "Er linken teksten naar het huidige adres",
      "slugBody": "Wijzig je het adres, dan gaan deze links naar /catalog/{slug} nergens meer heen:",
      "slugConfirm": "Adres toch wijzigen",
      "isStart": "Wie /catalog opent, komt nu hier uit. Dat wordt de volgende catalogus in het menu.",
      "inMenu": "Hij verdwijnt uit het menu.",
      "catalog": {
        "include": "Catalogus ‘{name}’ neemt hem op. Die catalogus wordt leeg, met een waarschuwing.",
        "exclude": "Catalogus ‘{name}’ sluit hem uit. Die catalogus wordt leeg, met een waarschuwing."
      },
      "activityLink": "De omschrijving van training ‘{title}’ linkt ernaar.",
      "catalogText": "De omschrijving van catalogus ‘{name}’ linkt ernaar.",
      "text": "De eigen tekst ‘{key}’ ({locale}) linkt ernaar.",
      "mailTemplate": "Mail: {name} ({locales}) linkt ernaar.",
      "outside": "Links buiten het systeem, zoals bladwijzers of een intranetpagina, kunnen we niet zien.",
      "unknown": "We konden niet nagaan waar deze catalogus gebruikt wordt. Probeer het opnieuw."
    },
    "new": "Catalogus toevoegen",
    "newTitle": "Nieuwe catalogus",
    "untitled": "Naamloze catalogus",
    "backToList": "Terug naar de lijst",
    "emptyAll": "Er is geen enkele catalogus.",
    "emptyAllHint": "Zonder catalogus heeft een lerende geen bladerkant — alleen directe links en toegewezen trainingen.",
    "itemCount_one": "{count} training",
    "itemCount_other": "{count} trainingen",
    "notInNav": "niet in het menu",
    "broken": "Een verwijzing bestaat niet meer; deze catalogus toont niets.",
    "deleteAnyway": "Toch weggooien",
    "name": "Naam ({language})",
    "slug": "Adres",
    "slugHelp": "Het stukje achter /catalog/ in de link. Kleine letters, cijfers en streepjes. Pas je het aan, dan werken gedeelde links naar deze pagina niet meer.",
    "statusLabel": "Status",
    "inMainNav": "In het menu tonen",
    "inMainNavHelp": "Uit betekent: wel bereikbaar via een link, niet in de zijbalk.",
    "showWhenEmpty": "Tonen als er niets in zit",
    "showWhenEmptyHelp": "Standaard verdwijnt een catalogus uit het menu zodra er voor die persoon niets in zit. Leeg is dus per persoon: wat de een ziet, hoeft de ander niet te zien.",
    "visibilityMode": "Wie mag deze pagina openen",
    "accessGroup": "Toegangsgroep",
    "pickAccessGroup": "Kies een groep…",
    "viewMode": "Wat de lijst toont",
    "defaultLayout": "Begin-weergave",
    "imageRatio": "Beeldverhouding",
    "imageRatioHelp": "Bepaalt hoe de afbeeldingen gesneden worden. De lijstweergave houdt dezelfde verhouding aan als de kaarten.",
    "status": {
      "concept": "Concept",
      "published": "Gepubliceerd",
      "inactive": "Inactief"
    },
    "visibility": {
      "everyone": "Iedereen",
      "ruleset": "Alleen een toegangsgroep"
    },
    "view": {
      "activities": "Eén vermelding per training",
      "occurrences": "Alle uitvoeringen zichtbaar"
    },
    "layout": {
      "cards": "Kaarten",
      "list": "Lijst"
    },
    "sections": {
      "identity": "Naam en plek",
      "identityHelp": "Hoe de pagina heet en waar hij in het menu staat.",
      "content": "Wat erin komt",
      "contentHelp": "Insluiten haalt trainingen binnen, uitsluiten houdt ze eruit. Een handgekozen uitsluiting wint van alles; een handgekozen training overleeft een regel die hem zou wegfilteren.",
      "access": "Wie de pagina mag openen",
      "accessHelp": "Dit gaat over de pagina, niet over de trainingen erin. Wie een training via een directe link mag openen, mag dat ook als hij deze catalogus niet kan openen.",
      "presentation": "Weergave",
      "presentationHelp": "Hoe de pagina eruitziet. De lerende mag kaarten en lijst zelf omzetten."
    },
    "membership": {
      "field": "Waarop",
      "values": "Welke waarden",
      "otherCatalog": "Welke catalogus",
      "pickCatalog": "Kies een catalogus…",
      "allHint": "Alles wat deze omgeving heeft.",
      "addCondition": "Voorwaarde toevoegen",
      "removeCondition": "Voorwaarde weghalen",
      "removeTerm": "Weghalen",
      "kind": {
        "all": "Alles",
        "rule": "Regel",
        "catalog": "Een andere catalogus"
      },
      "branch": {
        "include": "Hierin",
        "exclude": "Hier juist niet in"
      },
      "branchHint": {
        "include": "Een training komt erin als minstens één van deze het zegt.",
        "exclude": "En gaat er weer uit als een van deze hem raakt — tenzij je hem met de hand hebt toegevoegd."
      },
      "add": {
        "rule": "Regel",
        "catalog": "Catalogus",
        "all": "Alles"
      }
    },
    "preview": {
      "title": "Wat zit erin",
      "help": "Twee standen. Wat zit erin toont de selectie los van wie kijkt en los van status — dat is wat je instelt. Zoals een lerende het ziet haalt alles door alle poorten met jouw rechten, en jij ziet als beheerder meer dan een lerende.",
      "holds": "Wat zit erin",
      "asLearner": "Zoals een lerende het ziet",
      "hint": {
        "holds": "De selectie, los van status en van wie kijkt.",
        "learner": "Met alle poorten en jouw rechten. Als beheerder zie je meer dan een lerende."
      },
      "count_one": "{count} training",
      "count_other": "{count} trainingen",
      "empty": "Nog niets. Voeg een regel of een training toe.",
      "broken": "Een verwijzing in de selectie bestaat niet meer, dus deze catalogus toont niets.",
      "saveFirst": "Sla de catalogus eerst op; daarna zie je hier wat erin zit.",
      "term": "term {n}",
      "rung": {
        "1": "met de hand eruit gehaald",
        "2": "met de hand toegevoegd",
        "3": "uitgesloten door een regel",
        "4": "via een regel",
        "5": "geen enkele regel sluit hem in"
      }
    },
    "fields": {
      "type": "Soort",
      "composition": "Samenstelling",
      "tracking_mode": "Bijhouden",
      "learning_form_category": "Leervorm",
      "language": "Taal",
      "theme": "Categorie"
    },
    "onActivity": {
      "heading": "In welke catalogi staat dit?",
      "membershipOnly": "Dit gaat alleen over de selectie. Of een deelnemer de training ook ziet, hangt daarnaast af van de status, de doelgroep en of het materiaal beschikbaar is.",
      "noCatalogs": "Deze omgeving heeft nog geen catalogi.",
      "inside": "Staat erin ({count})",
      "insideNone": "In geen enkele catalogus.",
      "outside": "Staat er niet in ({count})",
      "outsideNone": "In elke catalogus.",
      "brokenCatalog": "Deze catalogus verwijst naar iets dat niet meer bestaat."
    },
    "defaultSort": "Standaard-sortering",
    "defaultSortHelp": "Waarmee de lijst begint. Kiest een bezoeker zelf een andere sortering, dan wint die — deze instelling is het begin, niet een dwang.",
    "shownFacets": "Welke filters staan erbij",
    "shownFacetsHelp": "Dit bepaalt welke filters zichtbaar zijn, niet wat er in de catalogus zit. Een verborgen filter blijft werken via een gedeelde link; wat er in de catalogus hoort, regel je bij de inhoud.",
    "shownFacetsEmpty": "Vink alles aan voor de standaard: alle filters.",
    "facet": {
      "type": "Type",
      "composition": "Vorm",
      "tracking_mode": "Soort",
      "category": "Categorie (vrij veld op de training)",
      "theme": "Categorie (beheerd)",
      "language": "Taal"
    }
  },
  "cancellationPolicies": {
    "heading": "Annuleringsvoorwaarden",
    "intro": "Herbruikbare sets voor annuleren: een termijn vóór de start, en per kant wie mag annuleren en wat het kost. Een nieuwe activiteit krijgt de standaard; een uitvoering kan een andere kiezen.",
    "new": "Nieuwe voorwaarden",
    "editTitle": "Voorwaarden bewerken",
    "view": "Bekijken",
    "empty": "Nog geen annuleringsvoorwaarden. De eerste die je maakt, wordt de standaard.",
    "makeDefault": "Maak standaard",
    "defaultBadge": "Standaard",
    "usage_one": "Gekozen bij {count} activiteit of uitvoering",
    "usage_other": "Gekozen bij {count} activiteiten en uitvoeringen",
    "confirmDelete": "Voorwaarden verwijderen?",
    "confirmDeleteBody": "\"{name}\" wordt verwijderd. Ze worden nergens gebruikt.",
    "summary": "{deadline} · vóór: {before} · daarna: {after}",
    "deadlineSameDay": "termijn tot de startdag",
    "deadlineDays_one": "termijn {count} dag vooraf",
    "deadlineDays_other": "termijn {count} dagen vooraf",
    "cost": {
      "none": "kosteloos"
    },
    "costType": {
      "none": "Kosteloos",
      "fixed": "Vast bedrag"
    },
    "side": {
      "before": "Vóór de termijn",
      "after": "Na de termijn",
      "beforeHelp": "Wat geldt tot en met de dag van de annuleerdeadline.",
      "afterHelp": "Wat geldt na de annuleerdeadline, tot de start. Een beheerder kan altijd annuleren, ook als het hier niet mag."
    },
    "section": {
      "general": "Algemeen",
      "texts": "Tekst voor de lerende"
    },
    "textsHelp": "De lerende leest deze tekst bij de activiteit, in zijn eigen taal. Een taal zonder tekst valt terug op de taal van de omgeving.",
    "fields": {
      "name": "Naam",
      "deadlineDays": "Annuleerdeadline (dagen vóór de eerste dag)",
      "deadlineDaysHelp": "De annuleerdeadline van een uitvoering is haar eerste dag min dit aantal kalenderdagen; 0 is de startdag zelf. Per uitvoering kan de datum met de hand worden gezet.",
      "isDefault": "Standaard voor nieuwe activiteiten",
      "mode": "Wie annuleert",
      "costType": "Kosten",
      "amount": "Bedrag (€)",
      "textIn": "Tekst ({language})"
    }
  },
  "cancellationTerms": {
    "line": {
      "untilStart": {
        "selfFree": "Kosteloos annuleren tot de start",
        "selfFixed": "Annuleren kost {amount}",
        "approvalFree": "Tot de start annuleren, met goedkeuring",
        "approvalFixed": "Tot de start annuleren voor {amount}, met goedkeuring",
        "notAllowed": "Zelf annuleren is niet mogelijk"
      },
      "before": {
        "selfFree": "Kosteloos annuleren tot en met {date}",
        "selfFixed": "Annuleren tot en met {date} kost {amount}",
        "approvalFree": "Tot en met {date} annuleren, met goedkeuring",
        "approvalFixed": "Tot en met {date} annuleren voor {amount}, met goedkeuring",
        "notAllowed": "Annuleren kan niet tot en met {date}"
      },
      "after": {
        "selfFree": "daarna kosteloos",
        "selfFixed": "daarna {amount}",
        "approvalFree": "daarna annuleren, met goedkeuring",
        "approvalFixed": "daarna annuleren voor {amount}, met goedkeuring",
        "notAllowed": "daarna niet meer annuleren"
      },
      "combined": "{before}, {after}"
    },
    "window": {
      "before": "Je annuleert vóór de annuleerdatum ({date}).",
      "after": "De annuleerdatum ({date}) is voorbij.",
      "costNow": "Annuleren kost nu {amount}.",
      "free": "Annuleren is nu kosteloos.",
      "followsRequest": "Over je verzoek wordt nog beslist. Deze kosten gelden ook als dat later gebeurt."
    }
  },
  "contentLanguages": {
    "intro": "De talen waarin je trainingen, hun materiaal en uitvoeringen kunt aanbieden. Dit staat los van de talen van het systeem zelf.",
    "legend": "Contenttalen",
    "legendHelp": "Een training heeft haar teksten per contenttaal, een uitvoering wordt in een van deze talen gegeven en het materiaal kan per taal verschillen. Het taalfilter van de catalogus toont deze talen.",
    "pick": "Talen",
    "pickPlaceholder": "Zoek een taal…",
    "default": "Standaard-contenttaal",
    "defaultHelp": "Hierin schrijf je een training eerst; de andere talen zijn vertalingen. Wie het systeem in een taal gebruikt die geen contenttaal is, krijgt deze taal. Kies je een andere standaard, dan gelden de bestaande teksten in de standaardtaal voortaan als teksten in de nieuwe.",
    "interface": "Talen van het systeem, ingesteld door BCS: {languages}.",
    "required": "Kies minstens één contenttaal.",
    "saved": "De contenttalen zijn opgeslagen.",
    "saveFailed": "Opslaan is niet gelukt. Probeer het opnieuw.",
    "defaultCannotBeRemoved": "De standaard-contenttaal kun je niet verwijderen. Kies eerst een andere standaard en sla die op.",
    "removeConfirm": {
      "title": "Contenttaal verwijderen?",
      "body": "Na het opslaan verdwijnt de taal uit de teksttabs en de catalogus.",
      "used": "{language}: {activities}, {occurrences} en {questionnaires}.",
      "unused": "{language}: er staat nog niets in deze taal.",
      "activities_one": "{count} activiteit",
      "activities_other": "{count} activiteiten",
      "occurrences_one": "{count} uitvoering",
      "occurrences_other": "{count} uitvoeringen",
      "questionnaires_one": "{count} vragenlijst",
      "questionnaires_other": "{count} vragenlijsten",
      "kept": "De teksten blijven bewaard: zet je de taal later weer aan, dan zijn ze er weer.",
      "countFailed": "Het aantal kon niet worden opgehaald. Je kunt toch doorgaan; de teksten blijven bewaard.",
      "confirm": "Verwijderen en opslaan"
    }
  },
  "documentSettings": {
    "heading": "Certificaten",
    "intro": "Hoe het certificaatnummer begint. Een activiteit krijgt pas een certificaat als je er een sjabloon kiest.",
    "saveFailed": "Opslaan is niet gelukt.",
    "saved": "Opgeslagen.",
    "prefix": "Voorvoegsel certificaatnummer",
    "prefixHelp": "Het begin van elk certificaatnummer, bijvoorbeeld ACME in ACME-2026-000123. Leeg is de korte naam van de omgeving. Een nieuw voorvoegsel geldt alleen voor nieuwe certificaten.",
    "prefixExample": "Zo ziet een nummer eruit: {number}",
    "showPlatformTemplates": "BCS-sjablonen tonen",
    "showPlatformTemplatesHelp": "BCS levert voorbeeldsjablonen mee. Verberg je ze, dan verdwijnen ze uit de keuzelijsten; waar er al een gekozen is, blijft het certificaten maken.",
    "platformTemplatesOff": "BCS heeft de BCS-sjablonen voor deze omgeving uitgezet: er komen geen nieuwe BCS-kopieën bij.",
    "toLibrary": "Sjablonen beheren"
  },
  "certificates": {
    "failed": {
      "title": "Certificaten die niet gemaakt konden worden",
      "intro": "Herstel de gegevens of het sjabloon en klik dan op Opnieuw proberen. De afronding zelf staat; de deelnemer ziet intussen dat het certificaat nog gemaakt wordt.",
      "retry": "Opnieuw proberen",
      "retried": "Het certificaat wordt opnieuw gemaakt.",
      "retryFailed": "Opnieuw proberen is niet gelukt.",
      "emptyTitle": "Alles is gelukt",
      "emptyText": "Er zijn geen certificaten die niet gemaakt konden worden.",
      "fix": {
        "user": "Naar de persoon",
        "template": "Naar het sjabloon",
        "activity": "Naar de training"
      }
    },
    "failure": {
      "renderer_unavailable": "Het maken van de PDF was niet beschikbaar.",
      "timed_out": "Het maken van de PDF duurde te lang.",
      "warnings": "Het sjabloon gaf een waarschuwing bij het maken.",
      "compile_error": "Het sjabloon kon niet verwerkt worden.",
      "required_token_empty": "Een verplicht gegeven ontbreekt, bijvoorbeeld de naam van de deelnemer.",
      "unknown_field": "Het sjabloon gebruikt een gegeven dat niet meer bestaat, bijvoorbeeld een verwijderd niveau van de organisatie.",
      "does_not_fit": "Een tekst past zelfs op de kleinste lettergrootte niet op het certificaat.",
      "output_invalid": "De gemaakte PDF klopte niet.",
      "source_rejected": "Het sjabloon bevat iets wat niet is toegestaan.",
      "workspace_unsafe": "De werkmap voor het maken was niet veilig."
    }
  },
  "documentTemplates": {
    "title": "Documentsjablonen",
    "intro": "De sjablonen voor certificaten van deze omgeving, ook de BCS-sjablonen: die kreeg de omgeving als eigen kopie. Elke keer publiceren maakt een nieuwe versie; oude versies blijven te bekijken en terug te zetten.",
    "showArchived": "Gearchiveerde tonen",
    "platformOff": "De BCS-sjablonen staan uit in deze omgeving.",
    "toSettings": "Naar Instellingen",
    "copyFailed": "De kopie kon niet gemaakt worden.",
    "emptyTitle": "Nog geen sjablonen",
    "emptyText": "Zet de BCS-sjablonen aan onder Instellingen, of vraag de beheerder om een sjabloon.",
    "bcs": "BCS",
    "archived": "Gearchiveerd",
    "archivedInUse": "Gearchiveerd, en nog gekozen: er worden nog certificaten mee gemaakt.",
    "view": "Bekijken",
    "adjust": "Aanpassen",
    "edit": "Bewerken",
    "archive": "Archiveren",
    "restore": "Terugzetten",
    "archiveTitle": "{name} archiveren?",
    "archiveInUse": "{usage}. Daar blijft het certificaten maken; alleen voor een nieuwe keuze is het niet meer te kiezen.",
    "archiveUnused": "Het sjabloon is nergens gekozen. Na het archiveren is het niet meer te kiezen; je kunt het terugzetten.",
    "archiveFailed": "Archiveren is niet gelukt.",
    "copyName": "Kopie van {name}",
    "usage": {
      "none": "Nergens gekozen",
      "activities_one": "{count} training",
      "activities_other": "{count} trainingen",
      "occurrences_one": "{count} uitvoering",
      "occurrences_other": "{count} uitvoeringen",
      "line": "Gekozen bij {parts}",
      "paths_one": "{count} leerlijn",
      "paths_other": "{count} leerlijnen"
    },
    "back": "Terug naar de sjablonen",
    "noPresetEditor": "Dit sjabloon heeft geen kant-en-klare opmaak om hier aan te passen.",
    "platformReadOnly": "Een sjabloon van BCS. Je kunt het bekijken; aanpassen doe je in een eigen kopie.",
    "archivedNotice": "Dit sjabloon is gearchiveerd. Waar het al gekozen is, maakt het nog certificaten.",
    "section": {
      "general": "Algemeen",
      "logo": "Logo",
      "colors": "Kleuren",
      "texts": "Teksten"
    },
    "name": "Naam",
    "logo": {
      "label": "Logo",
      "bcs": "Beeldmerk van BCS",
      "tenant": "Logo van de omgeving",
      "none": "Geen logo",
      "noTenantLogo": "Deze omgeving heeft nog geen logo in haar huisstijl.",
      "upload": "Eigen logo",
      "file": "Bestand",
      "fileHint": "PNG of JPG.",
      "uploaded": "Geüpload logo",
      "uploadFailed": "Het logo kon niet geüpload worden."
    },
    "colors": {
      "ink": "Tekstkleur",
      "accent": "Accentkleur",
      "hint": "Leeg = de kleur van het sjabloon. Tekst heeft genoeg contrast met wit nodig."
    },
    "texts": {
      "hint": "Leeg = de tekst van het sjabloon (grijs in het veld).",
      "tabWithErrors_one": "{locale} · {count} fout",
      "tabWithErrors_other": "{locale} · {count} fouten"
    },
    "elements": {
      "heading": "Kop",
      "intro": "Inleiding",
      "holder": "Naam van de deelnemer",
      "between": "Tussenregel",
      "training": "Training",
      "date_line": "Datum en nummer",
      "issuer": "Uitgever"
    },
    "preview": {
      "title": "Voorbeeld",
      "long": "Lange waarden",
      "loading": "Voorbeeld wordt gemaakt…",
      "updated": "Het voorbeeld is bijgewerkt.",
      "invalid": "Los eerst de fouten in het formulier op.",
      "invalidListed": "Het voorbeeld verschijnt zodra de fouten in de lijst bij het formulier opgelost zijn.",
      "frameTitle": "Voorbeeld: {title}",
      "download": "Voorbeeld downloaden (PDF)",
      "fileName": "voorbeeld",
      "busy": "Er worden nu veel voorbeelden gemaakt. Probeer het zo opnieuw.",
      "concept": "Voorbeeld van het concept",
      "version": "Voorbeeld van versie {version}",
      "notPdf": "Het voorbeeld kwam niet terug als PDF en wordt niet getoond."
    },
    "tags": {
      "title": "Tags invoegen"
    },
    "unpublished": "Niet gepubliceerd",
    "concept": "Concept",
    "version": "Versie {version}",
    "kind": {
      "label": "Soort",
      "general": "Algemeen",
      "classroom": "Klassikaal",
      "learning_path": "Leerlijn",
      "hint": "Ligt vast na het maken. Klassikaal kan de docent, de locatie en de datums noemen (alleen bij een training met uitvoeringen); leerlijn de afgeronde onderdelen (alleen bij een leerlijn).",
      "help": "Klassikaal kan de docent, de locatie en de datums noemen (alleen bij een training met uitvoeringen); leerlijn de afgeronde onderdelen (alleen bij een leerlijn)."
    },
    "orientation": {
      "landscape": "Liggend",
      "portrait": "Staand"
    },
    "adjustTitle": "{name} aanpassen",
    "adjustBody": "Je maakt een eigen kopie, op de versie van nu. Het BCS-sjabloon zelf verandert niet.",
    "adjustConfirm": "Kopie maken",
    "state": {
      "unpublished": "Nog niet gepubliceerd: dit sjabloon is nergens te kiezen.",
      "concept": "Er staat een concept klaar. Certificaten gebruiken de gepubliceerde versie tot je publiceert.",
      "live": "Gepubliceerd. Een nieuwe versie maak je door een concept te publiceren."
    },
    "notice": {
      "saved": "Concept opgeslagen.",
      "published": "Gepubliceerd. Nieuwe certificaten gebruiken deze versie.",
      "discarded": "Concept weggegooid.",
      "renamed": "De naam is opgeslagen.",
      "restored": "Versie {version} staat in het concept. Live verandert pas als je publiceert."
    },
    "failed": {
      "save": "Opslaan is niet gelukt.",
      "publish": "Publiceren is niet gelukt.",
      "upload": "Het logo kon niet geüpload worden."
    },
    "publishBlocked": "Dit kan nog niet gepubliceerd worden:",
    "previewBlocked": "Het voorbeeld kan nog niet gemaakt worden:",
    "saveConcept": "Concept opslaan",
    "publish": "Publiceren",
    "publishTitle": "{name} publiceren?",
    "publishBody": "{usage}. Nieuwe certificaten gebruiken vanaf nu deze versie; uitgegeven certificaten veranderen niet.",
    "discard": "Concept weggooien",
    "discardTitle": "Concept weggooien?",
    "discardBody": "De pagina toont daarna weer de live versie. Dit kun je niet terugdraaien.",
    "update": {
      "noneTitle": "Geen nieuwe versie",
      "noneText": "Er staat voor dit sjabloon geen nieuwe versie klaar.",
      "templates_one": "{count} eigen sjabloon",
      "templates_other": "{count} eigen sjablonen",
      "title": "Nieuwe versie van {name}",
      "intro": "BCS heeft versie {to} gepubliceerd. Tot je die overneemt, blijven nieuwe certificaten op de oude versie.",
      "unchanged": "Uitgegeven certificaten veranderen niet, wat je ook kiest.",
      "failed": {
        "conflict": "Er is intussen een nieuwere versie. De pagina toont nu die.",
        "busy": "Er worden nu veel certificaten gecontroleerd. Probeer het zo opnieuw.",
        "other": "Dat is niet gelukt."
      },
      "old": "Nu: versie {version}",
      "new": "Nieuw: versie {version}",
      "dismiss": "Niet nu",
      "accept": "Overnemen",
      "appliesTo": "Geldt voor {parts}.",
      "partial": "{moved} eigen sjablonen overgenomen, {skipped} niet: die halen op de nieuwe versie de controles niet."
    },
    "logoUpdate": {
      "noneTitle": "Geen nieuw logo",
      "noneText": "Het logo op de certificaten is het logo in de huisstijl.",
      "title": {
        "changed": "Nieuw logo van de omgeving",
        "removed": "Logo van de omgeving verwijderd"
      },
      "intro": {
        "changed": "Het logo in de huisstijl is vervangen. Tot je het overneemt, staat het oude op nieuwe certificaten.",
        "removed": "Het logo in de huisstijl is verwijderd. Certificaten krijgen het oude logo tot je kiest voor geen logo; een ander logo kies je in het sjabloon."
      },
      "appliesTo_one": "Geldt voor {count} sjabloon met het logo van de omgeving.",
      "appliesTo_other": "Geldt voor {count} sjablonen met het logo van de omgeving.",
      "old": "Nu",
      "new": "Nieuw",
      "accept": {
        "changed": "Overnemen",
        "removed": "Geen logo meer"
      }
    },
    "open": "Openen",
    "copy": "Kopiëren",
    "fromBcs": "Van BCS",
    "rename": "Naam opslaan",
    "copyTitle": "{name} kopiëren",
    "copyBody": "Een nieuw sjabloon met dezelfde inhoud. Het is nog niet gepubliceerd; de soort ligt na het maken vast.",
    "copyConfirm": "Kopie maken",
    "originLine": "Kopie van {name}, geleverd door BCS.",
    "editorComing": "De inhoud van een sjabloon bewerk je straks in de nieuwe editor. Tot die er is, kun je hier versies bekijken, terugzetten, publiceren en kopiëren.",
    "history": {
      "title": "Geschiedenis",
      "empty": "Nog geen versies: dit sjabloon is nog nooit gepubliceerd.",
      "caption": "De versies van {name}",
      "version": "Versie",
      "when": "Gepubliceerd",
      "who": "Door",
      "actions": "Acties",
      "live": "Live",
      "bcs": "BCS (versie {version})",
      "unknown": "Onbekend",
      "view": "Bekijken",
      "restore": "Terugzetten",
      "viewing": "Je bekijkt versie {version}.",
      "restoreTitle": "Versie {version} terugzetten?",
      "restoreBody": "Deze versie komt in het concept. Live verandert pas als je het concept publiceert.",
      "restoreOverConcept": "Deze versie vervangt het concept dat er nu staat. Live verandert pas als je publiceert."
    },
    "bcsUpdate": {
      "acceptNotice": "BCS heeft versie {to} van dit sjabloon uitgebracht. Je hebt het niet aangepast, dus je kunt die zo overnemen.",
      "review": "Bekijken en overnemen",
      "fetchNotice": "BCS heeft versie {to} van dit sjabloon uitgebracht. Je hebt het zelf aangepast: met Ophalen komt de nieuwe versie in het concept, en jij bepaalt wat er live gaat.",
      "fetch": "Ophalen",
      "fetchTitle": "Versie {to} van BCS ophalen?",
      "fetchOverConcept": "De nieuwe versie van BCS vervangt het concept dat er nu staat. Live verandert pas als je publiceert.",
      "fetched": "De nieuwe versie van BCS staat in het concept. Live verandert pas als je publiceert.",
      "dismissed": "Het sjabloon blijft zoals het is. Bij een volgende versie van BCS zie je het weer.",
      "conceptFrom": "Het concept bevat versie {version} van BCS.",
      "intro": "BCS heeft versie {to} uitgebracht. Tot je die overneemt, blijven nieuwe certificaten zoals ze nu zijn.",
      "old": "Nu live: versie {version}",
      "new": "Nieuw: versie {version} van BCS"
    },
    "types": {
      "certificate": "Certificaten",
      "agreement": "Overeenkomsten"
    },
    "typeLabel": {
      "agreement": "Overeenkomst"
    },
    "agreementsEmptyTitle": "Nog geen overeenkomsten",
    "agreementsEmptyText": "Een sjabloon voor een overeenkomst begin je door het voorbeeld van BCS te kopiëren.",
    "regenerate": {
      "count_one": "{count} certificaat uitgegeven met deze versie",
      "count_other": "{count} certificaten uitgegeven met deze versie",
      "button": "Opnieuw maken",
      "title": "Certificaten van versie {version} opnieuw maken?",
      "body": "Elk certificaat houdt zijn nummer en krijgt een nieuwe versie met het sjabloon en de gegevens van nu. De oude versie blijft bewaard.",
      "confirm": "Opnieuw maken",
      "fromTo_one": "Van versie {from} naar versie {to}: {count} certificaat.",
      "fromTo_other": "Van versie {from} naar versie {to}: {count} certificaten.",
      "unchanged": "Aan het sjabloon verandert niets: dit is de versie die live staat. Alleen gewijzigde gegevens (zoals een naam) komen erin.",
      "sameFields": "Dezelfde velden; de opmaak of tekst van het sjabloon kan wel anders zijn.",
      "fieldAdded": "Erbij: {field}",
      "fieldRemoved": "Eraf: {field}",
      "reason": "Reden",
      "reasonTooShort": "Minstens {min} tekens.",
      "previewFailed": "Wat er verandert, kon niet worden opgehaald.",
      "failed": "Opnieuw maken is niet gestart.",
      "throttled": "Even te vaak: probeer het over een minuut opnieuw.",
      "nothingQueued": "Er was niets opnieuw te maken: voor deze certificaten staat al iets klaar.",
      "queued_one": "{count} certificaat staat klaar om opnieuw gemaakt te worden.",
      "queued_other": "{count} certificaten staan klaar om opnieuw gemaakt te worden.",
      "progress": "Opnieuw maken, {handled} van {total}: {counts}.",
      "done": "Klaar: {counts}.",
      "counts": {
        "regenerated_one": "{count} opnieuw gemaakt",
        "regenerated_other": "{count} opnieuw gemaakt",
        "unchanged_one": "{count} ongewijzigd",
        "unchanged_other": "{count} ongewijzigd",
        "failed_one": "{count} mislukt",
        "failed_other": "{count} mislukt",
        "skipped_one": "{count} overgeslagen",
        "skipped_other": "{count} overgeslagen"
      },
      "toFailed": "Naar Mislukte certificaten"
    }
  },
  "documentEditor": {
    "title": "Sjabloon bewerken",
    "back": "Terug naar het sjabloon",
    "loadError": "Het sjabloon kon niet geladen worden.",
    "name": "Naam",
    "nameTooLong": "Hooguit {max} tekens.",
    "neverPublished": "Concept, nog niet gepubliceerd",
    "liveVersion": "Live: versie {version}",
    "unsavedShort": "niet opgeslagen wijzigingen",
    "conceptSaved": "concept opgeslagen",
    "saveConcept": "Concept opslaan",
    "publish": "Publiceren",
    "saved": "Het concept is opgeslagen.",
    "published": "Gepubliceerd als versie {version}.",
    "unsaved": "Er zijn wijzigingen die nog niet zijn opgeslagen. Toch weggaan?",
    "busy": "De server is even bezet. Probeer het zo opnieuw.",
    "throttled_one": "Even wachten: er is kort achter elkaar vaak opgeslagen. Over {count} seconde probeert de editor het zelf opnieuw; je kunt gewoon doorwerken.",
    "throttled_other": "Even wachten: er is kort achter elkaar vaak opgeslagen. Over {count} seconden probeert de editor het zelf opnieuw; je kunt gewoon doorwerken.",
    "throttledFailed": "Opslaan lukt nu even niet: er is te vaak achter elkaar opgeslagen. Je wijzigingen staan er nog; probeer het over een minuut opnieuw.",
    "failed": "Dat lukte niet. Probeer het opnieuw.",
    "errorsTitle_one": "Er is {count} punt om op te lossen",
    "errorsTitle_other": "Er zijn {count} punten om op te lossen",
    "publishConfirm": {
      "title": "Dit concept publiceren?",
      "body": "Het concept wordt de nieuwe versie. Nieuwe certificaten gebruiken vanaf nu deze versie; uitgegeven certificaten veranderen niet."
    },
    "locale": {
      "nl": "Nederlands",
      "en": "Engels",
      "de": "Duits",
      "fr": "Frans"
    },
    "page": {
      "landscape": "Pagina, A4 liggend",
      "portrait": "Pagina, A4 staand"
    },
    "flow": {
      "label": "Lopende tekst ({language})",
      "copyOfDutch": "Deze taal heeft nog geen eigen tekst en toont het Nederlands. Zodra je iets wijzigt, krijgt deze taal een eigen tekst.",
      "rejected": "De lopende tekst in deze taal bevat iets dat de editor niet kent, en wordt daarom niet getoond of bewerkt. Bij opslaan zegt de server wat er niet klopt."
    },
    "flowStart": {
      "label": "Begin lopende tekst (mm)",
      "valueText": "{mm} mm onder de bovenmarge",
      "hint": "Onder de bovenmarge, van 0 tot {max}."
    },
    "fields": {
      "heading": "Velden",
      "hint": "Sleep een veld naar de tekst, of klik om het in te voegen waar de cursor staat.",
      "error": "De velden konden niet geladen worden.",
      "empty": "Er zijn geen velden voor deze soort.",
      "kind": {
        "general": "Algemeen",
        "classroom": "Klassikaal",
        "learning_path": "Leerlijn"
      },
      "scope": {
        "org": "Organisatie",
        "context": "Afronding",
        "global": "Algemeen",
        "link": "Links"
      }
    },
    "grid": {
      "group": "Raster",
      "show": "Raster",
      "snap": "Uitlijnen op raster",
      "snapHint": "Slepen en van maat veranderen springen naar de lijnen van 5 mm, en randen en het midden naar de middenlijnen. Alt sleept vrij."
    },
    "history": {
      "group": "Geschiedenis",
      "undo": "Ongedaan maken",
      "redo": "Opnieuw",
      "undoShortcut": "Ongedaan maken (Ctrl+Z)",
      "redoShortcut": "Opnieuw (Ctrl+Y)",
      "undone": "Ongedaan gemaakt: {action}",
      "redone": "Opnieuw gedaan: {action}",
      "kind": {
        "move": "verplaatsen",
        "resize": "maat",
        "add": "blok toevoegen",
        "remove": "blok weghalen",
        "style": "opmaak",
        "text": "tekst",
        "orientation": "richting",
        "reading": "leesvolgorde",
        "flowStart": "begin lopende tekst",
        "background": "achtergrond",
        "title": "documenttitel",
        "image": "beeld",
        "furniture": "kop- en voettekst",
        "numbering": "nummering"
      }
    },
    "toolbar": {
      "label": "Opmaak",
      "blockType": "Soort tekst",
      "paragraph": "Alinea",
      "heading": "Kop {level}",
      "bold": "Vet",
      "italic": "Cursief",
      "underline": "Onderstreept",
      "bulletList": "Opsomming",
      "orderedList": "Genummerde lijst",
      "alignLeft": "Links uitlijnen",
      "alignCenter": "Centreren",
      "alignRight": "Rechts uitlijnen",
      "alignment": "Uitlijning",
      "quick": "Snelle opmaak"
    },
    "table": {
      "insertTitle": "Tabel invoegen",
      "rows": "Rijen",
      "cols": "Kolommen",
      "headerRow": "Kopregel",
      "insert": "Invoegen",
      "toolbar": "Tabel",
      "rowBefore": "Rij erboven",
      "rowAfter": "Rij eronder",
      "colBefore": "Kolom links",
      "colAfter": "Kolom rechts",
      "toggleHeader": "Kopregel aan/uit",
      "deleteRow": "Rij weg",
      "deleteCol": "Kolom weg",
      "delete": "Tabel weg"
    },
    "blocks": {
      "kind": {
        "text": "Tekstblok {n}",
        "image": "Afbeelding {n}",
        "rect": "Rechthoek {n}",
        "line": "Lijn {n}"
      },
      "textLabel": "{block}, tekst ({language})",
      "movedTo": "{block}: {x} mm van links, {y} mm van boven.",
      "frameHint": "Pijltjes verschuiven het blok 1 mm, Shift+pijltje 10 mm. Delete haalt het weg. Tab gaat naar de tekst om die te bewerken.",
      "image": {
        "bcs-logo": "BCS-logo",
        "tenant-logo": "Logo van de omgeving",
        "upload": "Eigen afbeelding",
        "library": "Uit de mediabibliotheek",
        "platform": "Uit de meegeleverde set"
      },
      "removed": "Het blok is weggehaald.",
      "addLabel": "Toevoegen",
      "add_text": "Tekstblok",
      "add_image": "Afbeelding",
      "add_rect": "Rechthoek",
      "add_line": "Lijn",
      "add_table": "Tabel",
      "describe": {
        "text": "Een vak met tekst dat je vrij op de pagina plaatst, zoals de titel of de naam. Je kunt er velden in slepen.",
        "image": "Een logo, handtekening of andere afbeelding uit de mediabibliotheek, vrij op de pagina.",
        "rect": "Een rechthoek, bijvoorbeeld als kader rond de pagina. Alleen ter versiering.",
        "line": "Een lijn, bijvoorbeeld om op te tekenen of als scheiding. Alleen ter versiering.",
        "table": "Een tabel in de lopende tekst, op de plek van de cursor, bijvoorbeeld voor een rij handtekeningen.",
        "pageBreak": "Wat na de cursor komt, begint op een nieuwe pagina.",
        "ref": "Een verwijzing naar een genummerde kop; het nummer schuift mee."
      },
      "rejected": "Deze tekst bevat iets dat de editor niet kent.",
      "add_pageBreak": "Paginabreuk",
      "add_ref": "Verwijzing",
      "skipped_one": "{count} blok kan niet worden getoond (het is beschadigd opgeslagen) en is weggelaten. Bij opslaan valt het weg.",
      "skipped_other": "{count} blokken kunnen niet worden getoond (ze zijn beschadigd opgeslagen) en zijn weggelaten. Bij opslaan vallen ze weg."
    },
    "inspector": {
      "remove": "Weghalen",
      "position": "Plaats en maat",
      "x": "Van links (mm)",
      "y": "Van boven (mm)",
      "width": "Breedte (mm)",
      "height": "Hoogte (mm)",
      "textStyle": "Tekst",
      "role": "Soort",
      "size": "Grootte (pt)",
      "weight": "Gewicht",
      "regular": "Normaal",
      "align": "Uitlijning",
      "color": "Kleur",
      "colorFormat": "Een kleur als #RRGGBB.",
      "image": "Afbeelding",
      "source": "Bron",
      "layer": "Laag",
      "layerOnlyDecorative": "Alleen een decoratief beeld kan achter de tekst.",
      "front": "Voor de tekst",
      "back": "Achter de tekst",
      "decorative": "Decoratief (een schermlezer slaat het over)",
      "alt": "Alt-tekst ({language})",
      "shape": "Vorm",
      "direction": "Richting",
      "horizontal": "Horizontaal",
      "vertical": "Verticaal",
      "stroke": "Lijndikte (mm)",
      "strokeColor": "Lijnkleur",
      "fill": "Vulling",
      "fillColor": "Vulkleur",
      "problems": "Bij dit blok",
      "noneHeading": "Geen blok geselecteerd",
      "none": "Kies een blok op de pagina of in de leesvolgorde om de plaats, maat en stijl te zien.",
      "pickImage": "Kies uit de mediabibliotheek…",
      "valign": "Verticaal",
      "valign_top": "Boven uitlijnen",
      "valign_middle": "In het midden uitlijnen",
      "valign_bottom": "Onder uitlijnen"
    },
    "reading": {
      "hint": "In deze volgorde leest een schermlezer de pagina.",
      "flow": "Lopende tekst",
      "up": "{name} omhoog",
      "down": "{name} omlaag",
      "reset": "Standaardvolgorde",
      "toggle": "Leesvolgorde ({count})",
      "moved": "{name} staat nu op plaats {position} van {count}."
    },
    "checks": {
      "heading": "Controles",
      "none": "Geen problemen gevonden. Het voorbeeld controleert de rest.",
      "severity": {
        "error": "Fout",
        "warning": "Let op"
      },
      "outside_margin": "Staat buiten de marge van {margin} mm.",
      "text_too_small": "De tekst is kleiner dan {min} pt.",
      "text_small": "De tekst is kleiner dan {warn} pt en daardoor slecht leesbaar.",
      "overlap": "Overlapt met {other}.",
      "low_contrast": "De tekstkleur heeft te weinig contrast op wit ({ratio}:1, minimaal 4,5:1).",
      "heading_first": "De eerste kop moet kop 1 zijn, niet kop {level}.",
      "heading_skip": "Kop {level} slaat een niveau over; verwacht kop {expected}.",
      "alt_missing": "Er is geen alt-tekst in het Nederlands.",
      "background_readability": "Controleer in het voorbeeld of alle tekst goed leesbaar is op de achtergrond.",
      "server": "Bij het laatste opslaan",
      "ref_missing": "Een verwijzing wijst naar een kop die er niet is of niet genummerd is.",
      "image_low_resolution": "Dit beeld is te klein voor deze maat: {dpi} dpi op papier, minimaal {min}. Gebruik een beeld van minstens {min_width} × {min_height} pixels.",
      "many_pages": "Het voorbeeld heeft {pages} pagina's; meer dan 20 is lang voor een overeenkomst."
    },
    "background": {
      "label": "Achtergrond",
      "placeholder": "Achtergrond",
      "none": "Geen achtergrond.",
      "current": "Nu: {source}.",
      "pick": "Kies uit de mediabibliotheek…",
      "remove": "Geen achtergrond"
    },
    "preview": {
      "heading": "Voorbeeld",
      "long": "Lange naam",
      "loading": "Het voorbeeld wordt gemaakt…",
      "updated": "Het voorbeeld is bijgewerkt.",
      "updatedLong": "Het voorbeeld is bijgewerkt, met een lange naam.",
      "failedStatus": "Het voorbeeld kon niet worden gemaakt.",
      "invalid": "Het voorbeeld wacht op de punten in de lijst bovenaan.",
      "failed": "Het voorbeeld kon niet worden gemaakt.",
      "frameTitle": "Voorbeeld van {title} ({language})",
      "download": "Voorbeeld downloaden (PDF)",
      "fileName": "voorbeeld",
      "notPdf": "Het voorbeeld kwam niet terug als PDF en wordt niet getoond."
    },
    "pdfTitle": {
      "label": "Documenttitel ({language})",
      "hint": "Staat in de eigenschappen van de PDF; een schermlezer leest hem voor."
    },
    "edit": "Bewerken",
    "orientation": {
      "label": "Richting",
      "landscape": "Liggend",
      "portrait": "Staand",
      "moved": "Controleer de blokken; ze zijn verplaatst.",
      "undo": "Ongedaan maken (Ctrl+Z) zet het terug. Het verandert alleen het concept."
    },
    "text": {
      "heading": "Tekst"
    },
    "pages": {
      "estimate": "{count} pagina('s). De paginagrenzen zijn een schatting; het voorbeeld eronder is de echte.",
      "real": "Het voorbeeld heeft er {count}."
    },
    "furniture": {
      "heading": "Kop- en voettekst",
      "header": "Kopregel",
      "footer": "Voetregel",
      "logo": "Logo",
      "logoNone": "Geen logo",
      "logoPosition": "Plaats van het logo",
      "logoHeight": "Maximale hoogte (mm)",
      "logoHeightRange": "Tussen {min} en {max} mm.",
      "headerText": "Tekst in de kopregel ({language})",
      "footerText": "Tekst in de voetregel ({language})",
      "firstPageDifferent": "Eerste pagina anders (de kopregel begint op pagina 2)",
      "pageNumbers": "Pagina x van y staat er altijd naast.",
      "pageOf": "Pagina {page} van {pages}",
      "position": {
        "left": "Links",
        "center": "Midden",
        "right": "Rechts"
      }
    },
    "pageBreaks": {
      "legend": "Pagina",
      "breakBefore": "Begin op een nieuwe pagina",
      "keepTogether": "Houd bij elkaar",
      "node": "Paginabreuk",
      "nested": "Kan niet in een lijst of tabel; alleen bij een blok van de lopende tekst zelf."
    },
    "numbering": {
      "heading": "Nummering",
      "style": "Stijl van de genummerde koppen",
      "none": "Geen nummering",
      "artikel": "Artikel 1, Artikel 1.1",
      "decimal": "1., 1.1",
      "hint": "Welke koppen meetellen, zet je per kop met Genummerd in het paneel Tekst.",
      "article": "Artikel",
      "articleInText": "artikel",
      "numbered": "Genummerd",
      "refTitle": "Verwijzen naar",
      "refNone": "Er is nog geen genummerde kop. Kies een nummering en zet Genummerd aan bij een kop."
    }
  }
}
